
    const resources = {
    "AboutUs": {
        "AboutUsPageTitle": "关于我们",
        "BeginningSectionHeader": "起源",
        "BeginningSectionParagraph": "Gamefound 由 Awaken Realms 的 CEO Marcin Świerkot 和 Gamefound 的 CTO Szymon Matyjaszek 于 2016 年创立。最初，它作为 pledge manager 为某些创作者开发，他们意识到成功的众筹活动需要专门的履约工具。Awaken Realms 是首个使用这一新系统的公司，不久之后，其他创作者也加入进来，推动了 Gamefound 作为独立平台的发展。",
        "CommunitySectionHeader": "社区",
        "CommunitySectionParagraph": "Gamefound 旨在加速游戏界的伟大项目，我们的用户是桌面游戏的粉丝。我们是这个社区的一部分，这就是为什么我们了解创作者和支持者的需求。简单来说，我们所做的一切都是基于自身的经验。",
        "ContactForBackerLink": "支持者联系",
        "ContactForBackerParagraph": "如果你是<a href='#'><strong>支持者</strong></a>，需要联系我们或某个创作者。",
        "ContactForBusinessLink": "商务联系",
        "ContactForBusinessParagraph": "如果你有任何<a href='#'><strong>与业务相关</strong></a>的话题需要讨论。",
        "ContactForCreatorLink": "创作者联系",
        "ContactForCreatorParagraph": "如果你是<a href='#'><strong>创作者</strong></a>并且想在 Gamefound 上运行你的活动。",
        "ContactForMarketingLink": "推广联系",
        "ContactForMarketingParagraph": "如果你想使用我们的<a href='#'><strong>营销服务</strong></a>。",
        "ContactForMediaLink": "媒体联系",
        "ContactForMediaParagraph": "如果你来自<a href='#'><strong>媒体</strong></a>或是一名影响者。",
        "ContactForRecruitmentLink": "招聘联系",
        "ContactForRecruitmentParagraph": "如果你想加入我们的团队并在<a href='#'><strong>Gamefound 工作</strong></a>。",
        "ContactInformationParagraph": "请致电{0}与我们联系。通话费用根据运营商的资费或价格表。",
        "EvolutionSectionHeader": "发展",
        "EvolutionSectionParagraph": "多年来，这个平台不断发展，定期添加新功能和改进。这种发展随着时间的推移加速。2019 年 3 月，我们庆祝达到了 10 万个支持者。恰好一年后的 2020 年 3 月 5 日，第 100 位创作者在我们的平台上启动了项目。2020 年 12 月 17 日，Gamefound 主办了其首个全面众筹项目 ISS Vanguard，标志着一个重要的里程碑。这个项目取得了巨大成功，为随后数百个卓越项目奠定了基础。",
        "GeneralProductSafetyRegulationContactParagraph": "关于《一般产品安全条例》监管机构联系点：{0}。",
        "HistorySectionHeader": "历史",
        "HumanTouchSectionHeader": "人性化触感",
        "HumanTouchSectionParagraph": "在Gamefound，我们优先考虑您的信任和舒适。如果我们的帮助中心未能解答您的问题，或您希望讨论或分享反馈，我们随时准备好迅速响应提供帮助。在所有项目中，都有专门的客户经理可直接联系，确保提供个性化支持。",
        "LegalSectionCaption": "了解有关我们平台上支付处理的更多信息，请点击{0}。",
        "LegalSectionDocsParagraph": "您可以在此处找到我们平台的{0}和{1}。",
        "LegalSectionHeader": "法律",
        "LegalSectionLink": "此处",
        "LegalSectionParagraph": "Gamefound是一家根据波兰法律注册成立的有限责任公司，位于欧盟。我们是一个全球性的众筹平台，接受来自数十个国家的创作者和来自几乎世界各地的支持。<br/><br/>Gamefound的名称和标志作为注册商标受法律保护，未经明确同意，禁止任何形式的使用。<br/><br/>Gamefound完全符合欧盟的规定。我们与Adyen合作，作为Gamefound的支付提供商，完全符合业界关键安全标准的最新PCI DSS标准，确保平台内支付处理的顺畅和安全。",
        "LegalSectionPrivacyPolicyLink": "隐私政策",
        "LegalSectionTermsOfServiceLink": "服务条款",
        "PartnersSectionButtonText": "成为创作者",
        "PartnersSectionHeader": "合作伙伴",
        "PartnersSectionSubheader": "他们信任我们：",
        "PlatformInNumbersSectionHeader": "Gamefound数据",
        "ReachOutSectionHeader": "联系我们",
        "ReliabilitySectionHeader": "可靠性",
        "ReliabilitySectionParagraph": "我们深知为您提供一个可以信赖的平台，让您的项目顺利进行是多么重要。作为创作者，您希望在期待已久的活动上线时一切顺利。而这得益于Gamefound背后的先进技术和一支负责其效率和可靠性的优秀团队。",
        "SafetyAndSecuritySectionHeader": "安全与保障",
        "Slogan": "创造力的未来",
        "StatisticBackersCountHeader": "Backer|Backers",
        "StatisticCreatorsCountHeader": "Creator|Creators",
        "StatisticProjectsCountHeader": "Project|Projects",
        "StatisticValueOfPledgesCounterHeader": "Pledges的总值",
        "StatisticValueOfPledgesTooltipText": "总金额以月平均汇率计算的欧元值。",
        "TeamSectionAdditionalParagraph": "我们的团队由50多位才华横溢的专家组成，其中一半致力于提升我们的技术。",
        "TeamSectionButtonText": "加入我们！",
        "TeamSectionHeader": "团队",
        "TodaySectionHeader": "今天",
        "TodaySectionParagraph": "我们已经超越了一百万支持者的里程碑，并举办了来自数百创作者的项目。Gamefound每年都经历指数级的增长，吸引新的创作者和支持者。今天，Gamefound是一个综合性平台，创作者可以在这里管理其活动，从最初的公告和获取第一个跟随者，到履行最终订单，甚至管理剩余库存的长期销售。Gamefound的主要股东是首席执行官Marcin Świerkot和Ravensburger后者于2022年2月成为战略投资者。",
        "VideoSectionParagraph": "Gamefound致力于让游戏创作更快速和简单。我们是一个将支持者和游戏开发者聚集在一起的平台，不仅仅是桌游，还有各种游戏项目。在这里，创作者可以专注于他们最擅长的事情，而支持者则可以轻松找到并支持他们喜爱的游戏。我们提供一系列服务，包括众筹、任何活动的pledge管理、以及营销支持，全部在一个无忧的地方完成。"
    },
    "Account": {
        "AccountCreatedActivationLinkInstructionParagraph": "<strong>请检查你的电子邮箱，并按照我们消息中的说明操作。</strong>",
        "AccountCreatedActivationLinkSentParagraph": "我们已向你发送了一封包含个人激活链接的邮件。",
        "AccountCreatedHeader": "你的账户快准备好了！",
        "AuthenticatePageHeader": "登录或注册",
        "BackToHomePageButton": "返回主页",
        "CompleteAccountEmailAlreadyInUse": "该邮箱已被使用。",
        "CompleteAccountEmailFieldLabel": "你的电子邮箱地址",
        "CompleteAccountFullNameFieldLabel": "你的全名",
        "CompleteAccountHeader": "你好！",
        "CompleteAccountIntroParagraph": "开始之前还有一些步骤。",
        "CompleteAccountInvalidActivationKey": "无效的激活码",
        "CompleteAccountNewsletterConsentLabel": "订阅Gamefound的新闻通讯 {0}",
        "CompleteAccountNewsletterTooltipText": "接收有关Gamefound有趣项目的更新。我们每月发送一次这些消息。",
        "CompleteAccountNicknameFieldLabel": "昵称",
        "CompleteAccountPageTitle": "创建账户",
        "CompleteAccountPasswordFieldLabel": "你的新账户密码",
        "CompleteAccountPasswordValidationMessage": "你的密码必须包含至少六个字母、数字和标点符号（如!和&）。",
        "CompleteAccountPrivacyPolicyLink": "隐私政策",
        "CompleteAccountTermsConsentLabel": "我接受 {0} 和 {1}。",
        "CompleteAccountTermsOfServiceFieldName": "服务条款",
        "CompleteAccountTosLink": "Gamefound服务条款",
        "ContinueActionButton": "继续",
        "ContinueAsGuestBenefitListItem1": "关注并支持您喜欢的项目。",
        "ContinueAsGuestBenefitListItem2": "使用保存的支付方式更轻松地支付认筹款。",
        "ContinueAsGuestBenefitListItem3": "更自由地编辑和管理多个项目的认筹。",
        "ContinueAsGuestBenefitListItem4": "在一个地方查看所有关注和支持项目的更新。",
        "ContinueAsGuestBenefitListItem5": "参与项目并帮助塑造它们。",
        "ContinueAsGuestBenefitListItem6": "获得更准确的项目推荐。",
        "ContinueAsGuestBenefitListItem7": "管理您的隐私设置。",
        "ContinueAsGuestBenefitListItem8": "创建和管理您自己的项目。",
        "ContinueAsGuestBenefitMoreLabel": "以及更多...",
        "ContinueAsGuestBenefitsListHeader": "如果您的电子邮件未绑定账户，后续您可以创建一个账户并享受以下福利：",
        "ContinueAsGuestButtonLabel": "继续无帐号",
        "ContinueAsGuestDescription": "您可以使用电子邮件作为访客继续。您仍将通过电子邮件收到所有重要更新，并且您可以稍后创建一个帐号以在一个地方管理所有的{0}活动，但访客支持无资格获取追随者礼物或折扣。",
        "ContinueAsGuestHeader": "继续作为访客",
        "ContinueBrowsingActionButton": "继续浏览",
        "ContinueWithAnAccountHeader": "使用账户继续",
        "CreateCreatorAccountHeader": "成为创作者",
        "CreateCreatorAccountLoginOptionParagraph": "我已经有一个Gamefound账户。",
        "CreateCreatorAccountSingUpOptionParagraph": "我还没有Gamefound账户。",
        "CreateCreatorAccountStepOneParagraph1": "你的创作者资料将链接到以下Gamefound账户：{0}",
        "CreateCreatorAccountStepOneParagraph2": "为了成为Gamefound创作者，你需要先拥有一个Gamefound账户。",
        "CreateCreatorAccountStepOneText": "1. 登录 / 注册",
        "CreateCreatorAccountStepTwoParagraph": "选择你在Gamefound用户面前展示的创作者资料名称。",
        "CreateCreatorAccountStepTwoText": "2. 选择你的创作者资料名称",
        "CreateCreatorAccountSubheader": "完成以下步骤以成为Gamefound创作者并启动你的第一个项目。",
        "EmailFieldLabel": "电子邮箱",
        "ExternalLoginProviderChoiceButton": "用{0}登录",
        "ExternalSignInFacebookPermissionDeniedErrorMessage": "要用Facebook登录，你需要允许共享你的电子邮箱地址。",
        "ExternalSignInGooglePermissionDeniedErrorMessage": "要用Google登录，你需要允许共享你的电子邮箱地址。",
        "FollowProjectAsGuestModalActionButton": "以游客身份关注",
        "FollowProjectAsGuestModalDescription": "还没有准备好注册？没关系。留下你的电子邮箱，当项目启动和进入下一步时，我们会通知你。",
        "FollowProjectAsGuestModalHeader": "以游客身份继续",
        "FollowProjectAsGuestSuccessModalDescription": "我们已将确认链接发送至你提供的电子邮箱地址。请点击邮件中的链接以验证你是该邮箱的拥有者。",
        "FollowProjectAsGuestSuccessModalHeader": "确认你的电子邮箱",
        "FollowProjectWithAnAccountModalActionButton": "以账户身份继续",
        "FollowProjectWithAnAccountModalDescription": "登录以解锁完整体验。你将能够关注和支持项目，管理你的认捐，参与更新和投票，并在整个过程中保持完全连接。",
        "FollowProjectWithAnAccountModalHeader": "以账户身份继续",
        "ForgotPasswordLink": "忘记密码？",
        "InvalidEmailSecurityCode": "这不是正确的代码。请确保你使用的是最新发送到你邮箱里的代码。",
        "InvalidInvitationLinkHeader": "无效的邀请链接",
        "InvalidInvitationLinkParagraph": "此邀请链接已失效。它要么无效，要么已经被使用。",
        "InvalidPasswordError": "无效的电子邮箱或密码。",
        "LogInButton": "登录",
        "LogInCallToActionIntroParagraph": "已有账户？",
        "LogInHeader": "欢迎回来！",
        "LogInLink": "已有账户？登录。",
        "LoginModalCommentText": "要发表评论，你需要先登录。",
        "LoginModalFollowText": "要关注项目，你需要先登录。",
        "LoginModalSuccessToastDescriptionMessage": "你可以在通讯偏好中调整通知设置。",
        "LoginModalSuccessToastTitle": "你现在关注了{0}。",
        "LogInModalTitle": "请登录",
        "LogInOption": "我是回访用户，我想登录。",
        "LogInPageTitle": "登录",
        "LoginToPlatformBenefitsListHeader": "登录Gamefound可：",
        "LoginViewImageAltText": "一个冷静冥想的人盘腿而坐，周围有游戏图标（骰子、对话泡泡、药水、盾牌、剑、云、心型和一个立方体）。",
        "PasswordFieldLabel": "密码",
        "PlatformAccountBenefitsListItem1": "关注并支持你喜欢的项目",
        "PlatformAccountBenefitsListItem2": "轻松支付你的认捐",
        "PlatformAccountBenefitsListItem3": "参与项目的各个阶段",
        "PlatformAccountBenefitsListItem4": "创建你自己的项目",
        "PlatformLoginFormChoiceHeader": "或用你的Gamefound账户登录。",
        "PlatformSignUpFormChoiceHeader": "或用简单两步创建Gamefound账户。",
        "ReCaptchaInvalidTokenErrorMessage": "无效的reCaptcha令牌",
        "ReCaptchaLoginVerificationFailedErrorMessage": "我们注意到一些异常活动。你不能登录。",
        "ReCaptchaMissingTokenErrorMessage": "缺少reCaptcha令牌",
        "ReCaptchaSignupVerificationFailedErrorMessage": "我们注意到一些异常活动。你不能注册。",
        "SecurityCodeFieldLabel": "安全代码",
        "SignUpButton": "注册",
        "SignUpCallToActionButton": "注册",
        "SignUpCallToActionIntroParagraph": "还没有账户？",
        "SignUpConsequenceIntroParagraph": "完成此表单即表示你同意我们的{0}。",
        "SignUpConsequencePrivacyPolicyLink": "隐私政策",
        "SignUpHeader": "注册",
        "SignUpLink": "还没有账户？注册。",
        "SignUpOption": "我是新用户，我想创建一个账户。",
        "SignUpPageTitle": "注册",
        "SignUpToPlatformBenefitsListHeader": "在Gamefound上设置账户以：",
        "TwoFactorAuthenticationEmailSecurityCodeLeadParagraph": "我们已经发送了一个安全代码到你的邮箱，以确保是你本人。请在下方输入该代码以登录：",
        "TwoFactorAuthenticationEmailSecurityCodeResendParagraphPart1": "没有收到你的代码？没关系，你可以{0}。",
        "TwoFactorAuthenticationEmailSecurityCodeResendParagraphPart2": "重新发送代码",
        "TwoFactorAuthenticationEmailSecurityCodeResentNoitificationMessage": "安全代码已重新发送。",
        "TwoFactorLoginStepCancelParagraphPart1": "想要重新开始？{0}。",
        "TwoFactorLoginStepCancelParagraphPart2": "返回登录",
        "WaitUntilResendSecurityCode": "请至少等待1分钟再重新发送代码。"
    },
    "AccountSettings": {
        "AccountDetailsSectionTitle": "账户详情",
        "AccountSettingsPageTitle": "账户设置",
        "ApiEmailMustBeNewError": "新邮箱必须确实是新的。",
        "ApiEmailNotAvailableError": "新邮箱已被占用。",
        "ApiEmailSendingFailedError": "发送电子邮件通知时出错。",
        "ApiIncorrectPasswordError": "密码不正确。",
        "ApiInvalidProjectIDError": "无效的项目ID。",
        "ApiInvalidSocialURLError": "无效的 {0} URL。",
        "ApiInvalidUserIDError": "无效的用户ID。",
        "ApiNewPasswordMustBeNewError": "新密码必须确实是新的。",
        "ApiNewPasswordRequiredError": "新密码不能为空。",
        "ApiNicknameNotAvailableError": "昵称不可用。",
        "ApiOldPasswordIncorrectError": "旧密码不正确。",
        "ApiOldPasswordRequiredError": "旧密码不能为空。",
        "ApiPasswordRequiredError": "密码不能为空。",
        "ApiUnauthorizedError": "您无权执行此操作。",
        "AvatarChangedSuccessToast": "头像已更改。",
        "AvatarFieldLabel": "用户头像",
        "AvatarManagerModalAvatarGeneratorTabName": "头像生成器",
        "AvatarManagerModalCustomImageTabName": "自定义图片",
        "AvatarManagerModalHeader": "管理头像",
        "AvatarManagerModalRandomizeAvatarLabel": "随机更换头像",
        "AvatarUploadedSuccessToast": "您的头像已上传。",
        "BioFieldDescription": "写几句话介绍自己。此描述对查看您个人资料的所有用户可见。描述不能超过255个字符。",
        "BioFieldLabel": "简介",
        "ChangeEmailCurrentEmailFieldLabel": "您的当前邮箱地址",
        "ChangeEmailFailedEmailTakenText": "无法完成密码重置请求。该邮箱已被占用。",
        "ChangeEmailFailedInvalidLinkText": "无法完成邮箱更改请求。链接无效或已过期。",
        "ChangeEmailFailedSystemErrorText": "由于系统错误，无法激活账户。请再试一次。",
        "ChangeEmailFailedTitle": "邮箱更改",
        "ChangeEmailGoogleFbWarningText": "如果您使用Google或Facebook账户创建或登录此账户，修改邮箱将使您无法再使用之前的Google或Facebook账户登录。",
        "ChangeEmailInfoText": "填写此表单以更新您的邮箱地址。我们将发送一条包含确认链接的消息以完成该过程。",
        "ChangeEmailNewEmailFieldLabel": "新邮箱地址",
        "ChangeEmailPasswordFieldLabel": "密码",
        "ChangeEmailPasswordInfoText": "出于安全原因，我们需要再次确认您的当前密码。",
        "ChangeEmailPendingChangeInfoText": "我们已向您发送了一封电子邮件，内含确认新邮箱 ({0}) 的说明。",
        "ChangeEmailRevertButton": "撤销",
        "ChangeEmailSuccessAccountSettingsLink": "我的账户设置",
        "ChangeEmailSuccessHomeLink": "返回首页",
        "ChangeEmailSuccessText": "您现在可以使用新邮箱登录。",
        "ChangeEmailSuccessTitle": "您的邮箱已更改。",
        "ChangeEmailTitle": "更改邮箱地址",
        "ChangePasswordCharacterRequirementError": "您的密码必须至少包含六个字母、数字和标点符号（如！和&）。",
        "ChangePasswordConfirmNewPasswordFieldLabel": "重复新密码",
        "ChangePasswordCurrentPasswordFieldLabel": "当前密码",
        "ChangePasswordCurrentPasswordText": "出于安全原因，我们需要再次确认您的当前密码。",
        "ChangePasswordInfoText": "填写此表单以更新您的密码。",
        "ChangePasswordNewPasswordFieldLabel": "新密码",
        "ChangePasswordPasswordsDontMatchError": "密码不匹配。",
        "ChangePasswordTitle": "更改密码",
        "ChangesSavedSuccessToast": "您的更改已保存。",
        "DeleteAccountConfirmationInfo": "此操作将删除您的所有账户数据。如果您有任何未完成的订单，我们将继续处理，但您将无法通过此账户管理它们。",
        "DeleteAccountConfirmationTitle": "删除账户",
        "DeleteAccountConfirmButton": "删除账户",
        "DeleteAccountLink": "这里",
        "DeleteAccountPasswordFieldLabel": "您的账户密码",
        "DeleteAccountPasswordInfo": "您需要重新输入账户密码以继续。",
        "DeleteAccountSectionText": "如果您希望删除Gamefound账户，请按照程序进行",
        "DeleteAccountSectionTitle": "删除账户",
        "DeleteCreditCardButton": "删除",
        "DeleteCreditCardConfirmationText": "您即将删除保存的银行卡信息。如果删除，以后每次付款时您都需要重新输入银行卡信息。确定要删除吗？",
        "DeleteCreditCardConfirmationTitle": "删除银行卡",
        "DeleteCreditCardSuccessToast": "已成功删除银行卡。",
        "EmailChangedSuccessToast": "我们已向您发送了一封电子邮件，内含确认新邮箱地址的说明。",
        "EmailFieldLabel": "邮箱",
        "EmailFieldPlaceholder": "example@example.com",
        "FacebookFieldDescription": "您的Facebook账户地址。",
        "FacebookFieldLabel": "Facebook",
        "FacebookFieldPlaceholder": "https://www.facebook.com/profile",
        "FullNameFieldDescription": "这是我们称呼您的方式。",
        "FullNameFieldLabel": "全名",
        "FullNameFieldPlaceholder": "名字 姓氏",
        "InstagramFieldDescription": "您的Instagram账户地址。",
        "InstagramFieldLabel": "Instagram",
        "InstagramFieldPlaceholder": "https://www.instagram.com/profile",
        "IsPublicFieldLabel": "此个人资料是公开的",
        "IsPublicFieldOffLabel": "此个人资料是私密的。",
        "IsPublicFieldOnLabel": "此个人资料是公开的。",
        "NicknameFieldDescription": "其他人在Gamefound上（如评论、评价）看到的您的名称。",
        "NicknameFieldLabel": "昵称",
        "NicknameFieldPlaceholder": "昵称",
        "NoSavedCreditCardsInfoText": "您还没有保存任何银行卡信息。",
        "PasswordChangedSuccessToast": "您的密码已更改。",
        "PasswordFieldLabel": "密码",
        "ProfileCustomizationSectionTitle": "个人资料定制",
        "SavedCreditCardInfoText": "您的银行卡信息由Adyen安全存储。Gamefound仅保存卡类型和卡号的最后四位数字。保存银行卡信息可以快速完成支付，您无需每次付款时都重新输入卡信息。",
        "SavedCreditCardsSectionTitle": "保存的卡片",
        "TwitterFieldDescription": "您的Twitter账户地址。",
        "TwitterFieldLabel": "Twitter",
        "TwitterFieldPlaceholder": "https://www.twitter.com/profile",
        "ValidationInvalidSocialLink": "此链接无效。",
        "YoutubeFieldDescription": "您的Youtube账户地址。",
        "YoutubeFieldLabel": "Youtube",
        "YoutubeFieldPlaceholder": "https://www.youtube.com/@channel"
    },
    "Admin": {
        "CanPostCommentsAsStaffQuirk": "可以以Gamefound员工的身份发布评论",
        "CanSkipTwoFactorAuthenticationQuirk": "可以跳过两因素认证",
        "CompletingDeferredPaymentFailed": "系统无法完成延期付款",
        "ExportFormatPlatform": "Gamefound 格式",
        "MerchantAccountStatusAdyenFailed": "Adyen - 失败",
        "MerchantAccountStatusAdyenPassed": "Adyen - 通过",
        "MerchantAccountStatusAdyenReview": "Adyen审核中",
        "MerchantAccountStatusAdyenReviewNeeded": "Adyen - 需要审核",
        "MerchantAccountStatusEditing": "准备中",
        "MerchantAccountStatusFailed": "已拒绝",
        "MerchantAccountStatusGamefoundReview": "等待审核",
        "MerchantAccountStatusGamefoundReviewNeeded": "Gamefound - 需要审核",
        "MerchantAccountStatusVerified": "已验证",
        "NotificationTopicAll": "全部",
        "NotificationTopicBlog": "Gamefound 博客",
        "NotificationTopicCommentReply": "评论回复",
        "NotificationTopicCreatorDigest": "创作者摘要",
        "NotificationTopicCreditBalanceChange": "信用余额变更",
        "NotificationTopicCreditExpirationReminders": "信用到期提醒",
        "NotificationTopicFeast": "Gamefound 盛宴",
        "NotificationTopicNewProjectByCreator": "创作者新项目",
        "NotificationTopicNewsletter": "通讯",
        "NotificationTopicPerformanceMarketingDailyReport": "Adfound每日报告",
        "NotificationTopicPerformanceMarketingRecommendation": "Adfound推荐",
        "NotificationTopicPerformanceMarketingSystemMessage": "Adfound系统消息",
        "NotificationTopicPledgeManagerReminder": "Pledge Manager提醒",
        "NotificationTopicProjectMilestones": "项目里程碑",
        "NotificationTopicProjectUpdates": "项目更新",
        "NotificationTopicSystemMessages": "系统消息",
        "NotificationTopicUserDigest": "摘要频率",
        "PollTargetAudienceBackers": "Backers",
        "PollTargetAudienceUsers": "Gamefound用户",
        "ProjectOnboardingGamefoundKyc": "Gamefound KYC",
        "ProjectOnboardingModeLAdyenHopV2": "Adyen HOP 2.0",
        "ProjectOnboardingModeLegacy": "传统入驻",
        "ProjectOnboardingModeNone": "无",
        "ProjectOnboardingModeStripeHop": "Stripe HOP",
        "RegisteredVatPayerInLocationWithNoVatReverseEnabledErrorMessage": "无法在没有启用反向增值税设置的地点切换“注册增值税纳税人”滑块。",
        "TermsDocumentScopeAdfoundTermsOfService": "Adfound服务条款",
        "TermsDocumentScopeBackersTermsOfService": "Backers服务条款",
        "TermsDocumentScopeCommunityGuidelines": "Gamefound社区指南",
        "TermsDocumentScopeContentPolicy": "Gamefound内容政策",
        "TermsDocumentScopeCreatorsCrowdfundingTermsOfService": "创作者众筹服务条款",
        "TermsDocumentScopeCreatorsDataProcessingAgreement": "创作者数据处理协议",
        "TermsDocumentScopeCreatorsDigitalContentTermsOfService": "创作者数字内容服务条款",
        "TermsDocumentScopeCreatorsTermsOfService": "创作者服务条款",
        "TermsDocumentScopeCrowdfundingTermsOfService": "众筹服务条款",
        "TermsDocumentScopeIntellectualPropertyPolicy": "知识产权政策",
        "TermsDocumentScopePrivacyPolicy": "隐私政策",
        "TermsDocumentScopeReservedFundsPolicy": "预留资金政策",
        "TermsDocumentScopeStoresTermsOfService": "商店服务条款",
        "TermsDocumentScopeTermsOfService": "服务条款",
        "TermsDocumentScopeTrademarkPolicy": "商标政策"
    },
    "BackerCenter": {
        "ActionRequiredFilterLabel": "需要操作",
        "ArchivedProjectsFilterLabel": "已归档项目",
        "ArchiveProjectArchiveStatusLabel": "移至归档",
        "FailedPaymentsOnlyLabel": "仅显示失败的付款",
        "HideOrderDetailsLabel": "隐藏订单详情",
        "HidePledgeDetailsLabel": "隐藏支持详情",
        "IncludeArchivedProjectsLabel": "包含已归档项目",
        "InstallmentsFilterLabel": "Stretch Pay",
        "InstallmentXOfYLabel": "{0} / {1} 分期付款",
        "NotificationClaimYourGiftActionButton": "领取礼物",
        "NotificationClaimYourGiftActionLabel": "您可以支持此项目并领取跟随活动的礼物。",
        "NotificationCompletePaymentActionButton": "完成付款",
        "NotificationCompletePaymentActionLabel": "您还未完成此支持的付款。",
        "NotificationCompletePledgeActionLabel": "需要您的送货地址来完成支持。",
        "NotificationCompleteYourPledgeActionButton": "完成您的支持",
        "NotificationMissingPaymentInfoActionButton": "更新支付信息",
        "NotificationMissingPaymentInfoActionLabel": "您的支持需要关注。请更新您的支付资料以确保分期付款顺利进行。",
        "NotificationPendingEditActionButton": "前往结账",
        "NotificationPendingEditActionLabel": "您还未提交支持修改。",
        "NotificationStoreCompletePaymentActionLabel": "您还未完成此订单的付款。",
        "NotificationStoreUnfinishedCartActionLabel": "您还未完成订单。",
        "NotificationUnfinishedCartActionButton": "前往结账",
        "NotificationUnfinishedCartActionLabel": "您还未完成支持。",
        "NotificationViewYourPledgeActionButton": "查看您的支持",
        "NotificationViewYourPledgeActionLabel": "收款过程中出现问题。",
        "OrderLastModifiedAtLabel": "最后修改",
        "OrderPaidAmountLabel": "已付金额",
        "OrderPlacedAtLabel": "下单时间",
        "PaymentAmountFromFilterLabel": "付款金额起",
        "PaymentAmountToFilterLabel": "付款金额至",
        "PaymentDateFromFilterLabel": "付款日期起",
        "PaymentDateToFilterLabel": "付款日期至",
        "PaymentSearchTypeRecentLabel": "最近",
        "PaymentSearchTypeUpcomingLabel": "即将到来",
        "PaymentsEmptyStateHeader": "没有可显示的付款。",
        "PaymentsEmptyStateParagraph": "与您的订单和支持相关的付款将显示在这里。",
        "PaymentSortByClosestLabel": "时间最近",
        "PaymentSortByFurthestLabel": "时间最远",
        "PaymentStatusFilterLabel": "付款状态",
        "PaymentTypeAllLabel": "所有",
        "PaymentTypeFilterLabel": "付款类型",
        "PaymentTypeInstallmentsLabel": "Stretch Pay",
        "PledgeDateFromFilterLabel": "支持日期起",
        "PledgeDateToFilterLabel": "支持日期至",
        "PledgeDetailsBoxPledgeInfoText": "支持: {0}, 下单时间 {1}",
        "PledgeDetailsBoxStoreOrderInfoText": "订单: {0}, 下单时间 {1}",
        "PledgesAndOrdersEmptyStateHeader": "没有可显示的支持。",
        "PledgesAndOrdersEmptyStateParagraph": "您最近的支持和订单更改将显示在这里。",
        "PledgeStageFilterLabel": "支持阶段",
        "PledgeValueFromFilterLabel": "支持金额起",
        "PledgeValueToFilterLabel": "支持金额至",
        "ProjectArchivedSuccessToast": "项目已归档。",
        "ProjectInvolvementBackedLabel": "已支持",
        "ProjectInvolvementFollowedLabel": "已关注",
        "ProjectNameFilterLabel": "项目名称",
        "ProjectRestoredSuccessToast": "项目已恢复。",
        "RecentlyViewedProjectsEmptyStateHeader": "没有可显示的项目。",
        "RecentlyViewedProjectsEmptyStateParagraph": "浏览几个项目 - 您的浏览历史将显示在这里。",
        "RestoreProjectArchiveStatusLabel": "从归档中恢复",
        "SearchPhraseFilterLabel": "搜索词",
        "SearchPhrasePlaceholderLabel": "输入内容以搜索...",
        "SectionPaymentsHeader": "付款",
        "SectionPledgesAndOrdersHeader": "支持 & 订单",
        "SectionProjectsAllTab": "所有",
        "SectionProjectsBackedTab": "已支持",
        "SectionProjectsFollowedTab": "已关注",
        "SectionProjectsHeader": "您的项目",
        "SectionRecentlyViewedProjectsHeader": "最近浏览的项目",
        "SectionRequiresActionHeader": "需要操作",
        "SectionUpdatesFeedAllTab": "所有",
        "SectionUpdatesFeedBackedTab": "已支持",
        "SectionUpdatesFeedFollowedTab": "已关注",
        "SectionUpdatesFeedHeader": "更新订阅",
        "SectionYourDashboardHeader": "您的仪表板",
        "ShowOrderDetailsLabel": "显示订单详情",
        "ShowPledgeDetailsLabel": "显示支持详情",
        "ShowPledgesWithActionRequiredOnlyLabel": "仅显示需要操作的支持",
        "ShowPledgesWithInstallmentsOnlyLabel": "仅显示有 Stretch Pay 的支持",
        "UpdatesFeedEmptyStateButtonLabel": "浏览项目",
        "UpdatesFeedEmptyStateHeader": "没有可显示的更新。",
        "UpdatesFeedEmptyStateParagraph": "您关注或支持的项目的最新更新将显示在这里。",
        "ViewAllPaymentsLabel": "查看所有付款",
        "ViewAllPledgesOrdersLabel": "查看所有支持 & 订单",
        "ViewOrderActionLabel": "查看订单",
        "ViewPledgeActionLabel": "查看支持",
        "ViewUpdateFeedLabel": "查看您的订阅",
        "XOfYInstallmentLabel": "分期付款 {0} / {1}",
        "YourDashboardPageTitle": "您的仪表板"
    },
    "Blog": {
        "BackToMainPageLink": "返回主页",
        "EmptyStateListParagraph": "目前没有可用的文章。",
        "PageHeader": "博客"
    },
    "CategoryType": {
        "AddonsDisplayName": "附加组件",
        "RewardsDisplayName": "奖励",
        "UnspecifiedDisplayName": "未指定"
    },
    "Checkout": {
        "BackToCartButton": "返回您的支持",
        "BillingAddressTitle": "账单地址",
        "BillingCountryMissingErrorLabel": "缺少账单国家。",
        "CancelInstallmentPlanErrorMessage": "无法取消已开始的分期计划。",
        "CardPaymentMethodName": "信用卡支付",
        "CheckboxDigitalDeliveryAgreementMessage": "我明确同意履行协议，并在购买过程结束后立即通过电子邮件向我发送我所订购的数字代码。我理解，由于上述同意，我将在协议订立后14天内失去撤销权。",
        "CheckboxEUVatPayerConfirmationMessage": "我是注册的欧盟增值税纳税人",
        "CheckboxEUVatPayerConfirmationTooltipText": "验证后的欧盟增值税纳税人按净价收费。您必须有有效的欧盟增值税编号才能进行跨境交易。",
        "CheckboxSaveCardMessage": "保存此卡片以供未来付款。",
        "CheckboxTermsAndConditionsAgreementMessage": "我同意{0}和{1}。",
        "CheckboxTermsAndConditionsAgreementName": "服务条款和{0}",
        "CheckboxUKVatPayerConfirmationMessage": "我是注册的英国增值税纳税人",
        "CheckboxUKVatPayerConfirmationTooltipText": "验证后的英国增值税纳税人按净价收费。您必须有有效的英国增值税编号才能进行跨境交易。",
        "CheckoutAvailableBanksLabel": "可用银行",
        "CheckoutCannotCreatePaymentErrorMessage": "尝试创建付款时发生意外错误。",
        "CheckoutConvertedCurrencySelectLabel": "转换后的货币",
        "CheckoutCreditCardCardholderEmailLabel": "持卡人电子邮件",
        "CheckoutCreditCardCardholderNameLabel": "持卡人姓名",
        "CheckoutCreditCardExpiryDateLabel": "到期日期",
        "CheckoutCreditCardNumberLabel": "银行卡号",
        "CheckoutCreditCardSecurityLabel": "CVV/CVC",
        "CheckoutCrowdfundingShippingInfoParagraph": "此阶段不收取运费和详细信息。项目发起人将在稍后要求您结算运费。",
        "CheckoutDccMoreInfoParagraph": "原价{0}已转换为{1}。（{2}）",
        "CheckoutDigitalProductsTermsSectionTitle": "数字产品条款接受",
        "CheckoutFooterCompanyInformationParagraph": "本网站由 Gamefound sp. z o.o.（商品名：Gamefound）运营，注册地址：ul. Grabarska 2 50-079 Wrocław，注册于国家法院登记处的企业登记册中，由 Wrocław-Fabryczna 区法院第六商业部维护，KRS 号：0000778227。",
        "CheckoutFooterDccSectionParagraph": "Gamefound 可以将您的付款转换为当地货币。转换是可选的，您可以选择以项目货币完成付款。如果您决定以受支持的货币之一而不是项目货币支付，Gamefound 将使用欧洲中央银行的汇率加{0}进行转换。如果创建者随后退款，退款金额将按原支付时的相同比率计算。",
        "CheckoutFooterDccSectionReadMoreLink": "了解更多",
        "CheckoutFooterDccSectionTitle": "货币转换",
        "CheckoutFooterGamefoundLegalSectionTitle": "Gamefound 不是商店。",
        "CheckoutFooterPlatformLegalSectionTitle": "Gamefound 不是商店",
        "CheckoutFooterProcessingPaymentsSectionParagraph": "付款由{0}全权处理并且安全。Gamefound 仅保存支付卡的架构和最后四位数字，不存储其他支付信息。",
        "CheckoutFooterProcessingPaymentsSectionTitle": "处理支付",
        "CheckoutFooterV1ProjectDisclaimer": "我们不拥有 Gamefound 上的项目。交付奖励、解决争议和发放退款由项目创建者负责。",
        "CheckoutFooterV2ProjectDisclaimer": "我们不拥有 Gamefound 上的项目。交付奖励、解决争议和发放退款由项目创建者负责：",
        "CheckoutFooterV2ProjectIndividualLegalEntity": "创建者是个人 - 您的消费者权益可能不适用。",
        "CheckoutGamefoundSuggestionCurrencyLabel": "由 Gamefound 转换",
        "CheckoutGoBackLink": "返回",
        "CheckoutHeader": "支持摘要",
        "CheckoutHeaderProjectByCreatorTitle": "{0} 由 {1}",
        "CheckoutInstallmentsAvailabilityParagraph": "再支持{0}解锁",
        "CheckoutInstallmentsAvailabilityTooltip": "解锁分期付款的最低支付金额：",
        "CheckoutInstallmentsDetailsInfoLabel": "您将支付首期{0}，总共为{1}。",
        "CheckoutInstallmentsPledgeDetailsInfoLabel": "您的总支持金额将分成{0}等额支付，根据您的分期计划账单。",
        "CheckoutInstallmentsUpgradeDetailsInfoLabel": "您即将支付升级方案的 {0} 分期付款中的第一笔，总金额为 {1}。",
        "CheckoutKlarnaPaymentMethodLabel": "立即使用 klarna 支付。",
        "CheckoutLatePledgeShippingInfoParagraph": "在 pledge manager 开放后，您将被要求添加运送详细信息并结算额外费用。",
        "CheckoutLocationDetailsSectionTitle": "运送和税费详情",
        "CheckoutOrderSummaryStepLabel": "订单摘要和支付",
        "CheckoutPayButton": "支付",
        "CheckoutPaymentCancelledByUserMessage": "用户取消付款",
        "CheckoutPaymentMethodSectionTitle": "支付方式",
        "CheckoutPaymentOptionsInfoNotificatorMessage": "此阶段我们仅验证您的卡。只有在活动达到目标并结束时才会收取实际付款。届时您可以自由修改或撤回您的支持。",
        "CheckoutPaymentOptionsSectionTitle": "支付选项",
        "CheckoutPaymentOptionsWarningNotificatorMessage": "处理付款时发生错误。如果想要继续接收您的支持，请手动完成付款。",
        "CheckoutPaymentTypeInstallmentsBadge": "{0} 分期付款",
        "CheckoutPaymentTypeInstallmentsDisabledLabel": "使用 Stretch Pay 支付",
        "CheckoutPaymentTypeInstallmentsLabel": "每月支付{0}",
        "CheckoutPaymentTypeMoneyLabel": "全额支付",
        "CheckoutPaymentTypeUpgradeInstallmentsLabel": "升级您的 Stretch Pay 计划为每月支付 {0}",
        "CheckoutPlatformSuggestionCurrencyLabel": "由 Gamefound 转换",
        "CheckoutPledgeButton": "支持",
        "CheckoutPledgeIdentificationLabel": "支持编号：",
        "CheckoutPledgeSummaryStepLabel": "支持摘要和支付",
        "CheckoutProductNotAvailableInSelectedLocationLink": "编辑您的支持",
        "CheckoutProductNotAvailableInSelectedLocationMessage": "某些产品无法运送到该位置。为了完成您的支持，请将它们从购物车中移除。{0}",
        "CheckoutProductNotAvailableInSelectedLocationParagraph": "您无法下单包含无法运送到该位置的商品。请将它们从购物车中移除以继续下单。",
        "CheckoutProductsSectionTitle": "您的支持中的产品",
        "CheckoutProjectCurrencyLabel": "项目货币",
        "CheckoutShippingStepLabel": "运送",
        "CheckoutSubHeader": "验证您的支持内容并进行支付。",
        "CheckoutSubmitOrderButton": "提交订单",
        "CheckoutTermsOfServiceLabel": "服务条款",
        "CheckoutTransactionCurrencyHeader": "交易货币",
        "CheckoutUnsavedChangedWarningMessage": "您在此支持中有未保存的更改。如果继续，您输入的信息将会丢失。确定要离开此页面吗？",
        "CompanyNameLabel": "公司名称",
        "CPFNumberLabel": "CPF 号码",
        "CPFNumberRequired": "需要 CPF 号码",
        "CPFNumberTooltipLabel": "有效格式为 XXX.XXX.XXX-XX",
        "CreateAccountCheckboxLabel": "使用此邮件创建一个{0}账户，方便你在一个地方轻松支持项目并管理所有事务。",
        "CreateOrderPageTitle": "支持摘要",
        "CreditCardPaymentMethodName": "信用卡",
        "CustomerEntityTypeBusinessLabel": "以企业身份支持",
        "CustomerEntityTypeIndividualLabel": "以个人身份支持",
        "DifferentBillingAddressLabel": "我的账单地址不同",
        "EmailAddressesDontMatchErrorLabel": "电子邮件地址不匹配。",
        "EmailConfirmationFieldDescription": "请输入相同的电子邮件以确认其有效性。",
        "EmailConfirmationFieldLabel": "确认电子邮件",
        "EmailFieldDescription": "在结帐后，您的支持将与此电子邮件相关联。所有关于支持的通信都将发送到这里。",
        "EmailFieldLabel": "电子邮件",
        "EnterBlikCodeDescription": "输入6位代码并在您的银行应用中确认交易。",
        "EnterBlikCodeLabel": "输入 Blik 代码",
        "EntityMustNotHaveVatNumberErrorMessage": "该实体不应提供VAT号码。",
        "EspagoPaymentMethodName": "信用卡",
        "EstimatedStartOfDeliveryLabel": "预计发货开始：",
        "ExternalTransferMethodOption": "外部转账",
        "ForceSameBillingLocationModalText": "您有一个单独的账单地址。由于运输地址已更改，账单地址现在必须与其匹配。您的账单地址已被清除。如果您希望保持单独的账单地址，请重新添加。",
        "ForceSameBillingLocationModalTitle": "账单地址已清除",
        "HumanizeDatePluralizedMinute": "分钟|分钟",
        "InvalidPaymentOptionErrorMessage": "请选择一种支付方式。",
        "InvalidShippingCostConfigurationErrorLabel": "该项目的运费配置似乎存在问题。如果问题仍然存在，请联系项目发起人。",
        "IssuerDropdownPlaceholder": "选择您的银行",
        "LegacyCheckoutPaymentMethodSectionSubtitle": "您将被要求提供卡片详细信息。",
        "LegacyCheckoutPaymentMethodSectionTitle": "选择支付方式",
        "LocalizedAddressLabel": "本地化地址",
        "LocalizedAddressRequired": "需要本地化地址",
        "LocalizedAddressTooltipLabel": "为了确保在非拉丁文字区域的正确配送处理，请输入包含任何独特当地字符的完整地址。",
        "ManageYourOrderButton": "管理您的订单",
        "ManageYourPledgeButton": "管理您的支持",
        "NewOrdersNotAllowedErrorMessage": "此项目目前不接受新订单。",
        "NIDNumberLabel": "NID 号码",
        "NIDNumberRequired": "需要 NID 号码",
        "NIDNumberTooltipLabel": "正确的号码格式是10位数字",
        "OnlineBankingFIPaymentMethodLabel": "Paytrail（在线银行 FI）",
        "OnlineBankingPLPaymentMethodLabel": "Przelewy24（在线银行 PL）",
        "OrderContainsLocationRestrictedItemsErrorMessage": "订单包含在当前位置不可用的商品。",
        "OrderInformationHeader": "订单信息",
        "OrderItemNotFound": "未找到订单商品。",
        "OrderNotFoundErrorMessage": "找不到指定的订单。",
        "OtherPaymentMethodsLabel": "其他支付方式",
        "PANNumberLabel": "PAN号码",
        "PANNumberRequired": "需要提供PAN号码",
        "PANNumberTooltipLabel": "请输入您的PAN（永久账户号码）。正确的号码格式为5个字母，4个数字和1个字母。",
        "PaymentCollectionTypeDeferredLabel": "延迟",
        "PaymentCollectionTypeInstantLabel": "即时",
        "PaymentErrorBoxDescription": "处理您的付款时出现问题。请检查您的付款方式有效性和可用资金并重试。",
        "PaymentErrorBoxTitle": "付款错误",
        "PaymentErrorGoToCheckoutLabel": "前往结算",
        "PaymentErrorViewYourPledgeLabel": "查看您的支持",
        "PaymentMethodDeferredDisclaimerParagraph": "在此阶段我们只验证您的银行卡。只有在众筹成功结束后才会收取费用。",
        "PaymentMethodDeferredPayPalDisclaimerParagraph": "此阶段您的 PayPal 账户仅被授权。仅当活动成功结束后才会收取付款。届时您可以自由修改或撤回您的支持。",
        "PaymentMethodInstantDisclaimerParagraph": "如果选择此支付方式，您将立即被扣款。",
        "PaymentMethodInstantDisclaimerParagraph1": "如果选择此支付方式，您将立即被扣款。只有在活动成功结束时资金才会支付给创建者。如果活动未成功结束，您将获得全额退款。",
        "PaymentMethodInstantDisclaimerParagraph2": "您可以自由升级您的支持。",
        "PaymentMethodInstantDisclaimerParagraph3": "一旦支付，所有支持升级必须使用相同的支付方式结算。",
        "PaymentMethodInstantDisclaimerParagraph4": "如果您改变主意，可以要求发起者取消您的支持，并在众筹活动结束前全额退款。",
        "PaymentMethodInstantDisclaimerParagraph5": "活动成功结束后，适用标准活动取消政策。",
        "PaymentMethodInstantDisclaimerParagraph6": "活动结束后，适用标准活动取消政策。",
        "PaymentMethodInstantDisclaimerParagraph7": "如果您改变主意，可以要求发起者取消您的支持，并在众筹活动结束前申请退款。",
        "PaymentNotFoundErrorMessage": "未找到付款。",
        "PaymentProcessingBoxActionLabel": "前往项目页面",
        "PaymentProcessingDeferredBoxDescription": "我们正在验证您的付款信息。根据您的支付提供商，这可能需要长达 {0} {1} 的时间。如果活动成功结束，付款将被收取。在此之前，您可以自由更改或撤销支持。您可以在此停留查看结果或继续浏览。验证完成后，我们会通过电子邮件通知您。",
        "PaymentProcessingDeferredBoxTitle": "正在验证付款方式",
        "PaymentProcessingInstantBoxDescription": "我们正在处理您的付款。对于所选付款方式，可能需要长达 {0} {1} 的时间。您可以在此等待结果或继续浏览。我们将通过电子邮件通知您操作结果。",
        "PaymentProcessingInstantBoxTitle": "付款进行中",
        "PayPalPaymentMethodName": "信用卡 / PayPal™",
        "PledgeInstallmentsPaymentDateEndgameAdditionalInfo": "第一期付款安排在众筹结束日期，这可能会根据项目's 'endgame'阶段的持续时间而有所不同。",
        "PledgeOrderPageTitle": "支持摘要",
        "PreviouslyUsedPaymentMethodLabel": "先前使用过的付款方式",
        "ProductsOutOfStockErrorMessage": "无法执行付款。一件或多件产品缺货。",
        "ProviderPaymentTokenMissingErrorMessage": "您的付款遇到问题，请再试一次。如果问题仍然存在，请联系我们。",
        "ReCaptchaCheckoutVerificationFailedErrorMessage": "我们注意到一些异常活动，您无法结账。",
        "RecentPaymentMethodsLabel": "最近使用的付款方式",
        "RedirectToPaymentProviderTooltipText": "正在跳转到支付提供商...",
        "RefundAndCancellationPolicyLink": "退款和取消政策",
        "RegisteredVatPayerCheckboxLabel": "我是注册的欧盟增值税纳税人",
        "RemoveItemButton": "删除商品",
        "ResumePaymentNotificatorMessage": "此阶段不会收集运费和费用。项目发起者会在后续要求您支付运费。",
        "ResumePaymentPageSubHeader": "完成付款流程以接收您的支持。",
        "RFCNumberLabel": "RFC号码",
        "RFCNumberRequired": "RFC号码是必填项",
        "RFCNumberTooltipLabel": "输入您的RFC（Registro Federal de Contribuyentes）号码。正确的号码格式是13位数字。",
        "RRNNumberLabel": "RRN 编号",
        "RRNNumberRequired": "需要 RRN 编号",
        "RRNNumberTooltipLabel": "正确的编号格式为 13 位数字",
        "RUTNumberLabel": "RUT号码",
        "RUTNumberRequired": "需要提供RUT号码",
        "RUTNumberTooltipLabel": "请输入您的RUT（Rol Único Tributario）号码。正确的号码格式为XX.XXX.XXX-X。",
        "SavedPaymentMethodLabel": "已保存",
        "SavePledgedOrderErrorMessage": "无法创建支持。如果问题仍然存在，请联系我们。",
        "ShippingCostAdditionalValueLabel": "额外",
        "ShippingCostLabel": "费用：",
        "ShippingCostReducedValueLabel": "减少",
        "ShippingCostWithoutTaxLabel": "净费用：",
        "ShippingFormAddressTitle": "地址",
        "ShippingFormNotificatorParagraph": "此项目不允许更改送货地址。",
        "ShippingFormShippingAddressTitle": "送货地址",
        "ShippingLocationModificationDisabledErrorMessage": "无法修改配送国家。",
        "ShippingMethodSectionTitle": "配送方式",
        "ShippingModelChangedSuccessToast": "运费已加入您的支持。",
        "ShippingModelsNotAvailableErrorMessage": "无可用运送模式，请联系网站管理员。",
        "ShippingPageHeader": "配送",
        "ShippingPageSubheader": "请检查支持内容并填写您的送货和账单信息。",
        "ShippingPageTitle": "支持信息",
        "ShippingSubLocationModificationDisabledErrorMessage": "无法修改配送状态/省份。",
        "StoreCheckboxTermsAndConditionsAgreementMessage": "我同意商店的 {0} 和 {1}。",
        "StoreCheckoutHeader": "订单摘要",
        "StoreCheckoutProductNotAvailableInSelectedLocationLink": "编辑您的订单",
        "StoreCheckoutProductNotAvailableInSelectedLocationMessage": "某些产品无法运送到此地点。请从购物车中移除它们以完成您的订单。{0}",
        "StoreCheckoutSubHeader": "请确认您的订单内容并继续付款。",
        "StoreCheckoutTermsOfServiceLabel": "Gamefound 商店服务条款",
        "StoreShippingPageSubheader": "请检查订单内容并填写您的送货和账单信息。",
        "StripePaymentMethodName": "信用卡 / Stripe™",
        "TermsAndConditionsForBackersLink": "支持者服务条款",
        "UnauthorizedAmendOrderErrorMessage": "您必须登录才能修改先前的订单。",
        "UnauthorizedPaymentErrorBoxDescription": "处理您的付款时出现问题。请确认您的付款方式有效且账户资金充足，等待电子邮件说明如何继续付款。如果您已经有账号，可以登录并立即完成此过程",
        "UnauthorizedShippingModificationErrorMessage": "您必须登录才能更改配送信息。",
        "UnfinishedPledgeErrorMessage": "您必须完成当前的支持。",
        "UnsuportedPaymentMethodMessage": "抱歉，您的订单使用了应用不支持的 {0} 付款方式，请使用浏览器继续操作。",
        "UpgradeInstallmentsRemainingValueLabel": "先前分期计划的剩余金额",
        "UpgradeInstallmentsTotalValueLabel": "升级后的总分期计划",
        "UpgradeInstallmentsUpgradeValueLabel": "升级金额",
        "UserAddressItemLabel": "地址",
        "UserCityLabel": "城市",
        "UserCountryLabel": "国家",
        "UserFirstAddressLabel": "地址行 1",
        "UserFullNameLabel": "全名",
        "UserNotesLabel": "附注",
        "UserPhoneNumberLabel": "电话号码",
        "UserPostalCodeLabel": "邮政编码",
        "UserSecondAddressLabel": "地址行 2",
        "UserShippingCountryDisabledParagraph": "如果您的配送国家在发货前发生变化，您必须联系发起者进行修改。",
        "UserShippingCountryLabel": "配送国家",
        "UserShippingCountryParagraph": "选择支持将要寄送的国家，以便我们应用正确的税率。如果您的配送国家在发货时间前发生变化，您必须联系发起者进行修改。运费将由发起者稍后确定。",
        "UserShippingCountryPlaceholder": "输入或选择国家名称",
        "UserStateOrProvinceLabel": "州/省",
        "UserSubLocationLabel": "具体位置",
        "UserSubLocationPlaceholder": "输入省/州名称",
        "UserThirdAddressLabel": "地址行 3",
        "UserUnableToDeleteOrderItemErrorMessage": "订单商品无法删除。",
        "UserVatNumberLabel": "税号",
        "UtilizeBonusAmountCancelButton": "将奖励保留在支持中",
        "UtilizeBonusAmountModalDescription": "您的支持中包含未使用的奖励金额。您可以使用此金额来减少付款金额，或将其保留在支持中以进一步支持发起者。您的选择将修改您的购物车总额。",
        "UtilizeBonusAmountModalTitle": "管理您的奖励金额",
        "UtilizeBonusAmountSubmitButton": "立即使用奖励",
        "UtilizeBonusAmountSuccessToastMessage": "您的奖励已应用于您的付款。",
        "VatNumberRequiredErrorMessage": "需要提供VAT号码。",
        "VatNumberRequiredForBusinessEntityErrorMessage": "企业实体需要提供VAT号码。"
    },
    "CheckoutValidation": {
        "AddOnsOnlyPledgeErrorMessage": "你不能仅选择附加项目结账。请在你的赞助中添加一个奖励以继续。",
        "AddProductPreviewValidationErrorMessage": "你不能将此产品添加到你的赞助中，因为这是{0}的预览。",
        "AddUnpublishedProductValidationErrorMessage": "你不能将此产品添加到你的赞助中，因为这是未发布的产品。",
        "AmendOrderNotPossibleErrorMessage": "此时无法修改此订单。",
        "BillingCountryNotFoundErrorMessage": "未找到开票国家。",
        "BillingStateMissingErrorMessage": "开票州缺失。",
        "BillingStateNotValidErrorMessage": "开票州无效。",
        "CannotChangeBillingErrorMessage": "不能更改账单地址。",
        "CartValueLowerThanPaidMessage": "你不能提交此赞助，因为其金额低于你已支付的金额。",
        "ChangeShippingNotPossibleErrorMessage": "此时无法更改运输。",
        "ChangingPaymentMethodUnavailableErrorMessage": "此时你不能更改支付方式。",
        "CheckShippingConfigurationInfoMessage": "请确保运输配置有效。",
        "CouldNotAmendOrderErrorMessage": "无法修改订单。",
        "CouldNotChangeShippingErrorMessage": "无法更改运输。",
        "CouldNotInvokePaymentErrorMessage": "无法调用支付。",
        "CreateOrderNotPossibleErrorMessage": "无法创建订单。",
        "CurrencyExchangeRateChangedInfoMessage": "货币汇率已变更。刷新页面以更新付款金额。",
        "DeferredPaymentIsNotAvailableMessage": "延迟付款不再可用。",
        "DisabledOrderCurrencyMessage": "你不能更改此赞助，因为其货币已被禁用。",
        "EditingPledgeNotFinishedErrorMessage": "你必须完成当前的赞助编辑。",
        "EmptyCartErrorMessage": "你不能结账，因为你的赞助为空。",
        "EmptyPledgeButtonTooltipText": "你不能继续进行空的赞助。",
        "EmptyPledgeErrorMessage": "赞助为空。",
        "IncorrectCheckoutModeErrorMessage": "结账模式不正确。",
        "IncorrectPaymentMode": "支付模式不正确。",
        "IncorrectPledgeStatusErrorMessage": "赞助状态不正确。",
        "IncorrectProjectPhaseErrorMessage": "项目阶段不正确。",
        "IncorrectProjectVersionErrorMessage": "项目版本不正确。",
        "InstallmentPlanNotAvailableErrorMessage": "此订单的分期付款不可用。",
        "InsufficientCreditAmountActionErrorMessage": "你没有足够的积分完成此次操作。",
        "InsufficientCreditAmountErrorMessage": "你没有足够的积分完成此订单。",
        "InsufficientOrderValueMessage1": "这包括最高支付金额{0:C2}及你的可用积分{1:C2}。",
        "InsufficientOrderValueMessage2": "这包括最高支付金额{0:C2}及你的可用折扣{1:C2}。",
        "InsufficientOrderValueMessage3": "这包括最低支付金额{0:C2}及你的可用积分{1:C2}。",
        "InsufficientOrderValueMessage4": "这包括最低支付金额{0:C2}及你的可用折扣{1:C2}。",
        "InvalidArchiveProductErrorMessage": "你不能将此产品添加到你的赞助中，因为这是原众筹活动的存档视图。",
        "InvalidAuthorizationParamsErrorMessage": "授权参数无效。",
        "InvalidCartActivationKey": "激活密钥无效。",
        "InvalidEUVatNumberErrorMessage": "你提供的增值税号无效。",
        "InvalidNumberOfInstallmentsCheckoutMessage": "分期付款数量无效。当前订单支付可以分为{0}期。",
        "InvalidNumberOfInstallmentsMessage": "分期付款数量无效。",
        "InvalidPaymentMethodErrorMessage": "支付方式无效。",
        "InvalidPaymentTypeForPaypalMethodErrorMessage": "订单使用StretchPay时不支持PayPal支付。",
        "InvalidPledgeValueMessage": "你不能提交此赞助，因为其净值低于你已支付的金额。",
        "InvalidProductSetErrorMessage": "此套装中的一个或多个项目需要操作。",
        "InvalidProjectContextErrorMessage": "项目上下文无效。",
        "InvalidProjectPhaseErrorMessage": "项目阶段无效。",
        "InvalidShippingConfigurationErrorMessage": "运输配置无效。",
        "InvalidUKVatNumberErrorMessage": "你提供的增值税号格式无效。英国增值税号应为GB开头，后跟9或12位数字。",
        "InvalidZipCodeFormatErrorMessage": "邮政编码必须以#####或#####-####形式提供。",
        "ItemLimitedToLoggedInUsersErrorMessage": "你无法提交此认捐，因为它包含仅限登录用户获取的物品。",
        "LockedOrderErrorMessage": "你不能更改订单，因为它已被创建者禁用。",
        "MaxCostReachedErrorMessage": "你不能赞助超过{0:C2}的金额。",
        "MinCostReachedErrorMessage": "你不能赞助低于{0:C2}的金额。",
        "MissingCartActivationKey": "激活密钥缺失。",
        "NewOrdersUnavailableErrorMessage": "抱歉，该项目暂时不接受新订单。",
        "NoScheduledPaymentsInfoMessage": "赞助没有任何计划付款。",
        "OrderModifiedSuccessfullyMessage": "你已成功修改订单。",
        "OrderNotAwaitingPaymentStatusErrorMessage": "此订单不在等待付款状态。",
        "OrderNotFinishedErrorMessage": "你必须完成当前订单。",
        "OrderNotFoundErrorMessage": "未找到订单。",
        "OrderNotProcessingPaymentStatusErrorMessage": "此订单未在处理支付状态。",
        "OrderPaymentStatusCannotBeProcessingPaymentErrorMessage": "订单状态不能为处理中支付状态。",
        "OrderProcessingPaymentMessage": "你的支付正在处理。",
        "OrderReachedMaxAmountErrorMessage": "你的赞助超过了最高金额{0:C2}。",
        "OrderSuccessfullyCreatedMessage": "订单成功",
        "OrderUnderpaymentErrorMessage": "我们已收到你的赞助付款，但其内容和价格已更改。请支付价格差额以接收你的赞助。",
        "ParentOrderNotFoundErrorMessage": "未找到父订单。",
        "PaymentAmountMismatchErrorMessage": "结账过程中你的支付金额发生了变化。刷新屏幕查看更新后的赞助摘要，然后继续付款。",
        "PaymentIncompleteErrorMessage": "你的支付不完整。",
        "PaymentInInstallmentsIsNotAvailableMessage": "分期付款不再可用。",
        "PaymentInInstallmentsUnavailableErrorMessage": "不符合分期付款条件。",
        "PaymentInitializationErrorMessage": "无法初始化支付。请再试一次。如果问题仍然存在，请联系我们。",
        "PaymentMethodChangeErrorMessage": "无法更改支付方式。",
        "PaymentMethodNotSupportedForInstallmentPaymentMessage": "选定的支付方式不支持分期付款。",
        "PaymentMethodUnavailableForGuestErrorMessage": "选择的支付方式访客用户无法使用。",
        "PaymentMethodUpdatedInfoMessage": "支付方式已更新。",
        "PaymentNotAuthorizedErrorMessage": "无法授权支付。",
        "PaymentNotCompletedErrorMessage": "你的支付未完成。请再试一次。",
        "PaymentNotRequiredMessage": "此订单此时不需要支付。",
        "PaymentOrderOverpaidErrorMessage": "你不能提交此赞助，因为其净值低于你已支付的金额。",
        "PaymentProblemErrorMessage": "你的支付出现问题 ({0})。请再试一次或联系我们。",
        "PaymentProblemTryAgainErrorMessage": "你的支付出现问题。请再试一次或联系我们。",
        "PaymentsUnavailableErrorMessage": "此项目不再接受支付。",
        "PlaceOrderInsufficientCreditAmountErrorMessage": "你没有足够的积分下此订单。",
        "PledgeCompletionRequiresAccountErrorMessage": "此支持无法在没有账号的情况下完成。请注册以继续。",
        "PledgeNotFinishedErrorMessage": "你必须完成当前赞助。",
        "PledgeNotFoundErrorMessage": "未找到赞助。",
        "ProductUnavailable": "一个或多个产品不可用",
        "ProjectInLatePledgeCompletedPhaseErrorMessage": "你不能向赞助中添加项目，因为此项目的Pledge Manager尚未启动。",
        "ProjectInPledgeManagerCompletePhaseErrorMessage": "此时你不能向赞助中添加项目。",
        "ProjectPhaseNotValidErrorMessage": "当前项目阶段无效。",
        "RemoveUnpaidItemsErrorMessage": "你不能向赞助中添加新项目。请移除购物车中的未支付项目或还原更改以继续。",
        "RequireDigitalDeliveryAgreementErrorMessage": "你必须接受数字交付协议才能继续订单。",
        "RequiredOptionsNotChosen": "赞助中的所有必选项都未选择。",
        "RequireTosAcceptanceErrorMessage": "你必须接受\"服务条款和退款及取消政策\"才能继续赞助。",
        "SaveOrderNotPossibleErrorMessage": "无法保存订单。",
        "ShippingAddressChangeUnavailableErrorMessage": "不能更改送货地址。",
        "ShippingConfigurationNotValidErrorMessage": "运输配置无效。",
        "ShippingCostCalculationFailedMessage": "计算运费时出错。",
        "ShippingCountryMissingErrorMessage": "运输国家缺失。",
        "ShippingCountryNotFoundErrorMessage": "未找到运输国家。",
        "ShippingDetailsNotValidErrorMessage": "运输和开票{0}必须相同。",
        "ShippingMethodUnavailableMessage": "所选运输方式不可用。",
        "ShippingStateInvalidErrorMessage": "运输州无效。",
        "ShippingStateMissingErrorMessage": "运输州缺失。",
        "SingleAdditionOnlyValidationErrorMessage": "此项目不能单独添加到你的赞助中。",
        "SpecificCustomerAddressBlockedByFullAddressCollection": "不能提供不同的账单地址，因为此位置的税收根据地址收取。",
        "StorePaymentMethodAsGuestErrorMessage": "访客用户无法储存支付方式用于未来支付。",
        "TipMaximumAmount": "最大金额为{0}。",
        "TipMinimumAmount": "最小金额为{0}。",
        "TooManyCopiesErrorMessage": "赞助中添加的商品数量过多。",
        "UnchangedPledgeInfoMessage": "你的赞助未变。",
        "UnhandledErrorMessage": "如果问题仍然存在，请联系我们。",
        "UserUnableToEditPledgeErrorMessage": "抱歉，此时你不能修改你的赞助。",
        "UserUnableToRevertPledgeChangesErrorMessage": "当前购物车没有父订单，因此无法还原更改。"
    },
    "Comments": {
        "AuthorNotFoundMessageText": "无法找到该评论的作者",
        "BackerBadge": "Backer",
        "BackerBadgeTooltip": "此用户支持了该项目",
        "BackNowButton": "立即支持",
        "CancelEditCommentAction": "取消编辑",
        "CommentDeleteConfirmationMessage": "确定要删除此评论吗？",
        "CommentFieldCapabilitiesHeader": "你可以使用：",
        "CommentFieldCapabilitiesOption1": "# 添加标签",
        "CommentFieldCommentSubmitButton": "评论",
        "CommentFieldEditingHeader": "编辑评论",
        "CommentFieldEditSubmitButton": "保存",
        "CommentFieldPlaceholder": "在这里写下你的消息...",
        "CommentFieldReplySubmitButton": "回复",
        "CommentItemStatusEditedLabel": "编辑过",
        "CommentPreviewItemInLabel": "位于：",
        "CommentReportedAndHiddenMessageText": "评论已隐藏",
        "CommentReportReasonHarassmentDisplayName": "骚扰或冒犯性语言",
        "CommentReportReasonHateSpeechDisplayName": "仇恨言论",
        "CommentReportReasonMisinformationDisplayName": "误导信息",
        "CommentReportReasonOtherDisplayName": "其他原因",
        "CommentReportReasonSpamDisplayName": "不需要的商业内容或垃圾邮件",
        "CommentRestrictionDescription1": "发起人已禁止非支持者发表评论。要参与讨论，请支持该项目。",
        "CommentRestrictionDescription2": "发起人已禁止非支持者发表评论。请关注最新项目更新。",
        "CommentRestrictionDescription3": "发起人已禁止非支持者发表评论。立即关注以接收项目更新通知。",
        "CommentRestrictionHeading1": "支持项目以发表评论",
        "CommentRestrictionHeading2": "讨论仅限支持者参与",
        "CommentsInTestModeInfoParagraph": "评论不在测试模式下，将公开可见",
        "CommentsPageNavbarLink": "评论",
        "CommunityGuidelinesLink": "社区指导原则",
        "CreatorBackerBadge": "之前的支持者",
        "CreatorBackerBadgeTooltip": "此用户曾支持过该创作者的项目",
        "CreatorBadge": "创作者",
        "CreatorCommentsFilterButton": "创作者评论",
        "DeleteCommentAction": "删除",
        "EditCommentAction": "编辑",
        "EmptyStateHeader": "还没有评论",
        "EmptyStateParagraph": "成为第一个评论的人！",
        "GamefoundStaffBadge": "Gamefound",
        "GoToUserDetailsCommentAction": "查看用户详情（管理员）",
        "HideCommentAction": "隐藏",
        "LoadMoreButton": "加载更多",
        "LoadMoreChildCommentsButton": "加载更多评论 ({0})",
        "LoadNewMessagesButton": "加载 {0} {1}",
        "LogInCallToActionButton": "登录",
        "LogInToCommentHeader": "登录以发表评论",
        "LogInToCommentParagraph": "你必须登录才能发表评论。没有账号？{0}。",
        "LogInToReplyTooltip": "你需要登录才能回复",
        "LogInToVoteTooltip": "你需要登录才能点赞",
        "MostPopularSortTypeButton": "最受欢迎",
        "MostRecentSortTypeButton": "最新",
        "MyCommentsFilterButton": "我的评论",
        "NewMessagesLabel": "新评论|新评论",
        "NonBackerBadge": "非支持者",
        "NonBackerBadgeTooltip": "此用户目前未支持该项目，不能再发表评论。",
        "PageHeader": "评论",
        "PathfinderBadgeTooltip": "此用户通过提供宝贵的反馈帮助了 Gamefound 的改进",
        "PinCommentAction": "置顶",
        "PinningUnpinningMessageText": "置顶或取消置顶评论可能需要最多 30 秒",
        "PledgeMasterBadge": "Pledge master",
        "PledgeMasterBadgeTooltip": "此用户帮助了许多项目变成现实",
        "ProjectCommentsDisabledCreatorMessage": "用户无法查看你项目的评论页面，因为目前已禁用。请联系 business@gamefound.com 启用评论。",
        "ProjectCommentsDisabledUserMessage": "创作者尚未启用评论区",
        "ProjectRecommendationsTitle": "你可能喜欢的其他项目",
        "ReplyCommentAction": "回复",
        "ReportAndHideCommentModalInformation": "此操作会立即隐藏评论。每条隐藏的评论将由 Gamefound 审核团队验证是否违反我们的社区标准。不正当使用可能会导致失去隐藏评论的权限。",
        "ReportAndHideCommentModalParagraph": "要隐藏评论，需要提供理由以帮助我们理解你的决定。该理由仅对 Gamefound 团队可见。",
        "ReportAndHideCommentModalTitle": "隐藏评论",
        "ReportCommentAction": "举报",
        "ReportCommentModalParagraph": "要举报评论，你需要提供理由。",
        "ReportCommentModalReasonDescriptionFieldLabel": "理由描述",
        "ReportCommentModalReasonFieldLabel": "理由",
        "ReportCommentModalTitle": "举报评论",
        "ReportedByAutomatedSystemName": "自动系统",
        "ReportSubmittedMessageText": "举报已提交",
        "SearchTagButton": "标签与筛选",
        "SearchTagsFieldPlaceholder": "搜索标签",
        "SetNicknameModalNicknameFieldLabel": "昵称",
        "SetNicknameModalParagraph": "为发表评论，你需要选择一个昵称。你可以随时在账号设置中更改它。",
        "SetNicknameModalTitle": "设置昵称",
        "SignUpLink": "注册",
        "TagSearchGoToTagResult": "前往 #{0}",
        "TagSearchNoMatchesResult": "没有匹配结果",
        "TagsEmptyStateHeader": "目前没有流行标签展示",
        "TagsSectionHeader": "标签与筛选",
        "UnhideCommentAction": "取消隐藏",
        "UnpinCommentAction": "取消置顶",
        "UserBannedDescription": "由于违反我们的 {0}，你评论的权限已被限制。",
        "UserBannedHeader": "你已被禁止发表评论"
    },
    "Common": {
        "ActionNotAvailableMessage": "此操作目前不可用。",
        "AddressCityLabel": "城市：",
        "AddressCountryLabel": "国家：",
        "AddressFullNameLabel": "全名：",
        "AddressLinesLabel": "地址：",
        "AddressPhoneLabel": "电话号码：",
        "AddressPostalCodeLabel": "邮政编码：",
        "AddressSublocationLabel": "省/州：",
        "AddressTaxNumberLabel": "税号：",
        "AddressUserNotesLabel": "附加备注：",
        "AmountTableHeader": "金额",
        "AutocompleteClearButtonLabel": "清除",
        "AutocompleteFieldCreateNewLabel": "创建新的",
        "AutocompleteFieldMatchingItemsLabel": "匹配项",
        "AutocompleteFieldNoMatchesLabel": "无匹配项",
        "BackerBadgeText": "Backer",
        "BackToMainPageLink": "返回主页",
        "BalloonActionsTriggerLabel": "显示操作",
        "BreadcrumbsBlogLink": "博客",
        "BreadcrumbsHomeLink": "主页",
        "ByText": "由",
        "CaptchaDisclaimerCaption": "此站点受 reCAPTCHA 和 Google {0} 和 {1} 保护。",
        "CaptchaPrivacyPolicyLink": "隐私政策",
        "CaptchaTermsOfServiceLink": "服务条款",
        "CheckboxRequiredValidationMessage": "您需要接受{0}。",
        "ClickHereButton": "点击这里",
        "CorruptedImageErrorMessage": "图片数据似乎已损坏。",
        "CreatorLogoImageAltLabel": "标志",
        "DangerousStringDetectedMessage": "检测到危险字符串。",
        "DateTableHeader": "日期",
        "EditActionLabel": "编辑",
        "ElementModifiedParagraph": "修改于 {0}",
        "EmptyStateSearchParagraph": "未找到匹配结果。",
        "FeatureDisabledErrorMessage": "功能已禁用",
        "FileTooLargeMaxMBSizeMessage": "文件太大。允许的最大文件大小为 {0} MB。",
        "FileTypeNotSupportedMessage": "不支持类型为 '{0}' 的文件。",
        "FollowerBadgeText": "Follower",
        "FormSubmitButton": "提交",
        "GoBackButton": "返回",
        "HideContentLabel": "隐藏",
        "HtmlHeadDescription": "Gamefound 是让神奇游戏项目得以实现的地方。由玩家为玩家打造，轻松管理众筹和 pledge manager。",
        "IncompleteFieldErrorMessage": "字段不完整",
        "InvalidImageDimensionsMessage": "图像的宽度和高度不能都大于 {0} 像素。",
        "InvalidImagePresetMessage": "无效的图像预设。",
        "InvalidProjectInformationErrorMessage": "无效的项目信息",
        "InvalidSocialMediaUrlMessage": "无效的 {0} URL。",
        "ItemsCounterLabel": "{0} / {1}",
        "LastUpdatedAtLabel": "最后更新：",
        "LoadMoreButton": "加载更多",
        "MainTagline": "创意的未来",
        "MissingOrInvalidParamMessage": "请求中丢失或无效的 '{0}' 参数。",
        "ModalBackButton": "返回",
        "ModalCancelButton": "取消",
        "ModalCloseButton": "关闭",
        "ModalConfirmButton": "确认",
        "ModalContinueButton": "继续",
        "ModalNoButton": "否",
        "ModalOkButton": "确定",
        "ModalSaveButton": "保存",
        "ModalYesButton": "是",
        "MoreInfoHeader": "更多信息",
        "MoreText": "更多",
        "NoImageSuppliedMessage": "未提供图片。",
        "NotesTableHeader": "备注",
        "NoVideoSuppliedErrorMessage": "未提供视频。",
        "OperationNotSupportedForGuestErrorMessage": "访客不支持此操作",
        "OrderCommunicationNotFound": "未找到订单沟通。",
        "PageMetaDescription": "Gamefound 是让神奇游戏项目得以实现的地方。由玩家为玩家打造，轻松管理众筹和 pledge manager。",
        "PaymentMethodTableHeader": "支付方式",
        "PlayVideoButton": "播放",
        "PleaseSelectPlaceholder": "请选择...",
        "PledgeSortTypeCreatedDateAscLabel": "最早下单",
        "PledgeSortTypeCreatedDateDescLabel": "最近下单",
        "PledgeSortTypeModifiedDateAscLabel": "最早修改",
        "PledgeSortTypeModifiedDateDescLabel": "最近修改",
        "PledgeSortTypePledgeValueAscLabel": "最低价优先",
        "PledgeSortTypePledgeValueDescLabel": "最高价优先",
        "PostedOnPublishDateLabel": "发布于 {0}",
        "ReadMoreActionButton": "阅读更多",
        "RemoveActionLabel": "删除",
        "ReportIssueActionButton": "报告问题",
        "ScrollLeftButtonLabel": "向左滚动",
        "ScrollRightButtonLabel": "向右滚动",
        "SearchFieldPlaceholder": "输入搜索",
        "SearchResultsPluralizedLabel": "结果",
        "ServerErrorToastSubtitle": "服务器错误",
        "ShareToFacebookButtonLabel": "分享到 Facebook 按钮",
        "ShowAllContentLabel": "显示全部",
        "ShowLessLabel": "显示较少",
        "ShowMoreLabel": "显示更多",
        "SkipToMainContentLabel": "跳到主要内容",
        "SliderIndicatorLabel": "转到幻灯片 {0}",
        "SomethingWentWrongContactMessage": "出现问题。如果此问题仍然存在，请联系我们。",
        "SomethingWentWrongMessage": "出了些问题。",
        "SortTypeAlphabeticalAscLabel": "A-Z",
        "SortTypeAlphabeticalDescLabel": "Z-A",
        "SortTypeDefaultLabel": "默认",
        "SortTypeEndingSoonLabel": "即将结束",
        "SortTypeMostDiscussedLabel": "最受讨论",
        "SortTypeMostFundedLabel": "最多资金",
        "SortTypeMostPopularLabel": "最受欢迎",
        "SortTypeNewestLabel": "最新",
        "SortTypeOldestLabel": "最早",
        "SortTypeRecentUpdatesLabel": "最新更新",
        "StablePledgeLogoAltText": "Stable Pledge 标志",
        "StagePaymentStatusTableHeader": "阶段（支付状态）",
        "StretchPayLogoAltText": "Stretch Pay标志",
        "UnauthorizedInsufficientPermissionsMessage": "您无权完成此操作。",
        "UnauthorizedMessage": "您无权执行此操作。",
        "UploadImagesButton": "上传图片",
        "ValidationAlphaDash": "{0}字段可能包含字母数字字符以及连字符和下划线。",
        "ValidationEmail": "{0}字段必须是有效的电子邮件。",
        "ValidationFieldRequired": "该字段是必填项。",
        "ValidationMaxLength": "字段长度不得大于{0}个字符。",
        "ValidationMaxValue": "{0}字段必须为{1}或更少。",
        "ValidationMinLength": "{0}字段必须至少为{1}个字符。",
        "ValidationMinValue": "{0}字段必须为{1}或更多。",
        "ValidationOptionRequired": "请选择其中一个选项。",
        "ViewMoreProjectsLabel": "查看更多项目",
        "WrongOrMissingLocationErrorMessage": "位置错误或丢失。",
        "WrongOrMissingSubLocationErrorMessage": "子位置错误或丢失。",
        "YesLabel": "是"
    },
    "Contact": {
        "AccountProblemContactTopicTitle": "我的账户有问题",
        "AdfoundContactTopicTitle": "我有关于 Adfound 的问题",
        "BusinessContactSectionHeader": "商业联系",
        "CancelRefundContactTopicTitle": "我想取消我的支持/我想退款",
        "ContactCooperationHeader": "合作",
        "ContactCreatorHeader": "创作者",
        "ContactMediaHeader": "媒体",
        "ContactPlatformRelatedHeader": "平台相关",
        "ContactSearchFormDefaultName": "搜索话题",
        "ContactSearchFormDefaultPlaceholder": "开始输入以查找话题...",
        "ContactSearchFormName": "搜索项目",
        "ContactSearchFormPlaceholder": "开始输入以查找项目...",
        "ContactSearchInProgressLabel": "搜索中...",
        "ContactSearchNoResultsParagraph": "未找到匹配结果。",
        "ContactSearchResultByCreatorLabel": "由 {0}",
        "ContactSearchResultsTitle": "搜索结果",
        "ContactSearchSuggestedTitle": "为你推荐的项目",
        "ContactSearchTopicsFormName": "搜索帮助话题",
        "ContactSearchTopicsFormPlaceholder": "开始输入以查找帮助话题...",
        "ContactSelectProjectLink": "点击这里",
        "ContactSelectProjectNotification": "请注意，Gamefound 只是一个由游戏创作者使用的工具。我们不负责游戏的生产和分发。所有与订单和运输相关的问题应向创作者咨询。如果你的问题与特定项目相关，请{0}选择一个项目。",
        "CouldNotSendContactNotificationEmailErrorMessage": "无法发送联系通知邮件。",
        "CreatorAccountProblemContactTopicTitle": "我是创作者，账户或项目有问题",
        "CreatorAnotherContactTopicTitle": "我有另一个想讨论的话题",
        "CreatorCrowdfundingContactTopicTitle": "我想使用 Gamefound 作为众筹平台",
        "CreatorPledgeManagerContactTopicTitle": "我想使用 Gamefound 作为 pledge manager",
        "DifferentProblemContactTopicTitle": "我有其他问题",
        "DifferentQuestionContactTopicTitle": "我有其他问题",
        "FeatureRequestContactTopicTitle": "我有一个功能请求",
        "FormEmailFieldLabel": "你的邮箱地址",
        "FormMessageFieldLabel": "你的信息",
        "FormSubjectFieldLabel": "主题",
        "InfluencerContactTopicTitle": "我是网红",
        "InformationSuggestionContactTopicTitle": "我需要信息/我有一个关于项目的建议",
        "InvalidContactCategoryKeyErrorMessage": "使用了无效的分类键。无法发送联系通知邮件。",
        "JournalistContactTopicTitle": "我是记者",
        "MarketingServicesContactTopicTitle": "我对 Gamefound 的营销服务感兴趣",
        "OfferContactTopicTitle": "我有一个提议",
        "OtherIssuesSectionHeader": "其他问题",
        "PageSubtitle": "如果你对某个特定项目或 Gamefound 的技术问题有任何疑问，请使用下面的指南获取帮助。",
        "PageTitle": "联系我们",
        "PaymentProblemContactTopicTitle": "我的支付有问题",
        "PlatformContactRequestSentText": "我们已收到你的信息，并向你发送了一封邮件副本。",
        "PlatformContactRequestSentTitle": "你的信息已发送！",
        "ProjectContactRequestSentText": "我们已经将你的信息副本发送到你的邮箱。",
        "ProjectContactRequestSentTitle": "你的信息已发送给创作者！",
        "QuestionContactTopicTitle": "我有一个问题",
        "ReCaptchaInvalidTokenErrorMessage": "无效的 reCaptcha 令牌",
        "ReCaptchaMissingTokenErrorMessage": "缺少 reCaptcha 令牌",
        "ReCaptchaVerificationFailedErrorMessage": "我们注意到一些不寻常的活动。你无法发送此消息。",
        "ShippingQuestionContactTopicTitle": "我有一个关于运输的问题",
        "TechnicalProblemContactTopicTitle": "网站技术问题",
        "TopicsSectionHeader": "你需要什么帮助？",
        "TranslationIssueContactTopicTitle": "翻译问题"
    },
    "Cookies": {
        "AcceptCookiesHeader": "Gamefound 使用 cookies",
        "AcceptCookiesParagraph": "我们使用 cookies 以便您正常使用网站，改进其功能并获取用户反馈。",
        "AnalyticCookiesHeader": "分析型 cookies",
        "AnalyticCookiesParagraph": "分析型 cookies 会收集您如何使用我们网站的数据，并监控其性能，以改进我们网站的功能和衡量我们的营销活动的效率，而不会识别您的个人数据。通过使用分析型 cookies，我们可以创建汇总统计数据和分析，帮助我们了解您如何使用我们的网站。这有助于我们快速识别并修复您可能遇到的所有错误，并为您提供高质量的浏览体验。",
        "CookieSettingsUpdatedMessage": "您的 cookie 设置已更新。",
        "PageHeader": "cookie 设置",
        "SettingsBoxHeader": "亲爱的用户",
        "SettingsBoxParagraph": "以下是我们使用的 cookies 信息。请检查您的 cookies 设置，并选择您同意我们使用和安装的 cookies。为了使用我们的网站及其正常运行，必须使用技术型 cookies。",
        "TechnicalCookiesHeader": "技术型 cookies",
        "TechnicalCookiesParagraph": "技术型 cookies 不会收集任何可用于营销目的的信息或记住您在互联网上访问的地方。它们对于正常使用网站是必要的，没有这些 cookies，网站无法使用。"
    },
    "CrowdfundingGuide": {
        "CampaignLaunchSectionHeader": "项目启动",
        "CampaignLaunchSectionParagraph": "在此阶段，项目开始向支持者开放认捐。当你访问项目页面时，可以看到创作者为特定认捐提供的奖励。只要活动仍然活跃，你可以更改你的认捐，添加物品或取消认捐。在活动成功结束之前，你不会被扣款。",
        "CrowdfundingGuideMetaDescription": "众筹的概念可以与预购相比较，但它是一种特殊的预购方式。在众筹中，你可以影响产品，并决定用多少资金来支持它。你出的越多，得到的也越多",
        "CrowdfundingGuidePageTitle": "什么是众筹？",
        "ExplainingStepsSectionHeader": "解释所有步骤",
        "ExplainingStepsSectionItem1Header": "认捐",
        "ExplainingStepsSectionItem1Paragraph": "哈哈，你想支持一个项目。要做到这一点，你必须认捐。那是什么意思？认捐是指在众筹活动成功结束后，你将支付所承诺金额的一种承诺。让我们来认捐吧！你可以在众筹网站的主页上找到所有的认捐选项（奖励）。一旦你选取了一个奖励并声明了你要支持的金额，你将被要求提供支付信息（通常是借记卡/信用卡详细信息）。就这么简单。只有在活动达到目标（或超过目标）的情况下，你才会被扣款。",
        "ExplainingStepsSectionItem2Header": "目标及扩展目标",
        "ExplainingStepsSectionItem2Paragraph": "当项目启动时，创作者会声明其目标——实现项目所需的资金数额。当目标达到时，支持者的认捐将被扣款。但是，达到活动的目标并不是众筹的结束。此时扩展目标就会登场。扩展目标是活动的额外目标。它们包括免费赠品、扩展、新的质量提升等。每个扩展目标都是为了满足一个阈值，通常是支持者数量或达到特定的资金水平。",
        "ExplainingStepsSectionItem3Header": "附加物品",
        "ExplainingStepsSectionItem3Paragraph": "除了奖励外，你还可以向认捐中添加不同的物品。创作者有时会提供附加物品，如粉丝物品、游戏扩展和类似袖套、游戏垫之类的小工具。这些物品通常不包含在奖励中，但可以独立添加。它们通常不是完全体验奖励所必需的，但有些可以肯定为产品提供额外的乐趣。",
        "ExplainingStepsSectionItem4Header": "配送",
        "ExplainingStepsSectionItem4Paragraph": "你已经认捐了一个项目并添加了支付信息，但没人问你的地址，为什么？因为从认捐到配送的路程可能很长。支持者会在认捐管理阶段提供这些信息，而不是在众筹阶段，因为很多事情可能会在此期间发生。配送成本在认捐管理阶段之前定义。",
        "ExplainingStepsSectionItem5Header": "后期认捐",
        "ExplainingStepsSectionItem5Paragraph": "一旦活动成功结束，创作者可以在众筹阶段之后启用继续支持项目的选项。在此阶段，配送成本可能尚未定义，但支持者可以继续为已筹资的项目贡献资金，通常可以获得相同或类似的奖励。",
        "ExplainingStepsSectionItem6Header": "认捐管理器",
        "ExplainingStepsSectionItem6Paragraph": "认捐管理器由创作者在履行成本明确后启用。在认捐管理器中，你可以选择和管理你的认捐内容。你还可以添加更多物品。除此之外，认捐管理器是在这里你提供配送详细信息，选择配送方式并为其付费。",
        "ExplainingStepsSectionItem7Header": "风险",
        "ExplainingStepsSectionItem7Paragraph": "众筹并不像商店。你不会在认捐后立即收到产品。在众筹中，创建产品的过程需要时间，因为社区会影响其最终形式。记住，创作者对项目负责，我们在这里是为了助力众筹过程。你可以随时直接联系创作者，询问你对活动的任何问题。有可能活动无法达到目标。如果是这种情况，你不会失去任何东西，因为如果活动失败，支持者不会被扣款。",
        "GamefoundDefinitionSectionHeader": "Gamefound不是商店",
        "GamefoundDefinitionSectionParagraph": "记住，捐助并不意味着购买。一个项目不是你可以买到的商品，而是一个可以变为现实的想法。支持者可以支持它以使其成为现实，然后获得奖励。简言之，你在为一个可能成真的想法贡献。",
        "IntroductorySectionParagraph1": "众筹的概念可以与预购相比较，但它是一种特殊的预购方式。在众筹中，你可以影响最终产品的结果，并决定用多少资金来支持它。你出的越多，得到的也越多。",
        "IntroductorySectionParagraph2": "众筹基于一个想法。创作者将其分享给社区以获得其在资金和实现方面的支持。它变成了一个集体项目，所有人对项目的最终形式都有发言权。创作者不仅能够确定他们的构想是否有受众，还能了解受众的意见如何影响这个想法。",
        "IntroductorySectionParagraph3": "众筹平台不是商店。它是一个创作者可以向社区展示他们的想法的地方，不一定展示最终产品，因为其形式可能会随着时间的推移而改变。在众筹的情况下，支持者对产品的最终形式有真正的影响。",
        "IntroductorySectionParagraph4": "你通过认捐支持项目，创作者会为你的贡献提供回报。你选择那些你认为最感兴趣的认捐选项。项目的内容在项目页面上进行了描述。认捐越高，为项目贡献越多，你获得的奖励也越多。许多这些奖励可能是有限的，代表某种程度的独家物品、早期访问、更低价格以及许多其他令人信服的支持项目的理由，除了参与旅程和过程中的发言权。一旦你认捐，你就成为了一个支持者。",
        "PageHeader": "什么是众筹？",
        "PlatformDefinitionSectionHeader": "Gamefound不是商店",
        "PlatformDefinitionSectionParagraph": "记住，认捐不等于购买。一个项目不是你可以买的商品，而是一个可以实现的想法。支持者可以认捐使其成为现实，然后获得奖励。简言之，你在为一个可能实现的想法贡献。",
        "ProjectPreviewSectionHeader": "项目预览",
        "ProjectPreviewSectionParagraph": "在众筹活动启动之前，创作者可以创建一个预览并从社区收集反馈。在此期间，项目初步展示给支持者。预览让创作者有时间作出调整，所以记住你看到的可能与最终版本大不相同。你现在还不能认捐项目，但可以接收其启动通知。"
    },
    "Faq": {
        "FaqDisabledCreatorMessage": "用户无法查看您的项目的常见问题页面，因为它当前被禁用。请通过 business@gamefound.com 联系我们以启用常见问题页面。",
        "FaqDisabledUserMessage": "创建者尚未启用常见问题部分。",
        "FaqPageHeader": "常见问题",
        "FaqSectionNotFoundMessage": "找不到请求的常见问题部分。",
        "FaqUserEmptyStateButton": "联系创建者",
        "FaqUserEmptyStateParagraph": "稍后再查看或直接联系创建者。",
        "FaqUserEmptyStateTitle": "创建者尚未在常见问题部分添加任何内容",
        "FeedbackFormParagraph": "这些信息对您有帮助吗？",
        "NegativeFeedbackSubmittedParagraph": "很抱歉没有帮助到您。感谢您的反馈。这将帮助创建者建立一个更好的常见问题。查看其他答案或 {0} 联系创建者。",
        "PositiveFeedbackSubmittedParagraph": "感谢您的反馈！我们会将其传达给 {0} 的创建者。",
        "SearchFaqTopicsLabel": "在常见问题中搜索",
        "SearchFaqTopicsPlaceholder": "开始输入以查看搜索结果..."
    },
    "Footer": {
        "CreatorsLinksColumnHeader": "Creators",
        "LanguageVersionLinksColumnHeader": "查看 Gamefound 翻译",
        "NavigationSectionHeader": "页脚导航",
        "PlatformLinksColumnHeader": "平台"
    },
    "Homepage": {
        "ActiveSectionSeeMore": "查看所有活跃项目",
        "ActiveSectionSubtitle": "查看所有可支持的众筹活动和pledge manager",
        "ActiveSectionTitle": "活跃",
        "BecomeACreatorButton": "开始你的活动",
        "BecomeACreatorStatsBackersLabel": "Backers",
        "BecomeACreatorStatsCreatorsLabel": "Creators",
        "BecomeACreatorStatsProjectsLabel": "项目",
        "BecomeACreatorStatsValueLabel": "筹集金额",
        "BecomeACreatorStatsValueTooltip": "总金额以月平均汇率计算的欧元值。",
        "BecomeACreatorValuesTypedText1": "我们连接全球的桌游玩家",
        "BecomeACreatorValuesTypedText2": "我们加速创造出色的桌游",
        "CreatorBenefitAdvancedCrowdfundingTechnologyCaption": "为Backers和Creators提供最佳功能。",
        "CreatorBenefitAdvancedCrowdfundingTechnologyTitle": "最先进的众筹技术",
        "CreatorBenefitAnalyticsTitle": "广泛的分析",
        "CreatorBenefitAnalyticsTooltip": "你可以将Facebook Pixel和Google Analytics追踪添加到项目中，查看所有相关信息。我们还提供专属的推荐系统。",
        "CreatorBenefitCommunityCaption": "数百万Backers寻找令人兴奋的项目。",
        "CreatorBenefitCommunityTitle": "庞大的社区",
        "CreatorBenefitCommunityTooltip": "数百万Backers寻找令人兴奋的项目",
        "CreatorBenefitCrowdfundingTitle": "带有pledge manager的众筹",
        "CreatorBenefitCrowdfundingTooltip": "由于众筹与pledge manager的无缝过渡，你不需要导入项目。",
        "CreatorBenefitFeaturesTitle": "定制化功能",
        "CreatorBenefitFeaturesTooltip": "内置的伸展目标、附加内容、追随者礼物设置，项目页面间的简易导航只是我们提供的一些功能。",
        "CreatorBenefitFeedbackTitle": "反馈",
        "CreatorBenefitFeedbackTooltip": "我们不断寻找Creators和Backers需要的功能创意，也会分享我们的经验以确保您的活动蓬勃发展。",
        "CreatorBenefitGrowthTitle": "平台成长",
        "CreatorBenefitGrowthTooltip": "我们动态发展，定期为Backers和Creators引入新的有用功能。",
        "CreatorBenefitMarketingTitle": "营销",
        "CreatorBenefitMarketingTooltip": "我们的内部营销机构可以帮助您进行外部推广，例如在Facebook或BGG上。所有内部推广（新闻通讯、顶部横幅、主页特色展示）都是免费的。",
        "CreatorBenefitOneSolutionCaption": "Pledge Manager、Late Pledge、先进的营销、分析等一体化解决方案！",
        "CreatorBenefitOneSolutionTitle": "一体化解决方案",
        "CreatorBenefitPaymentsCaption": "最先进的众筹结账系统。",
        "CreatorBenefitPaymentsTitle": "20+ 种安全支付方式",
        "CreatorBenefitPaymentsTooltip": "我们的支付运营商Adyen保证完全符合PCI DS 3.2标准。您和您的Backers的钱完全安全。",
        "CreatorBenefitPricingTitle": "具竞争力的价格",
        "CreatorBenefitPricingTooltip": "您需支付从募集金额中扣除的基础众筹费用和支付处理费用。如果您的项目未融资成功，则不需支付任何费用。",
        "CreatorBenefitServicesTitle": "可靠的服务",
        "CreatorBenefitServicesTooltip": "我们有专门的技术团队负责Gamefound的技术保障、效率和可靠性。",
        "CreatorBenefitSupportTitle": "个性化支持",
        "CreatorBenefitSupportTooltip": "当您需要帮助时，可以通过我们的联系页面轻松找到我们。",
        "CreatorBenefitVATTitle": "欧盟/英国VAT处理",
        "CreatorBenefitVATTooltip": "Gamefound为来自欧盟和英国以外的Creators处理并结算VAT。",
        "CrowdfundingProjectsActionLabel": "查看众筹项目",
        "CrowdfundingProjectsSectionTitle": "众筹",
        "ExploreSectionTitle": "探索",
        "ExploreSegmentActive": "活跃",
        "ExploreSegmentEndingSoon": "即将结束",
        "ExploreSegmentForYou": "为你推荐",
        "ExploreSegmentInstallments": "接受Stretch Pay",
        "ExploreSegmentYouMayLike": "你可能喜欢",
        "FeaturedSectionSeeMore": "探索更多",
        "FeaturedSectionTitle": "精选",
        "FollowProjectSuccessToast": "你已关注 {0}。",
        "FundedSectionSeeMore": "查看所有已资助项目",
        "FundedSectionSubtitle": "关注最近资助成功的项目，以获取他们进展的通知。",
        "FundedSectionTitle": "已资助",
        "HeroBannerBadgeLabel": "加入 {0}",
        "HeroBannerFundedAmountLabel": "已筹集 {0}",
        "HeroBannerPluralizedBackers": "{n} 位backer|{n} 位backers",
        "HeroBannerStretchGoalUnlockedCountLabel": "{0} / {1} 个伸展目标已解锁",
        "HideAdvertBannerButton": "隐藏此通知",
        "LatePledgeProjectsActionLabel": "查看Late Pledge项目",
        "LatePledgeProjectsSectionTitle": "Late Pledge",
        "MostDiscussedSectionTitle": "讨论最多",
        "MostFundedSectionTitle": "筹资最高",
        "MostPopularUpcomingSectionTitle": "最受欢迎的预告",
        "NewOnThePlatformSectionTitle": "Gamefound新品",
        "PledgeManagerLimitedNoNewOrdersTooltip": "只有特定的Backers可以访问pledge manager。",
        "PledgeManagerLimitedShippingOnlyTooltip": "只有特定的Backers可以添加运送详细信息。",
        "PledgeManagerLimitedWithNewOrdersTooltip": "只有特定的Backers可以访问pledge manager。",
        "PledgeManagerOpenNoNewOrdersTooltip": "只有Backers可以访问pledge manager。",
        "PledgeManagerOpenShippingOnlyTooltip": "Backers只能添加运送详细信息。",
        "PreordersSectionTitle": "预购",
        "ProjectCardAgePropertyLabel": "适宜年龄",
        "ProjectCardBenefitsPropertyLabel": "福利",
        "ProjectCardByCreatorLabel": "由 {0}",
        "ProjectCardCrowdfundingActivePhaseLabel": "众筹",
        "ProjectCardCrowdfundingDraftPhaseLabel": "即将上线",
        "ProjectCardCrowdfundingEndedCanceledPhaseLabel": "众筹 - 取消",
        "ProjectCardCrowdfundingEndedFailedPhaseLabel": "众筹 - 未成功",
        "ProjectCardCrowdfundingEndedSuccessPhaseLabel": "众筹 - 成功筹资",
        "ProjectCardExpressCrowdfundingActivePhaseLabel": "快速众筹",
        "ProjectCardFollowButtonLabel": "关注",
        "ProjectCardFollowWithGiftCaption": "{0} 将添加到你的pledge中。",
        "ProjectCardFollowWithGiftTextPart1": "{0} 关注以在上线时获得 {1}。",
        "ProjectCardFollowWithGiftTextPart2": "关注",
        "ProjectCardFollowWithNoGiftCaption": "加入 {0} 名追随者。",
        "ProjectCardFollowWithNoGiftTextPart1": "{0} 以保持参与。",
        "ProjectCardFollowWithNoGiftTextPart2": "关注",
        "ProjectCardFundingAmountPledgedCaption": "已筹款",
        "ProjectCardFundingGoalPercentageTooltip": "活动已筹集目标的 {0}%。",
        "ProjectCardFundingGoalReachedInCaption": "目标达成于 {0}",
        "ProjectCardFundingTotalCaption": "总筹资",
        "ProjectCardFundingTotalTooltip": "在活动期间和之后筹集的所有资金。",
        "ProjectCardIsFollowingCaption": "您将收到它的进展通知。",
        "ProjectCardIsFollowingText": "您正在关注此项目。",
        "ProjectCardLatePledgeEndedPhaseLabel": "Late Pledge - 已结束",
        "ProjectCardLatePledgeOpenPhaseLabel": "Late Pledge - 对所有人开放",
        "ProjectCardLaunchedLabel": "已启动！",
        "ProjectCardLaunchingInLabel": "即将启动：",
        "ProjectCardPlayersPropertyLabel": "玩家人数",
        "ProjectCardPlaytimeHoursText": "{0} 小时",
        "ProjectCardPlaytimeMinutesText": "{0} 分钟",
        "ProjectCardPlayTimePropertyLabel": "游戏时间",
        "ProjectCardPledgeManagerClosedPhaseLabel": "Pledge manager - 已关闭",
        "ProjectCardPledgeManagerLimitedPhaseLabel": "Pledge manager - 受限",
        "ProjectCardPledgeManagerOpenPhaseLabel": "Pledge manager - 对所有人开放",
        "ProjectCardPluralizedCoCreator": "共同创作者",
        "ProjectCardPreorderPhaseLabel": "预购",
        "ProjectCardPromoItemDiscountLabel": "折扣",
        "ProjectCardPromoItemGiftLabel": "礼物",
        "ProjectCardStablePledgeTooltip": "此项目属于Stable Pledge计划。这意味着Creator承诺如果pledge的最终成本增加超过10%，将提供全额退款。",
        "ProjectCardStorePhaseLabel": "商店",
        "ProjectCardStretchPayTooltip": "此项目接受分期付款。如果您的付款超过 {0}，您可以分 {1} 个月支付。",
        "ProjectCardTagPropertyLabel": "标签",
        "ProjectCardToggleDetailsLabel": "切换详情",
        "ProjectCardUnfollowButtonLabel": "取消关注",
        "ProjectListAllSegmentTitle": "全部",
        "ProjectListAllTimeSegmentTitle": "所有时间",
        "ProjectListComingSoonSegmentTitle": "即将推出",
        "ProjectListGlobalTagsTitle": "标签",
        "ProjectListItemTypeCrowdfundingTitle": "众筹",
        "ProjectListItemTypeInstallmentsTitle": "接受 Stretch Pay",
        "ProjectListItemTypeLatePledgeTitle": "Late Pledge",
        "ProjectListItemTypeSoloModeTitle": "单人模式",
        "ProjectListItemTypeStoresAndPreordersTitle": "预购 & 商店",
        "ProjectListItemTypeTtrpgTitle": "TTRPG",
        "ProjectListItemTypeUpcomingTitle": "即将推出",
        "ProjectListLatePledgeSegmentTitle": "Late Pledge",
        "ProjectListMostFundedSegmentTitle": "资金最多",
        "ProjectListMostPopularSegmentTitle": "最受欢迎",
        "ProjectListNewSegmentTitle": "新项目",
        "ProjectListPopularTagsTitle": "热门标签",
        "ProjectListsSectionTitle": "项目列表",
        "ProjectListTrendingSegmentTitle": "流行趋势",
        "RankingsAllCategoriesOption": "所有类别",
        "RankingsAllTimeTimeSpanOption": "所有时间",
        "RankingsAudienceCategoryOption": "按受众",
        "RankingsAudienceTypeLabel": "受众",
        "RankingsCategorySelectLabel": "选择类别",
        "RankingsFundingCategoryOption": "按资助",
        "RankingsFundingTypeLabel": "资助",
        "RankingsLast24HoursTimeSpanOption": "最近24小时",
        "RankingsLast30DaysTimeSpanOption": "最近30天",
        "RankingsLast7DaysTimeSpanOption": "最近7天",
        "RankingsSectionTitle": "排名",
        "RankingsSortTypeSelectLabel": "选择排序类型",
        "RankingsTimeSpanSelectLabel": "选择时间跨度",
        "RecentlyAddedUpdatesSectionTitle": "最近新增更新",
        "SpotlightSectionTitle": "聚焦",
        "StartCampaignBoxActionLabel": "启动",
        "StartCampaignBoxDescription": "分享你的项目，确保资金，并建立社区。",
        "StartCampaignBoxHeader": "开始你的活动",
        "UnfollowProjectSuccessToast": "您已取消关注 {0}。",
        "UnfollowProjectWarningText": "您即将取消关注此活动。如果现在取消关注，您将无法在以后支持该项目时领取免费礼物。您真的要取消关注吗？",
        "UnfollowProjectWarningTitle": "警告",
        "UpcomingProjectsActionLabel": "查看即将推出的项目",
        "UpcomingSectionSeeMore": "查看所有即将推出的项目",
        "UpcomingSectionSubtitle": "探索并关注项目，了解最新动态。",
        "UpcomingSectionTitle": "即将推出"
    },
    "JoinProject": {
        "ContinueToProjectHomeButton": "继续访问项目主页",
        "CreatorEmailCommunicationConsentLabel": "我同意接收该创作者的电子邮件",
        "CreatorEmailCommunicationConsentTooltip": "通过勾选此项，表示您同意 {0} 可以使用您的电子邮件地址针对该项目进行平台外的沟通。",
        "CreditsGrantedToAccountParagraph": "{0} 的创作者已为您的账户授予了 {1} 积分可用于您的支持。",
        "DiscardPledgeCreatedByCreatorOption": "不，我想重新开始",
        "KeepPledgeCreatedByCreatorOption": "是的，我想保留这个",
        "ManageYourPledgeHeader": "您被邀请管理在 {0} 的支持！",
        "ManageYourPledgeParagraph": "{0} 的创作者邀请您管理您的支持。您的支持从您之前所支持的平台导入到 Gamefound，您可以在这里根据需要进行修改或添加。",
        "PledgeCreatedByCreatorFollowUpParagraph": "您想保留此支持，还是重新开始选取其他产品？",
        "PledgeCreatedByCreatorIntro": "{0} 的创作者为您设置了以下支持：",
        "ViewYourPledgeButton": "查看您的支持",
        "WelcomeToPledgeManagerHeader": "您已加入 {0} 的支持管理系统！"
    },
    "Layout": {
        "AboutUsLink": "关于我们",
        "ActionRequiredSectionTitle": "需要操作",
        "ActivitySectionTitle": "活动",
        "ActivitySectionTriggerLabel": "活动",
        "BecomeACreatorLink": "成为创作者",
        "BecomeACreatorPageTitle": "成为创作者",
        "BlogLink": "博客",
        "BrowserNotSupportSharingFeatureText": "您的浏览器不支持分享功能",
        "CareerLink": "职业",
        "CartBoxCheckoutButton": "结账",
        "CartBoxEmptyPledge": "您的认捐为空",
        "CartBoxItemQuantity": "数量：{0}",
        "CartBoxModifyText": "您正在修改认捐 {0}",
        "CartBoxMultiplePledgesText": "您在 {0} 个项目中有购物车\n",
        "CartBoxMultiplePledgesTitle": "您当前的认捐",
        "CartBoxNoPledgesTitle": "您的认捐",
        "CartBoxTotalItemsQuantity": "项目：{0}",
        "CartBoxTriggerLabel": "购物车",
        "CartBoxViewAllButton": "查看全部",
        "CartBoxViewCartButton": "查看您的认捐",
        "CartBoxViewPledgesButton": "查看认捐",
        "CommunicationPreferencesLink": "通讯偏好",
        "ContactLink": "联系",
        "CookieSettingsLink": "Cookie 设置",
        "CreatorProjectsHeader": "创作者 {0}",
        "CreatorProjectsHeaderPluralizedProject": "project|projects",
        "CrowdfundingGuideLink": "众筹指南",
        "DismissActionButtonText": "忽略",
        "EndingInLabel": "结束于",
        "EnterpriseSolutionsLink": "企业解决方案",
        "FeesLink": "费用",
        "FeesPageTitle": "费用",
        "FooterNavigationSectionTitle": "导航",
        "FooterTitle": "页脚设置和导航",
        "HeaderLoginLink": "登录",
        "HeaderSignupLink": "注册",
        "HelpLink": "帮助",
        "HideThisMessageButton": "隐藏此消息",
        "ImageFieldDropOrSelectLabel": "将您的图片拖放到此处或从磁盘中选择",
        "ImageFieldSelectLabel": "从磁盘中选择图片",
        "ImageFieldStandardFormatsAcceptedLabel": "接受标准图片格式",
        "InLabel": "在",
        "LanguageDropdownReportTranslationIssueLink": "报告翻译错误",
        "LanguageDropdownReportTranslationIssueParagraph": "平台翻译（测试版）由 AI 提供。帮助我们改进：{0}",
        "LanguageSelectorModalDescription": "您将看到此平台界面翻译成所选语言。如果创作者添加了该语言的项目翻译，它也会自动显示给您。",
        "LanguageSelectorModalInformation": "平台的翻译由 AI 提供。如果您在您的语言中发现任何错误，可以报告翻译问题。注意：项目内容、描述和奖励由创作者翻译。如果项目翻译有任何问题，请联系创作者。",
        "LanguageSelectorModalLabel": "平台语言",
        "LanguageSelectorModalTitle": "选择平台语言",
        "LanguageSelectorTriggerLabel": "语言",
        "MarketingServicesLink": "营销服务",
        "MarketingServicesPageTitle": "营销服务",
        "ModalCancelButton": "取消",
        "ModalSaveButton": "保存",
        "NavigationMenuTriggerLabel": "导航菜单",
        "NotificationCenterTitle": "通知中心",
        "PerformanceMarketingLink": "Adfound 营销",
        "PerformanceMarketingPageTitle": "Adfound 营销",
        "PrivacyPolicyLink": "隐私政策",
        "PrivacySettingsLink": "隐私设置",
        "PushNotificationDenyButton": "以后再说",
        "PushNotificationEnableButton": "启用通知",
        "PushNotificationModalDeniedText": "您的浏览器设置目前阻止了推送通知。请参阅我们的帮助中心了解如何启用它们。",
        "PushNotificationModalText": "启用通知，以接收您支持和关注的项目的所有重要更新。",
        "PushNotificationModalTitle": "不漏过任何消息！",
        "SearchFormEmptyState": "抱歉，我们没有找到任何内容。尝试更改您的搜索。",
        "SearchFormPlaceholder": "输入搜索",
        "SearchFormResultsCreatorsCountLabel": "创作者：",
        "SearchFormResultsProjectsCountLabel": "项目：",
        "SearchFormSearchButtonLabel": "搜索",
        "SearchFormViewMoreLink": "查看更多",
        "SeenLabel": "已查看",
        "ShareActionText": "在 Gamefound 上查看",
        "TermsOfServiceLink": "服务条款",
        "ThemeSelectorBrightOptionLabel": "明亮",
        "ThemeSelectorDarkOptionLabel": "黑暗",
        "ThemeSelectorLabel": "颜色主题",
        "ThemeSelectorSystemOptionLabel": "系统",
        "UnseenLabel": "新",
        "UserBoxAdminLink": "进入管理区域",
        "UserBoxCommunicationPreferencesLink": "通讯偏好设置",
        "UserBoxDisableTestModeButton": "退出测试模式",
        "UserBoxEnableTestModeButton": "进入测试模式",
        "UserBoxImpersonatingLabel": "模仿",
        "UserBoxLogoutButton": "登出",
        "UserBoxMyAccountLink": "用户设置",
        "UserBoxPaymentsLink": "支付",
        "UserBoxPlatformLink": "前往 Gamefound",
        "UserBoxPledgesAndOrdersLink": "认捐与订单",
        "UserBoxProfileLink": "用户资料",
        "UserBoxProjectsLink": "您的项目",
        "UserBoxRevertImpersonationButton": "恢复",
        "UserBoxTriggerLabel": "用户菜单",
        "UserBoxUpdatesFeedLink": "更新动态",
        "UserBoxYourDashboardLink": "您的仪表盘",
        "UserLocationBarDisabledDescription": "这是您认捐的交付地点。如需更新，请编辑您的认捐。",
        "UserLocationBoxButtonLabel": "更改位置",
        "UserLocationModalConfiration": "位置已保存",
        "UserLocationModalFieldsetHeading": "交付至",
        "UserLocationModalInformation": "您下单的地点。这将用于计算税金并向您展示专供您位置的库存。",
        "UserLocationModalLocationFieldPlaceholder": "选择国家",
        "UserLocationModalSubLocationFieldPlaceholder": "选择州",
        "UserLocationModalTitle": "选择您的位置",
        "VideoFieldDropOrSelectLabel": "将您的视频拖放到此处或从磁盘中选择",
        "VideoFieldSelectLabel": "从磁盘中选择视频",
        "WebPushAdjustPreferencesParagraph": "您可以随时在以下位置调整您的偏好",
        "WebPushBlockedParagraph": "浏览器设置目前阻止了推送通知。请参阅我们的帮助中心了解如何启用它们。",
        "WebPushConfirmationSuccessMessage": "通知已启用。",
        "WebPushDeliveryTimeElapsedLabel": "{0} {1} 前",
        "WebPushEmptyStateParagraph": "没有通知显示。当您关注或支持项目时，更新会出现在这里。",
        "WebPushEnableButton": "启用推送通知",
        "WebPushEnableParagraph": "通过启用推送通知，随时了解 Gamefound 上的最新活动和更新。",
        "WebPushHowToUnblockLink": "阅读说明",
        "WebPushLabel": "通知",
        "WebPushNotSupportedErrorMessage": "浏览器不支持推送通知",
        "WebPushUnaothorizedUserParagraph": "通知仅对登录用户可用。",
        "WeDoNotSellYourDataLink": "我们不出售您的数据",
        "WepPushDeliveryNowLabel": "现在",
        "WhyGamefoundLink": "为什么选择 Gamefound？",
        "WhyGamefoundMetaDescription": "从资金筹集到履行，Gamefound 为您的活动提供强大工具、专家见解和热情社区——让您的活动走得更远。",
        "WhyGamefoundPageTitle": "为什么选择 Gamefound？"
    },
    "OrderStatus": {
        "AwaitingPaymentStatusParagraph": "订单尚未付款。",
        "FinishPledgeButton": "结账",
        "NotificatorPartiallyPaidMessage": "您已支付部分订单。请移除未付款商品或支付剩余款项。",
        "NotificatorPledgeNotFinishedMessage": "您的订单未完成。",
        "NotificatorProblemWithCollectingInstallmentsMessage": "收取分期付款时出现问题。详情如下。",
        "NotificatorShippingAddressMissingMessage": "需要您的送货地址来完成订单。",
        "OrderAwaitingPaymentStatusParagraph": "订单尚未付款。",
        "OrderPaidStatusParagraph": "订单已全部付款。",
        "OrderPartiallyPaidStatusParagraph": "订单部分付款。",
        "OrderPaymentStatusAwaitingPaymentDescription": "订单尚未付款。",
        "OrderPaymentStatusAwaitingPaymentName": "待付款",
        "OrderPaymentStatusAwaitingPaymentRetailDescription": "订单尚未付款。",
        "OrderPaymentStatusCanceledName": "已取消",
        "OrderPaymentStatusNoneName": "无",
        "OrderPaymentStatusPaidDescription": "订单已全部付款。",
        "OrderPaymentStatusPaidName": "已付款",
        "OrderPaymentStatusPaidRetailDescription": "订单已全部付款。",
        "OrderPaymentStatusPartiallyPaidDescription": "订单部分付款。",
        "OrderPaymentStatusPartiallyPaidName": "部分付款",
        "OrderPaymentStatusPartiallyPaidRetailDescription": "订单部分付款。",
        "OrderPaymentStatusPaymentErrorName": "付款错误",
        "OrderPaymentStatusProcessingPaymentDescription": "订单付款处理中。",
        "OrderPaymentStatusProcessingPaymentName": "付款处理中",
        "OrderPaymentStatusScheduledAndAwaitingPaymentDescription": "订单按分期付款计划收取。众筹后添加到订单的产品仍需付款。",
        "OrderPaymentStatusScheduledAndAwaitingPaymentName": "计划和待付款",
        "OrderPaymentStatusScheduledAndAwaitingPaymentRetailDescription": "订单按分期付款计划收取。下单后新增的产品仍待付款。",
        "OrderPaymentStatusScheduledDescription": "订单按分期付款计划收取。",
        "OrderPaymentStatusScheduledName": "计划付款",
        "OrderPaymentStatusScheduledRetailDescription": "订单按分期付款计划收取。",
        "OrderStageCanceledName": "已取消",
        "OrderStageCompletedName": "已完成",
        "OrderStageEditedByCreatorName": "由创始人编辑",
        "OrderStageHistoryNoteForDigitalCodes": "您的数字代码将通过单独的电子邮件发送。",
        "OrderStagePartiallyShippedName": "部分发货",
        "OrderStagePlacedName": "已下单",
        "OrderStagePledgedName": "已承诺",
        "OrderStagePreparingForShippingName": "准备发货",
        "OrderStageReadyForShippingName": "准备发货",
        "OrderStageShippedName": "已发货",
        "OrderStageUnfinishedName": "未完成（购物车）",
        "OrderStatusExplanationAllSetHeader": "目前一切都准备好了！",
        "OrderStatusExplanationCrowdfundingEndedPaymentPaidNextStepParagraph": "等待项目开放迟到认捐或启动承诺管理器。在迟到认捐中，您可以修改订单内容。在承诺管理器中，您可以编辑其内容并结算运费。",
        "OrderStatusExplanationCrowdfundingEndedPaymentPaidParagraph": "您的付款已成功收取。",
        "OrderStatusExplanationCrowdfundingEndedPaymentScheduledInstallmentsParagraph": "您的付款按照分期计划收取。",
        "OrderStatusExplanationCrowdfundingExpressScheduledHeader": "您的订单按分期付款计划收取。",
        "OrderStatusExplanationCrowdfundingNoPaymentHeader": "您已成功认捐！",
        "OrderStatusExplanationCrowdfundingNoPaymentNextStepParagraph": "等待活动结束。",
        "OrderStatusExplanationCrowdfundingNoPaymentParagraph": "关注项目更新。",
        "OrderStatusExplanationCrowdfundingPaidNextStepParagraph": "等待活动结束。",
        "OrderStatusExplanationCrowdfundingPaymentPaidParagraph": "您的付款已成功收取。您现在可以自由修改订单。",
        "OrderStatusExplanationCrowdfundingPaymentScheduledInstallmentsNextStepParagraph": "等待活动结束。活动成功结束后，您将按分期计划支付。",
        "OrderStatusExplanationCrowdfundingPaymentScheduledInstallmentsParagraph": "您选择了Stretch Pay并成功验证了支付方式。尚未收费。",
        "OrderStatusExplanationExpressCrowdfundingPaidNextStepParagraph": "创始人将在准备好后发货。",
        "OrderStatusExplanationExpressCrowdfundingPaymentPaidParagraph": "您的订单已成功收费。关注项目更新以了解进展和发货时间。",
        "OrderStatusExplanationExpressCrowdfundingPaymentScheduledParagraph": "关注项目更新以了解进展和发货时间。",
        "OrderStatusExplanationExpressCrowdfundingScheduledNextStepParagraph": "一旦所有分期付款完成，创始人将发货。",
        "OrderStatusExplanationLatePledgeEndedNextStepParagraph": "等待项目启动承诺管理器。在承诺管理器中，您可以编辑订单内容并结算运费。",
        "OrderStatusExplanationLatePledgeNoPaymentHeader": "您已成功认捐！",
        "OrderStatusExplanationLatePledgeNoPaymentNextStepParagraph": "等待项目启动承诺管理器。启动后，添加送货地址并结算运费。",
        "OrderStatusExplanationLatePledgeNoPaymentParagraph": "关注项目更新。",
        "OrderStatusExplanationLatePledgePaymentPaidNextStepParagraph": "等待项目启动承诺管理器。启动后，添加送货地址并结算运费。",
        "OrderStatusExplanationLatePledgePaymentPaidParagraph": "您的付款已成功收取。您现在可以自由修改订单。",
        "OrderStatusExplanationLatePledgePaymentScheduledInstallmentsNextStepParagraph": "等待项目启动承诺管理器。启动后，添加送货地址并结算运费。",
        "OrderStatusExplanationLatePledgePaymentScheduledInstallmentsParagraph": "您的付款按分期计划收取。您现在可以自由修改订单。",
        "OrderStatusExplanationPaymentNoneNextStepParagraph": "等待活动结束。活动成功结束后，您将按分期计划支付。",
        "OrderStatusExplanationPaymentNoneParagraph": "您的付款方式已验证以确保其有效性，但尚未收费。",
        "OrderStatusExplanationPledgeManagerCompletedHeader": "创始人已完成您的订单。",
        "OrderStatusExplanationPledgeManagerCompleteNextStepParagraph": "创始人将在准备好后发货。",
        "OrderStatusExplanationPledgeManagerNoPaymentHeader": "您已成功认捐！",
        "OrderStatusExplanationPledgeManagerNoPaymentNextStepParagraph": "创始人将在准备好后发货。",
        "OrderStatusExplanationPledgeManagerNoPaymentParagraph": "关注项目更新以了解进展和发货时间。",
        "OrderStatusExplanationPledgeManagerPartiallyShippedHeader": "您的一部分订单已发货。",
        "OrderStatusExplanationPledgeManagerPartiallyShippedNextStepParagraph": "您将会在下一个发货波中收到剩余的订单。",
        "OrderStatusExplanationPledgeManagerPartiallyShippedParagraph": "订单正在运送中！等待收货并享用 :)",
        "OrderStatusExplanationPledgeManagerPaymentPaidHeader": "您的付款已成功收取！",
        "OrderStatusExplanationPledgeManagerPaymentPaidNextStepParagraph": "创始人将在准备好后发货。",
        "OrderStatusExplanationPledgeManagerPaymentPaidParagraph": "关注项目更新以了解进展和发货时间。",
        "OrderStatusExplanationPledgeManagerPaymentScheduledHeader": "您的订单按分期付款计划收取。",
        "OrderStatusExplanationPledgeManagerPaymentScheduledNextStepParagraph": "创始人将在准备好后发货。",
        "OrderStatusExplanationPledgeManagerPaymentScheduledParagraph": "关注项目更新以了解进展和发货时间。",
        "OrderStatusExplanationPledgeManagerPreparingForShippingCanAddNewItemsHeader": "创始人允许添加新商品，但无法移除商品或更改送货地址。",
        "OrderStatusExplanationPledgeManagerPreparingForShippingCanAddNewItemsNextStepParagraph": "创始人将在准备好后发货。",
        "OrderStatusExplanationPledgeManagerPreparingForShippingCanAddNewItemsParagraph": "关注项目更新以了解发货时间。",
        "OrderStatusExplanationPledgeManagerPreparingForShippingHeader": "您的订单正在准备发货。",
        "OrderStatusExplanationPledgeManagerPreparingForShippingNextStepParagraph": "创始人将在准备好后发货。",
        "OrderStatusExplanationPledgeManagerPreparingForShippingParagraph": "关注项目更新以了解发货时间。",
        "OrderStatusExplanationPledgeManagerPreparingShippingHeader": "您的订单正在准备发货。",
        "OrderStatusExplanationPledgeManagerPreparingShippingNextStepParagraph": "创始人将在准备好后发货。",
        "OrderStatusExplanationPledgeManagerPreparingShippingParagraph": "关注项目更新以了解发货时间。",
        "OrderStatusExplanationPledgeManagerShippedHeader": "您的订单已发货。",
        "OrderStatusExplanationPledgeManagerShippedParagraph": "订单正在运送中！等待收货并享用 :)",
        "OrderStatusExplanationStoreNextStepParagraph": "创始人将打包并发货。",
        "OrderStatusExplanationStorePaymentPaidParagraph": "您的订单已成功下单并付款。",
        "PaidStatusParagraph": "订单已全部付款。",
        "PartiallyPaidStatusParagraph": "订单部分付款。",
        "ResumePaymentButton": "继续付款",
        "ResumePaymentMessage": "您尚未支付订单。",
        "ScheduledAndAwaitingPaymentStatusParagraph": "您使用Stretch Pay认捐，尚未支付运费或众筹后添加到订单的商品。",
        "ScheduledStatusParagraph": "您选择了分期付款。",
        "StoreNotificatorPartiallyPaidMessage": "您的订单已部分付款。请支付订单的剩余款项。",
        "StoreResumePaymentMessage": "您尚未支付订单。"
    },
    "PaymentSuccess": {
        "BackerNumberMessage": "你是支持者 #{0}",
        "CrowdfundingPageSubHeader": "将在活动成功结束后24小时内收费。",
        "CrowdfundingPageSubHeaderInstantPayment": "您的认捐已收费。如需取消，请直接联系发起人申请退款。",
        "CrowdfundingPaymentSuccessStatisticHeader": "您已为达成目标贡献",
        "DetailsSectionHeader": "恭喜！您的认捐已完成！🎉",
        "EarlyShippingCollectionParagraph": "运费已收取。您将在认捐管理阶段提供详细的送货地址。",
        "FaqSectionCommentsLink": "评论",
        "FaqSectionContactFormLink": "联系表",
        "FaqSectionHeaderItem1": "何时会收取我的认捐费用？",
        "FaqSectionHeaderItem2": "运费如何处理？",
        "FaqSectionHeaderItem3": "我可以更新我的认捐吗？",
        "FaqSectionHeaderItem4": "有其他问题吗？",
        "FaqSectionHeaderItem5": "我在哪里可以找到并管理我的认捐？",
        "FaqSectionHeaderItem6": "我可以更改送货地址吗？",
        "FaqSectionHeaderItem7": "我可以在认捐中添加项目吗？",
        "FaqSectionHeaderItem8": "我什么时候能收到奖励？",
        "FaqSectionParagraphItem1": "将在活动成功结束后24小时内收费。",
        "FaqSectionParagraphItem10": "不能。一旦认捐下达，无法编辑。任何附加项目必须单独认捐。如果需要帮助，请联系发起人。",
        "FaqSectionParagraphItem2": "此阶段不收取运费和运送详情。项目发起者会在稍后要求您支付运费。",
        "FaqSectionParagraphItem3": "当然可以。您可以在活动结束前或认捐经理中更改认捐内容。",
        "FaqSectionParagraphItem4": "访问 {0} 部分或使用 {1} 获取所需答案。关注项目 {2} 并在 {3} 分享您对项目的看法。",
        "FaqSectionParagraphItem5": "前往 {0} 查看详情。",
        "FaqSectionParagraphItem6": "您可以在认捐发货前更改送货地址。注意更改送货地址可能影响运费。",
        "FaqSectionParagraphItem7": "只要项目开启，您可以添加项目到您的认捐中。",
        "FaqSectionParagraphItem8": "对于某些快速众筹活动，履行可能会在您提交认捐后不久开始。查看 {0} 并关注 {1} 了解详细履行信息。",
        "FaqSectionParagraphItem9": "可以，但只能增加总金额。您不能移除项目或减少认捐。如果需要帮助，请联系发起人。",
        "FaqSectionProjectDescriptionLink": "项目描述",
        "FaqSectionProjectUpdatesLink": "更新",
        "FaqSectionProjectUpdatesVariantLink": "项目更新",
        "FaqSectionWithInstantPaymentParagraphItem1": "您已收费。您可以联系发起人并在活动结束前撤销认捐以获得全额退款。",
        "NewsletterBannerConfirmationHeader": "感谢您加入我们的社区！",
        "NewsletterBannerConfirmationParagraph": "您可以在帐户设置中管理订阅。",
        "NewsletterBannerHeader": "邮箱中的游戏更新",
        "NewsletterBannerParagraph": "订阅我们的新闻通讯，获取Gamefound上的有趣活动更新。我们大约每月发送一次这些信息。",
        "NewsletterBannerSubscribeButton": "订阅",
        "NotificatorOverpaidOrderErrorMessage": "您的认捐已超额支付。请联系发起人获取多余款项的退款。",
        "PageCrowdfundingInstantSubheader": "感谢您参与此项目！您的认捐已付。如果您改变主意，可在众筹活动结束前要求发起人取消认捐并获得退款。",
        "PageHeader": "您支持了 {0}",
        "PageSubheader": "您刚刚认捐支持了此项目，并成为其中的一部分。",
        "PageTitle": "订单信息",
        "PaymentSuccessCreatorCustomMessageTitle": "来自 {0} 的特别感谢",
        "PledgeManagerPaymentSuccessStatisticHeader": "您已支持该项目",
        "ProjectHomeLink": "项目主页",
        "RecommendationSectionHeader": "探索更多",
        "ReturnActionButton": "查看您的认捐",
        "SocialMediaMessage": "分享此项目，帮助其成长。",
        "StepHeader": "下一步：",
        "StoreDetailsSectionHeader": "您已下单",
        "StoreFaqSectionHeaderItem1": "我在哪里可以找到我的订单？",
        "StoreFaqSectionHeaderItem2": "有其他问题吗？",
        "StoreFaqSectionParagraphItem1": "前往 {0} 查看其详情。",
        "StoreFaqSectionParagraphItem2": "访问 {0} 部分或使用 {1} 获取所需答案。",
        "StorePageHeader": "您在 {0} 的订单已成功下达",
        "StorePageSubheader": "您刚刚为商店下了订单并成为其中的一部分。",
        "StoreReturnActionButton": "查看您的订单",
        "ToastNewsletterSubscriptionSuccessMessage": "您已订阅我们的新闻通讯。",
        "UnlockStretchGoalImageAlt": "延伸目标图片",
        "UnlockStretchGoalMessage": "在 {0} 解锁",
        "UnlockStretchGoalSectionHeader": "... 并解锁了以下延伸目标",
        "UnlockStretchGoalSectionSingleHeader": "你帮助解锁了延伸目标",
        "YourOrderPageLink": "你的订单",
        "YourPledgePageLink": "你的支持"
    },
    "Product": {
        "ItemLimitedToLoggedInUsersTooltip": "由于每个用户的限购数量，此商品仅对已登录用户开放。",
        "MissingOrInvalidProductIdErrorMessage": "请求中缺少或无效的productID参数。",
        "ProductCardAddToOrderButton": "添加到订单",
        "ProductHasInvalidConfigurationErrorMessage": "此产品配置无效，暂时无法添加到您的提交中。",
        "ProductLimitPluralizedCount": "{n} 份|{n} 份",
        "ProductNotAvailableInCountryErrorMessage": "该产品在您的国家/地区无售。",
        "ProductNotBuyableErrorMessage": "产品不可购买。",
        "ProductNotExistErrorMessage": "产品不存在。",
        "ProductValidationLimitInfoTooltipText": "您最多只能添加 {0} 件此产品。",
        "ProductValidationLimitReachedTooltipText": "您无法再添加更多该产品。",
        "ProductValidationMinQuantityTooltipText": "数量字段必须为1或以上。",
        "ProductValidationOrderNotFinishedTooltipText": "由于您尚未完成当前订单，添加项目已停用。",
        "ProductValidationPaymentProcessingTooltipText": "由于正在处理您的付款，添加项目已停用。",
        "ProductValidationPledgeNotFinishedTooltipText": "由于您尚未完成当前提交，添加项目已停用。",
        "ProductValidationStockLimitReachedTooltipText": "您无法添加此产品，因为已无存货。",
        "ProductValidationUnselectedOptionsTooltipText": "选择一个产品选项以确认。",
        "QuantityInputDecreaseButtonLabel": "数量减一",
        "QuantityInputIncreaseButtonLabel": "数量加一",
        "QuantityInputLabel": "数量",
        "RewardCardAddToPledgeButton": "添加到提交",
        "RewardCardFeaturedLabel": "精选",
        "RewardCardLowestPriceInLast30Days": "过去30天最低价格：{0}",
        "RewardCardMoreInfoLink": "更多信息",
        "RewardCardMostPopularLabel": "最受欢迎",
        "RewardCardPledgeCountText": "提交 {0}",
        "RewardCardPluralizedCount": "{n} 次|{n} 次",
        "RewardCardProductDescriptionTitle": "产品描述",
        "RewardCardProductSetItemQuantityLabel": "数量：{0}",
        "RewardCardRetailLabel": "零售",
        "RewardCardReviewsTitle": "评论",
        "RewardCardSetItemTableHeader": "该套装包括{0}: ",
        "RewardCardSpecialLabel": "特别",
        "RewardCardStretchPayGetItForText": "每月支付 {0}",
        "RewardCardStretchPayTooltipText": "Stretch Pay 适用于付款金额超过 {0}。",
        "SetItemsAppliedOptionLabel": "适用于 {0}",
        "SetItemsAppliedOptionsTooltipText": "此选项适用于以下 {0}: ",
        "SetItemsPluralized": "项目|项目",
        "SetItemsPluralizedCount": "{n} 项目|{n} 项目",
        "StoreProductHasInvalidConfigurationErrorMessage": "此产品配置无效，暂时无法添加到您的订单中。",
        "StoreProductValidationLimitReachedTooltipText": "您无法再添加更多该产品到您的订单。",
        "StoreProductValidationStockLimitReachedTooltipText": "您无法添加此产品到您的订单中，因为没有更多库存。"
    },
    "Profile": {
        "CommentUserProfilePrivateStateParagraph": "该个人主页是私密的。没有人可以查看。",
        "EmptyStateCommentsParagraph": "{0}没有发布任何评论。",
        "EmptyStateCommentsParagraphOwnProfile": "添加评论以填充此空间。",
        "EmptyStateCommentsTitle": "没有评论可显示",
        "EmptyStateFollowersParagraph": "列表已经准备好增长。",
        "EmptyStateFollowersTitle": "没有粉丝可显示",
        "EmptyStateFollowingParagraph": "列表已经准备好增长。",
        "EmptyStateFollowingTitle": "没有关注用户可显示",
        "EmptyStateProfilePrivateStatusOwnProfileAction": "管理隐私设置",
        "EmptyStateProfilePrivateStatusOwnProfileTitle": "你的个人主页是私密的",
        "EmptyStateProfileStatusPrivateOwnProfileParagraph": "你可以在账户设置中更改此设置。",
        "EmptyStateProfileStatusPrivateParagraph": "该用户已隐藏个人资料详情。没有人可以查看。",
        "EmptyStateProfileStatusPrivateTitle": "该个人主页是私密的",
        "EmptyStateProfileViewParagraph": "{0}还没有填写此空间。",
        "EmptyStateProfileViewTitle": "没有任何内容显示",
        "EmptyStateProjectParagraph": "{0}还没有支持或关注任何项目。",
        "EmptyStateProjectParagraphOwnProfile": "关注或支持一个项目以填充此空间。",
        "EmptyStateProjectsExploreAction": "探索项目",
        "EmptyStateProjectsTitle": "没有项目可显示",
        "FollowersCountLabel": "粉丝",
        "FollowRestrictionReasonDefaultMessage": "你需要将个人主页设置为公开才能关注其他用户",
        "FollowRestrictionReasonNoNicknameAndProfilePrivateMessage": "添加昵称并将个人主页设为公开才能关注其他用户。",
        "FollowRestrictionReasonNoNicknameMessage": "添加昵称才能关注其他用户。",
        "FollowRestrictionReasonProfilePrivateMessage": "将个人主页设为公开才能关注其他用户。",
        "NotificationUserFollowingParagraph": "你可以在通信偏好设置中调整通知。",
        "NotificationUserFollowingTitle": "你现在正在关注{0}。",
        "NotificationUserUnfollowingParagraph": "你将不会收到此用户的活动通知。",
        "NotificationUserUnfollowingTitle": "你不再关注{0}。",
        "SectionCommentsHeader": "评论",
        "SectionCommentsParagraph": "{0}发布的评论。",
        "SectionFollowersHeader": "粉丝",
        "SectionFollowersParagraph": "关注{0}的用户。",
        "SectionFollowingHeader": "关注",
        "SectionFollowingParagraph": "{0}关注的用户。",
        "SectionOverviewHeader": "概览",
        "SectionProjectsHeader": "项目",
        "SectionProjectsParagraph": "关注和支持的项目。",
        "SectionViewAllAction": "查看全部",
        "UserFollowAction": "关注",
        "UserFollowingLabel": "你正在关注此用户。",
        "UserFollowLogInToFollowAction": "登录",
        "UserFollowLogInToFollowParagraph": "要关注此用户，你必须登录或{0}如果你没有账户。",
        "UserFollowLogInToFollowParagraphAction": "创建一个账户",
        "UserFollowLogInToFollowTitle": "登录以关注",
        "UserFollowSettingsCancelButton": "取消",
        "UserFollowSettingsMakeMyProfilePublicLabel": "将我的个人主页设为公开。",
        "UserFollowSettingsMakeYourProfilePublicParagraph": "将你的个人主页设为公开才能关注其他用户。",
        "UserFollowSettingsNicknameLabel": "昵称",
        "UserFollowSettingsPublicProfileFieldName": "公开个人主页",
        "UserFollowSettingsPublicStatusLabel": "该个人主页是公开的。",
        "UserFollowSettingsSetNicknameLabel": "设置昵称以关注其他用户。",
        "UserFollowSettingsTitle": "个人主页和昵称详情",
        "UserProfileCardFollowingBadge": "正在关注",
        "UserProfileCardFollowThisUserAction": "关注该用户",
        "UserUnfollowAction": "取消关注",
        "ViewProfileAction": "查看个人主页"
    },
    "Project": {
        "DefaultSecretStretchGoalAbstract": "达到目标以揭示隐藏奖励。",
        "DefaultSecretStretchGoalName": "隐藏扩展目标",
        "SecretStretchGoalBadgeLabel": "隐藏",
        "StablePledgeSectionHtmlPattern": "该项目是 Stable Pledge 计划的一部分。创作者保证，如果在活动结束后的任何价格估算变化超过10%，支持者可获得全额退款。支持者可在变更公告后14天内要求100%退款。Gamefound 会将其佣金退还给创作者，但退款由创作者全权负责。 <a href=\"{0}\" target=\"_blank\" rel=\"noopener noreferrer\">了解更多</a>。"
    },
    "ProjectCatalogCategories": {
        "Accessories": "配件",
        "AccessoriesSlug": "accessories",
        "AnimalRights": "动物权利",
        "AnimalRightsSlug": "animal-rights",
        "Animals": "动物",
        "AnimalsSlug": "animals",
        "Art": "艺术",
        "ArtSlug": "art",
        "Audio": "音频",
        "AudioSlug": "audio",
        "BoardAndCardGames": "桌游和卡牌游戏",
        "BoardAndCardGamesSlug": "board-and-card-games",
        "CameraGear": "摄影设备",
        "CameraGearSlug": "camera-gear",
        "Celebrations": "庆典",
        "CelebrationsSlug": "celebrations",
        "Comics": "漫画",
        "ComicsSlug": "comics",
        "CommunityProjects": "社区项目",
        "CommunityProjectsSlug": "community-projects",
        "CreativeWorks": "创意作品",
        "CreativeWorksSlug": "creative-works",
        "CultureCategory": "文化",
        "CultureCategorySlug": "culture",
        "DanceAndTheater": "舞蹈和戏剧",
        "DanceAndTheaterSlug": "dance-theater",
        "Education": "教育",
        "EducationSlug": "education",
        "EnergyAndGreenTech": "能源和绿色科技",
        "EnergyAndGreenTechSlug": "energy-green-tech",
        "Environment": "环境",
        "EnvironmentSlug": "environment",
        "FashionAndWearables": "时尚和可穿戴设备",
        "FashionAndWearablesSlug": "fashion-wearables",
        "Film": "电影",
        "FilmSlug": "film",
        "FoodAndBeverages": "食品和饮料",
        "FoodAndBeveragesSlug": "food-beverages",
        "GamingCulture": "游戏文化",
        "GamingCultureSlug": "gaming-culture",
        "GeneralProducts": "综合",
        "GeneralProductsSlug": "general",
        "HealthAndFitness": "健康与健身",
        "HealthAndFitnessSlug": "health-fitness",
        "Home": "家居",
        "HomeSlug": "home",
        "HumanRights": "人权",
        "HumanRightsSlug": "human-rights",
        "LocalBusinesses": "本地企业",
        "LocalBusinessesSlug": "local-businesses",
        "Music": "音乐",
        "MusicSlug": "music",
        "OtherCategoriesSlug": "other_categories",
        "OtherCommunityProjects": "其他社区项目",
        "OtherCommunityProjectsSlug": "other-community-projects",
        "OtherCreations": "其他创作",
        "OtherCreationsSlug": "other-creations",
        "Others": "其他",
        "OthersSlug": "others",
        "PhonesAndAccessories": "手机与配件",
        "PhonesAndAccessoriesSlug": "phones-accessories",
        "Photography": "摄影",
        "PhotographySlug": "photography",
        "PodcastsBlogsAndVlogs": "播客、博客和视频博客",
        "PodcastsBlogsAndVlogsSlug": "podcasts-blogs-vlogs",
        "Productivity": "生产力",
        "ProductivitySlug": "productivity",
        "Spirituality": "灵性",
        "SpiritualitySlug": "spirituality",
        "TechAndInnovation": "科技与创新",
        "TechAndInnovationSlug": "tech-innovation",
        "Transportation": "交通",
        "TransportationSlug": "transportation",
        "TravelAndOutdoors": "旅行与户外",
        "TravelAndOutdoorsSlug": "travel-outdoors",
        "TTRPG": "桌面角色扮演游戏",
        "TTRPGSlug": "ttrpg",
        "VideoGames": "电子游戏",
        "VideoGamesSlug": "video-games",
        "WebSeriesAndTVShows": "网络剧和电视节目",
        "WebSeriesAndTVShowsSlug": "web-series-tv-shows",
        "Wellness": "健康",
        "WellnessSlug": "wellness",
        "WritingAndPublishing": "写作与出版",
        "WritingAndPublishingSlug": "writing-publishing"
    },
    "ProjectDescriptionSectionType": {
        "PledgeOptionAddonsDisplayName": "附加组件",
        "PledgeOptionRewardsDisplayName": "奖励",
        "PledgeOptionsDisplayName": "支持选项",
        "PledgeOptionStretchGoalsDisplayName": "扩展目标",
        "ProjectStoryDisplayName": "项目故事",
        "RefundsAndCancellationDisplayName": "退款和取消",
        "RisksAndChallengesDisplayName": "风险和挑战",
        "TimelineDisplayName": "项目时间表"
    },
    "ProjectHome": {
        "AcceptingStoreTermsOfServiceText": "购买本店商品，即表示您同意 {0} 的 {1}。",
        "AddonsRestrictionSubheader": "此项目不允许仅认捐附加项目。",
        "AddToCartOptionsModalShowItemsInSetButton": "显示项目",
        "AddToCartOptionsModalTitle": "将产品添加到您的认捐中",
        "AddToCartRestrictedModalFirstParagraph": "该产品无法添加，因为现有认捐的配送目的地不支持此产品的发货。",
        "AddToCartRestrictedModalFourthPagraph": "要查看可以运送到原始配送国家的产品，请 {0} 更改配送国家，请取消或编辑订单，移除新地址不可送达的项目。",
        "AddToCartRestrictedModalParagraphAction": "调整配送目的地。",
        "AddToCartRestrictedModalSecondParagraph": "现有认捐的配送国家： {0}",
        "AddToCartRestrictedModalThridParagraph": "当前设置的配送国家： {0}",
        "AddToCartRestrictedModalTitle": "该产品在此地点不可用",
        "AddToCartSubmitOrderButton": "提交订单",
        "AddToCartSuccessCheckoutButton": "提交认捐",
        "AddToCartSuccessContinueBrowsingButton": "继续浏览",
        "AddToCartSuccessModalInstallmentMissingAmountParagraph": "再认捐 {0} 即可解锁使用 {1} 分期付款",
        "AddToCartSuccessModalTitle": "产品已添加到您的认捐中",
        "AddToCartSuccessSubmitChangesHint": "<strong>提示：</strong> 您已更改认捐内容。如果已完成修改，请提交更改。",
        "AnimatedNumberPluralizedBacker": "支持者",
        "BackerInfoMessage": "您是支持者！",
        "CannotAddItemsAtThisTimeText": "您现在无法给认捐添加项目。",
        "CannotAddProductInArchiveViewText": "此产品无法添加到您的认捐中，因为这是原始众筹活动的存档视图。",
        "CannotAddProductInClosedProjectText": "您无法添加项目到认捐中，因为此项目已结束。",
        "CannotAddProductInDraftText": "您无法添加项目到认捐中，因为该项目尚未启动。",
        "CannotAddProductInPreviewText": "您无法添加此产品到认捐中，因为这是 {0} 的预览。",
        "CannotAddProductPledgeManagerNotLaunchedText": "您无法添加项目到认捐中，因为该项目的Pledge Manager尚未启动。",
        "ChangeDisplayCurrencyNote": "注意：显示的金额为大致的货币换算。认捐金额以项目本币进行收取。",
        "ChangeDisplayCurrencyParagraph": "更改显示货币将使您查看目标和认捐金额转换为 {0} 的结果。",
        "ChangeDisplayCurrencyTitle": "更改显示货币",
        "ChangeLanguageButton": "更改语言",
        "CompareProductsBannerCompareButtonText": "对比奖励",
        "CompareProductsBannerDescription": "使用我们的产品对比工具选择最适合您的认捐，并确保添加了所有您想要的项目。",
        "CompareProductsBannerHeader": "寻找最佳价值？",
        "CreatorResponsibleForThisProject": "负责此项目的创作者：{0}，以 {1} 名义经营。",
        "CrowdfundingBackAgainButton": "再次支持",
        "CrowdfundingDraftInfoModalSection1Header": "这不是它的最终状态。",
        "CrowdfundingDraftInfoModalSection1Text": "活动正在建设中。如果启动，您将看到其最终版本。在启动前所有项目、描述和价格可能会发生变化。",
        "CrowdfundingDraftInfoModalSection2Header": "您的意见非常欢迎！",
        "CrowdfundingDraftInfoModalSection2Text": "让创作者听到您的声音。您的想法将有助于最终版本的形成。可以在评论区分享您的观点或表达支持。",
        "CrowdfundingDraftInfoModalSection3Header": "活动尚不接受认捐。",
        "CrowdfundingDraftInfoModalSection3Text": "如果想支持此活动，您需等待其启动。",
        "CrowdfundingDraftInfoModalSubtitle": "这意味着什么？",
        "CrowdfundingDraftInfoTitle": "这是活动预览",
        "CrowdfundingExpressOvertimeTooltipText": "该活动处于Endgame阶段。活动结束后，每新增一个支持者或第一次新增认捐会将筹资计时时间重置为10分钟。",
        "CrowdfundingExpressUpgradeLimitationText": "直到完全支付当前认捐之前，您无法再次支持此项目。",
        "CustomTermsOfServiceLink": "服务条款",
        "DigitalProductBadge": "数字",
        "DisplayCurrenciesLabel": "显示货币",
        "FeaturedProductBadge": "精选",
        "FollowProjectButton": "关注",
        "HumanizeDateAgoLabel": "{0} 前",
        "HumanizeDatePluralizedDay": "天",
        "HumanizeDatePluralizedDayAccusativeCase": "天|天",
        "HumanizeDatePluralizedHour": "小时",
        "HumanizeDatePluralizedHourAccusativeCase": "小时|小时",
        "HumanizeDatePluralizedMilisecond": "毫秒",
        "HumanizeDatePluralizedMillisecond": "毫秒|毫秒",
        "HumanizeDatePluralizedMillisecondAccusativeCase": "毫秒|毫秒",
        "HumanizeDatePluralizedMinute": "分钟",
        "HumanizeDatePluralizedMinuteAccusativeCase": "分钟|分钟",
        "HumanizeDatePluralizedMinuteShort": "分钟",
        "HumanizeDatePluralizedMonth": "月",
        "HumanizeDatePluralizedMonthAccusativeCase": "月|月",
        "HumanizeDatePluralizedSecond": "秒",
        "HumanizeDatePluralizedSecondAccusativeCase": "秒|秒",
        "HumanizeDatePluralizedSecondShort": "秒",
        "HumanizeDatePluralizedYear": "年",
        "HumanizeDatePluralizedYearAccusativeCase": "年|年",
        "HumanizeDateThreePartsLabel": "{0} {1} {2}",
        "HumanizeDateTwoPartsLabel": "{0} 和 {1}",
        "HumanizeLanguageLabel": "语言",
        "HumanizeToBePluralized": "是",
        "ItemCannotBeAddedSeparatelyText": "此项目无法单独添加到您的认捐中。",
        "LegacyFeaturedProductsHeader": "精选产品",
        "LegacyFeaturedProductsSubheader": "最推荐！",
        "LegacyOverviewHeader": "项目概览",
        "LimitedProductBadge": "限量",
        "LockedOrderTooltip": "您无法更改此订单，因为它已被创作者禁用。",
        "MiniWizardAddMoreItemsButton": "添加更多项目",
        "MiniWizardBackerNumberText": "您是支持者 #{0}",
        "MiniWizardBackerWithoutNumberText": "您是支持者",
        "MiniWizardCancelPledgeButton": "取消认捐",
        "MiniWizardCartItemsHeader": "您的项目",
        "MiniWizardChooseAddonsButton": "选择附加项目",
        "MiniWizardChooseRewardsButton": "选择奖励",
        "MiniWizardCollapsibleHideItemsButton": "隐藏项目",
        "MiniWizardCollapsibleShowItemsButton": "显示项目",
        "MiniWizardCompleteOrderButton": "提交订单",
        "MiniWizardCompletePledgeButton": "完成认捐",
        "MiniWizardCompletePledgeShortButton": "完成",
        "MiniWizardCreditDiscountLabel": "积分折扣：",
        "MiniWizardCreditValueText": "您的积分",
        "MiniWizardCreditValueTooltip": "此金额将减少您的最终付款额。",
        "MiniWizardCurrentPledgeLabel": "当前认捐",
        "MiniWizardDividerLabel": "或",
        "MiniWizardEditPledgeButton": "编辑认捐",
        "MiniWizardEditPledgeShortButton": "编辑",
        "MiniWizardExpandableHideDetailsLabel": "隐藏详情",
        "MiniWizardExpandablePledgeValueText": "您的认捐金额",
        "MiniWizardExpandableShowDetailsLabel": "显示详情",
        "MiniWizardFeaturedRewardBadge": "精选",
        "MiniWizardItemRemoved": "项目已被移除。",
        "MiniWizardManageOrderButton": "管理您的订单",
        "MiniWizardManagePledgeButton": "管理您的认捐",
        "MiniWizardModifyingPledgeCostAfterLabel": "修改后",
        "MiniWizardModifyingPledgeCostBeforeLabel": "修改前",
        "MiniWizardModifyingPledgeHint": "提交以应用更改",
        "MiniWizardModifyingPledgeTitle": "您正在修改您的认捐。",
        "MiniWizardMoreAddOnsButton": "添加更多附加项目",
        "MiniWizardNoAddonsSubheader": "尚未选择附加项目。",
        "MiniWizardNoCartItemsHeader": "尚未选择奖励。",
        "MiniWizardNoShippingTooltip": "不包含运费。",
        "MiniWizardOrderPlacedText": "您已下单",
        "MiniWizardOrderValueText": "您的订单",
        "MiniWizardPledgeModifiedText": "您正在修改您的原始 {0} 认捐。",
        "MiniWizardPledgeValueText": "您的认捐",
        "MiniWizardProcessingPaymentInfo": "您的付款正在处理。",
        "MiniWizardProcessingPaymentLabel": "正在处理付款",
        "MiniWizardRemovedAllItemsText": "您已移除所有认捐项目。",
        "MiniWizardRemovedPaidItemsText": "您已移除所有可能移除的认捐项目。",
        "MiniWizardResumePaymentButton": "继续付款",
        "MiniWizardRevertChangesButton": "还原更改",
        "MiniWizardSelectThisRewardButton": "选择此奖励",
        "MiniWizardSubmitChangesButton": "提交更改",
        "MiniWizardSubmitPledgeButton": "提交认捐",
        "MiniWizardTaxSummaryInclTaxLabel": "含税",
        "MiniWizardTaxSummaryPlusTaxLabel": "+ 税",
        "MiniWizardUpgradePledgeButton": "升级认捐",
        "MiniWizardUpgradePledgeShortButton": "升级",
        "MiniWizardYourOrderLabel": "您的订单",
        "MiniWizardYourPledgeLabel": "您的认捐",
        "PerformanceMarketingBannerLabel": "活动营销横幅",
        "PledgeWithoutRewardAmountFieldName": "奖金金额",
        "PledgeWithoutRewardAmountFieldPlaceholder": "您的认捐金额",
        "PledgeWithoutRewardDescription": "帮助项目达到目标或支付任意金额支持创作者（无奖励）。",
        "PledgeWithoutRewardHeader": "展示您的支持",
        "PledgeWithoutRewardSuccessToast": "奖金金额已添加到您的认捐中",
        "ProductAvailableOnlyInSetLabel": "单独不可用",
        "ProductStockLeftLabel": "剩余{0}",
        "ProjectApproximateCurrencyConversionTooltip": "约是从{0}转换值",
        "ProjectArchivedViewLink": "前往当前项目视图",
        "ProjectArchivedViewMessage": "这是原始众筹活动的存档视图。",
        "ProjectBenefitsAndRisksCrowdfundingDescription": "众筹存在风险——奖励无法保证。创作者对开发和交付负全部责任。",
        "ProjectBenefitsAndRisksCrowdfundingLinkLabel": "了解众筹",
        "ProjectBenefitsAndRisksStablePledgeDescription": "该项目是Stable Pledge计划的一部分。如果最终成本增加超过10%，创作者承诺全额退款。",
        "ProjectBenefitsAndRisksStablePledgeLinkLabel": "了解Stable Pledge",
        "ProjectBenefitsAndRisksStretchPayDescription": "该项目提供Stretch Pay。超过{0}的认捐可以分成{1}期付款。",
        "ProjectContentsDescriptionMissingErrorMessage": "描述部分缺失。",
        "ProjectCurrenciesLabel": "项目货币",
        "ProjectHeaderByCreatorTitle": "由{0}创作",
        "ProjectOpenOnlyForCreditsText": "该项目目前仅对有积分的支持者开放。您因没有积分而无法添加任何内容到您的认捐中。",
        "ProjectOvertimeActivatedText": "Endgame将被激活！活动时间将延长。",
        "ProjectOvertimeBackersEmptyStateText": "等待第一位支持者推动Endgame前进。",
        "ProjectOvertimeButtonLabel": "现在支持，延长时间",
        "ProjectOvertimeButtonUpgradeLabel": "升级您的认捐",
        "ProjectOvertimeExplanationParagraph": "每次新的认捐或升级都将重置计时器，通过支持者的努力延长活动生命周期。",
        "ProjectOvertimeExtendedText1": "感谢支持",
        "ProjectOvertimeExtendedText2": "活动延长了",
        "ProjectOvertimeExtendedTimeLabel": "延长期内",
        "ProjectOvertimeFoundedLabel": "已筹集",
        "ProjectOvertimeRemainingText": "最后{0}。立即支持以激活Endgame！",
        "ProjectOvertimeStatisticsParagraph": "活动由{1}支持者延长了{0}",
        "ProjectOvertimeSummaryBoxTooltipText": "计划的结束日期随着Endgame阶段的时长延长。活动计划结束后，每位新的支持者或他们首次认捐升级都会重置最终倒计时至{0}。",
        "ProjectOvertimeTimerElapsedText": "即将结束",
        "ProjectOvertimeTimerText": "活动结束于：",
        "ProjectOvertimeTitle": "Endgame进行中",
        "ProjectOvertimeTooltipText": "该活动处于Endgame阶段。每位新的支持者或认捐升级都会重置筹款倒计时至10分钟。",
        "ProjectOvertimeTooltipTriggerText": "每个支持者都会重置计时器",
        "ProjectPageNavbarLink": "项目",
        "ProjectPromoItemAuthenticatedAndDoesntFollowTooltip": "如果您在启动前关注这项活动，礼品将在结账时添加到您的认捐中。",
        "ProjectPromoItemAuthenticatedAndFollowsTooltip": "礼品将会在结账时添加到您的认捐中。",
        "ProjectPromoItemBackNowLabel": "现在支持领取免费礼品",
        "ProjectPromoItemDiscountLabel": " - <strong>{0}</strong>优惠",
        "ProjectPromoItemFollowNowLabel": "立即关注领取免费礼品",
        "ProjectPromoItemIsFollowingLabel": "您将获得免费礼品",
        "ProjectPromoItemNotAuthenticatedAndDoesntFollowTooltip": "如果您在启动前关注这项活动，礼品将在结账时添加到您的认捐中。要获得礼品，您必须在关注并支持时使用相同的邮箱。",
        "ProjectPromoItemNotAuthenticatedAndFollowsTooltip": "礼品将在结账时添加到您的认捐中。要获得礼品，您必须在关注并支持时使用相同的邮箱。",
        "ProjectPromoItemTimeLeftForDiscountText": "您有{0}的时间成为支持者并领取{1}优惠。",
        "ProjectPromoItemTimeLeftForGiftText": "您有{0}的时间成为支持者并领取免费礼品。",
        "ProjectPropertiesAgeLabel": "适合年龄",
        "ProjectPropertiesCategoryLabel": "类别",
        "ProjectPropertiesGenreLabel": "类型",
        "ProjectPropertiesPlayersLabel": "玩家数",
        "ProjectPropertiesPlayTimeLabel": "游戏时长",
        "ProjectPropertiesTagsLabel": "标签",
        "ProjectRecommendationPluralizedFollower": "关注者|关注者们",
        "ProjectRecommendationsSearchLink": "探索",
        "ProjectRecommendationsText": "基于您的收藏和流行趋势，发现新项目来{0}！",
        "ProjectRecommendationsTitle": "您可能感兴趣的其他项目",
        "ProjectSearchPageTitle": "搜索项目",
        "ProjectSectionReportTranlsationIssueLink": "报告翻译问题",
        "ProjectSectionReportTranlsationIssueParagraph": "该项目的翻译不完整。未翻译的描述将显示为平台默认语言。{0}帮助我们变得更好。",
        "ProjectStoryAvailableLanguagesCountText": "有{0} {1}其他语言可用。",
        "ProjectStoryAvailableLanguagesTooltipText": "项目页面可用语言：{0}。",
        "ProjectStoryBackingInformationCrowdfundingRisksDescription": "众筹不同于商店。您不会在认捐后立即收到产品。众筹中，产品的创作过程需要时间，因为社区会影响其最终形式。请记住，创作者负责项目，我们在这里促成众筹过程。您可以随时直接联系创作者，询问有关活动的任何问题。有可能活动不会达到目标。如果是这种情况，您将不会失去任何东西，因为活动失败时支持者并不会被收取费用。",
        "ProjectStoryBackingInformationCrowdfundingRisksLabel": "众筹风险",
        "ProjectStoryBackingInformationExpressCrowdfundingRisksDescription": "快速众筹不同于商店。只要活动开放，您就可以认捐产品。活动没有设立筹款目标，所有款项即时处理。一些产品在活动进行期间就会发货。查看创作者提供的运输信息以了解预计交货日期。请记住，创作者负责项目，我们在这里促成众筹过程。在认捐之前，请务必查看项目的退款和取消部分以了解政策。您也可以直接联系创作者，询问有关活动的任何问题。",
        "ProjectStoryBackingInformationExpressCrowdfundingRisksLabel": "快速众筹风险",
        "ProjectStoryBackingInformationRisksLabel": "众筹风险",
        "ProjectStoryBackingInformationSectionLabel": "支持信息",
        "ProjectStoryBackingInformationStablePledgeDescription": "该项目是Stable Pledge计划的一部分。如果项目结束后任何价格估算变动超过10%，创作者保证向支持者提供全额退款。在价格变动通告后14天内提出的退款请求将获得100%退款。Gamefound将返还佣金给创作者，创作者独自负责退款。",
        "ProjectStoryBackingInformationStablePledgeLabel": "Stable Pledge",
        "ProjectStoryBackingInformationStretchPayDescription": "Stretch Pay允许您将认捐拆分为较小的付款。分期次数由创作者决定，并且对所有支持者相同。创作者还设置了解锁分期选项所需的最低认捐金额。如果项目启用了Stretch Pay，您将在奖励旁看到明确详情。您可以有多个分期计划，一旦完成一个，您可以开始另一个。您还可以在添加新项目到认捐时升级您的计划。",
        "ProjectStoryBackingInformationStretchPayLabel": "Stretch Pay",
        "ProjectStoryContactLink": "联系",
        "ProjectStoryCreatorLabel": "创作者",
        "ProjectStoryDisplayedLanguageText": "您正在查看{0}。",
        "ProjectStoryMoreInfoLink": "了解更多",
        "ProjectStoryNoTranslationInSelectedLanguageText": "此页面无{0}翻译。",
        "ProjectStoryNoTranslationText": "项目页面无其他语言可用。",
        "ProjectStoryPluralizedCoCreator": "共同创作者",
        "ProjectStoryStablePledgeLink": "了解Stable Pledge",
        "ProjectStoryStablePledgeText": "该项目是Stable Pledge计划的一部分。",
        "ProjectStretchGoalBackersCountNotUnlockedDescription": "项目达成{0}时解锁此目标。",
        "ProjectStretchGoalBackersCountUnlockedDescription": "项目达成{0}时已解锁此目标。",
        "ProjectStretchGoalCampaignDayNotUnlockedDescription": "活动第{0}天解锁此目标。",
        "ProjectStretchGoalCampaignDayUnlockedDescription": "活动第{0}天已解锁此目标。",
        "ProjectStretchGoalPercentage": "完成{0}%",
        "ProjectStretchGoalPledgeValueNotUnlockedDescription": "项目总认捐金额达{0}时解锁此目标。",
        "ProjectStretchGoalPledgeValueUnlockedDescription": "项目总认捐金额达{0}时已解锁此目标。",
        "ProjectStretchGoalProgressBackerCount": "还需{0}支持者",
        "ProjectStretchGoalProgressCampaignDay": "还剩{0} {1}",
        "ProjectStretchGoalProgressPledgeValue": "还需{0}",
        "ProjectStretchGoalTitle": "下一个解锁的伸展目标",
        "ProjectStretchGoalUnlocksByBackerCount": "{0}支持者",
        "ProjectStretchGoalUnlocksByDay": "第{0}天",
        "ProjectStretchGoalUnlocksByPledgeValue": "认捐{0}",
        "ProjectSummaryBackerCountSubHeader": "{0}支持者筹集了",
        "ProjectSummaryBoxAddMoreItemsText": "添加更多项目到您的认捐中",
        "ProjectSummaryBoxAllStretchGoalsText": "所有伸展目标已解锁",
        "ProjectSummaryBoxBackerCountCrowdfundingOnlyLabel": "由{0}支持者众筹",
        "ProjectSummaryBoxBackerCountCrowdfundingOnlyTooltipText": "创作者显示众筹期间筹集的资金。",
        "ProjectSummaryBoxBackerCountTotalFundingLabel": "由{0}支持者总共筹集",
        "ProjectSummaryBoxBackerCountTotalFundingTooltipText": "创作者显示众筹期间和之后筹集的资金。",
        "ProjectSummaryBoxBackerTextWithNumber": "您是第{0}位支持者",
        "ProjectSummaryBoxBackerTextWithoutNumber": "您是支持者",
        "ProjectSummaryBoxBackProjectButton": "支持此项目",
        "ProjectSummaryBoxClosedSubHeader": "无法添加或修改认捐。",
        "ProjectSummaryBoxClosedSubHeaderEmphasis": "认捐管理已关闭",
        "ProjectSummaryBoxCompletePledgeButton": "完成认捐",
        "ProjectSummaryBoxCreditsAvailableText": "您有{0}积分可用",
        "ProjectSummaryBoxCrowdfundingSummaryButton": "查看众筹摘要",
        "ProjectSummaryBoxDefaultHeader": "这是预览",
        "ProjectSummaryBoxDraftCountdownElapsed": "即将开始",
        "ProjectSummaryBoxDraftCountdownTitle": "活动启动于",
        "ProjectSummaryBoxDraftInfoTooltip": "创作者已经发布此页面供您和其他人查看并反馈。您现在看到的内容可能在启动之前会有所变化。",
        "ProjectSummaryBoxFundedAtText": "该项目在{0}被筹集资金",
        "ProjectSummaryBoxLastUpdate": "最后更新：",
        "ProjectSummaryBoxLatePledgeButton": "迟到认捐",
        "ProjectSummaryBoxLatePledgeCompletedHeader": "迟到认捐已结束",
        "ProjectSummaryBoxLatePledgeHeader": "这是迟到认捐",
        "ProjectSummaryBoxLimitedAllowedSubHeader": "发起人限制了对pledge manager的访问。",
        "ProjectSummaryBoxLimitedAllowedSubHeaderEmphasis": "你可以支持这个项目。",
        "ProjectSummaryBoxLimitedNoNewOrdersSubHeader": "只有特定的支持者可以访问pledge manager。",
        "ProjectSummaryBoxLimitedNoNewOrdersSubHeaderEmphasis": "这个项目不接受新的支持。",
        "ProjectSummaryBoxLimitedNotAllowedSubHeader": "发起人限制了对pledge manager的访问。",
        "ProjectSummaryBoxLimitedNotAllowedSubHeaderEmphasis": "只有特定的支持者可以支持这个项目。",
        "ProjectSummaryBoxLimitedShippingOnlySubHeader": "只有特定的支持者可以添加配送信息。",
        "ProjectSummaryBoxLimitedShippingOnlySubHeaderEmphasis": "这个项目不接受新的支持。",
        "ProjectSummaryBoxNoNewOrdersSubHeader": "只有支持者可以访问pledge manager。",
        "ProjectSummaryBoxNoNewOrdersSubHeaderEmphasis": "这个项目不接受新的支持。",
        "ProjectSummaryBoxOpenSubHeader": "可以支持这个项目。",
        "ProjectSummaryBoxOpenSubHeaderEmphasis": "所有人",
        "ProjectSummaryBoxOriginalCampaignButton": "查看原始项目",
        "ProjectSummaryBoxPledgeManagerCountdownTitle": "距离Pledge manager结束还有",
        "ProjectSummaryBoxPledgeManagerHeader": "这是一个pledge manager",
        "ProjectSummaryBoxPreorderButton": "预购",
        "ProjectSummaryBoxPreorderHeader": "这是一个预购",
        "ProjectSummaryBoxPreorderSubHeader": "在正式发布前订购产品。<br/>查看项目详情了解更多。",
        "ProjectSummaryBoxShippingOnlySubHeader": "支持者只能添加配送信息。",
        "ProjectSummaryBoxShippingOnlySubHeaderEmphasis": "这个项目不接受新的支持。",
        "ProjectSummaryBoxSomeStretchGoalsText": "<strong>{0} / {1}</strong> 激励目标已解锁。",
        "ProjectSummaryBoxSpendCreditsLink": "花费您的积分",
        "ProjectSummaryBoxUpgradePledgeButton": "升级支持",
        "ProjectSummaryClockElapsedMessage": "即将结束",
        "ProjectSummaryClockElapsedTitle": "项目结束于",
        "ProjectSummaryGoalReachedInText": "在 <strong> {0} </strong> 内达到目标",
        "ProjectSummaryLearnMoreAboutCrowdfundingHeader": "关于众筹",
        "ProjectSummaryLearnMoreAboutCrowdfundingReadMoreLink": "阅读更多",
        "ProjectSummaryLearnMoreAboutCrowdfundingText": "众筹是一个由社区实现的理念。这是一个需要支持者支持的集体项目。",
        "ProjectSummaryLearnMoreButton": "了解更多",
        "ProjectSummaryLearnMoreEndDateHeader": "项目结束日期",
        "ProjectSummaryLearnMoreFundingModeExpressCFAllowEditOrdersText": "在结账后只能增加支持金额。",
        "ProjectSummaryLearnMoreFundingModeExpressCFForbidEditOrdersText": "结账后支持金额将固定。",
        "ProjectSummaryLearnMoreFundingModeExpressCFText": "这个项目使用快速众筹，没有筹款目标。付款即时处理。可能提供分期付款，第一次付款立即扣除。",
        "ProjectSummaryLearnMoreFundingModeHeader": "筹款模式",
        "ProjectSummaryLearnMoreFundingModeText": "这个项目是全或无。这意味着发起人在项目达成目标后才会收到资金。",
        "ProjectSummaryLearnMorePossibleRisksHeader": "潜在风险",
        "ProjectSummaryLearnMorePossibleRisksLink": "这里",
        "ProjectSummaryLearnMorePossibleRisksText": "每个项目都有潜在风险。阅读关于这个项目风险的{0}。",
        "ProjectSummaryNoTimeLeftToFinishLabel": "即将结束",
        "ProjectSummaryNoTimeLeftToLaunchLabel": "即将启动",
        "ProjectSummaryOthersAreFollowingText": "{0} 跟随。",
        "ProjectSummaryPluralizedBoardgamers": "人|人们",
        "ProjectSummaryPluralizedOtherBoardgamers": "其他人|其他人们",
        "ProjectSummaryProgressCurrencyConversionTooltip": "转换自已支持金额 {0}。",
        "ProjectSummaryProgressCurrencyConversionWithGoalTooltip": "转换自已支持金额 {0}，目标金额 {1}。",
        "ProjectSummaryProgressGoalHeader": "目标: {0} ({1} 已筹得)",
        "ProjectSummaryProgressPluralizedBacker": "{n} 支持者|{n} 支持者",
        "ProjectSummaryStatisticsBackerCountText": "{0} 支持了 {1}",
        "ProjectSummaryStatisticsCanceledReasonText": "发起人已取消这个项目。",
        "ProjectSummaryStatisticsCanceledTitle": "项目已取消",
        "ProjectSummaryStatisticsEndDateText": "项目于 {0} 结束。",
        "ProjectSummaryStatisticsFailedReasonText": "项目未达成其目标。",
        "ProjectSummaryStatisticsFailedTitle": "项目未筹集资金",
        "ProjectSummaryStatisticsGoalReachedInLabel": "在<strong>{0}</strong>内实现目标",
        "ProjectSummaryStatisticsNoFundsCollectedText": "没有从支持者处收集资金。",
        "ProjectSummaryStatisticsPercentageOfGoalText": "这占目标的 {0} ({1}).",
        "ProjectSummaryStatisticsSuccessfulTitle": "项目已筹集资金",
        "ProjectSummaryStretchGoalNextLink": "下一个目标",
        "ProjectSummaryStretchGoalPreviousLink": "上一个目标",
        "ProjectSummaryStretchGoalsLink": "查看激励目标列表",
        "ProjectSummaryStretchGoalUnlocked": "所有激励目标已解锁",
        "ProjectSummaryTimeLeftToFinishLabel": "剩余 {0} {1}",
        "ProjectSummaryTimeLeftToLaunchLabel": "距项目启动还有 {0} {1}",
        "ProjectSummaryTotalFundingHeader": "总筹款金额：",
        "ProjectSummaryYouAndOthersAreFollowingText": "您和 {0} 关注此项目。",
        "ProjectSummaryYouAreFollowingText": "您正在关注此项目。",
        "ProjectTimelineBackNowButton": "立即支持",
        "ProjectTimelineCanceledBackerMessage": "这个项目已取消。您的支持金额不会扣款。{0}",
        "ProjectTimelineCanceledLabel": "已取消",
        "ProjectTimelineCanceledNotBackerMessage": "这个项目已取消。支持者的支持金额不会扣款。{0}",
        "ProjectTimelineClosedLabel": "已关闭",
        "ProjectTimelineClosedMessage": "这个项目不再接受支持或变更。",
        "ProjectTimelineCrowdfundingBackerMessage": "项目正在进行中。您是支持者 #{1}。您可以自由修改您的支持。{0}",
        "ProjectTimelineCrowdfundingBackerWithoutBackerNumberMessage": "项目正在进行中！您是支持者，可以自由修改您的支持。{0}",
        "ProjectTimelineCrowdfundingGuideLabel": "众筹指南",
        "ProjectTimelineCrowdfundingLabel": "众筹",
        "ProjectTimelineCrowdfundingNotBackerMessage": "项目正在进行中。您可以在项目结束前自由修改您的支持。{0}",
        "ProjectTimelineEstimatedEndText": "预计结束时间：{0}",
        "ProjectTimelineEstimatedStartText": "预计开始时间：{0}",
        "ProjectTimelineFailedBackerMessage": "这个项目未达成其筹款目标。您的支持金额不会扣款。{0}",
        "ProjectTimelineFailedLabel": "未达成目标",
        "ProjectTimelineFailedNotBackerMessage": "这个项目未达成其筹款目标。支持者的支持金额不会扣款。{0}",
        "ProjectTimelineFollowActionLabel": "关注以获取更新",
        "ProjectTimelineFulfillmentBackerMessage": "产品正在配送中。{0}",
        "ProjectTimelineFulfillmentLabel": "履行中",
        "ProjectTimelineFulfillmentNotBackerMessage": "产品正向支持者配送。{0}",
        "ProjectTimelineFundedLabel": "已筹款",
        "ProjectTimelineFundingMessage": "成功众筹后，Gamefound 正在收集资金。{0}",
        "ProjectTimelineGoToYourPledgeLink": "前往您的支持",
        "ProjectTimelineHeader": "项目时间线",
        "ProjectTimelineHelpLabel": "帮助",
        "ProjectTimelineLatePledgeBackerMessage": "您现在可以修改您的支持。稍后将询问配送信息。{0}",
        "ProjectTimelineLatePledgeEndedLabel": "后期支持结束",
        "ProjectTimelineLatePledgeEndedMessage": "这个项目目前不接受新的支持或变更。",
        "ProjectTimelineLatePledgeLabel": "后期支持",
        "ProjectTimelineLatePledgeNotBackerMessage": "此项目已筹款，现重新开放接受新的支持。{0}",
        "ProjectTimelineLearnMoreLabel": "了解更多",
        "ProjectTimelineNextStepLabel": "下一步",
        "ProjectTimelineNowLabel": "现在",
        "ProjectTimelinePledgeManagerLimitedLabel": "pledge manager - 限制",
        "ProjectTimelinePledgeManagerLimitedMessage": "这个pledge manager仅向特定用户开放。{0}",
        "ProjectTimelinePledgeManagerOpenBackerMessage": "此项目开放接收新订单并准备收集您的配送信息。{0}",
        "ProjectTimelinePledgeManagerOpenLabel": "pledge manager - 对所有人开放",
        "ProjectTimelinePledgeManagerOpenNotBackerMessage": "此项目开放接收新订单并准备收集配送信息。{0}",
        "ProjectTimelineProgressInfoMessage": "了解项目进展。在我们的 {0} 和 {1} 中了解更多关于众筹的信息。",
        "ProjectTimelineShippingRangeMessage": "配送时间范围：{0} 和 {1} 之间",
        "ProjectTimelineUpcomingLabel": "即将到来",
        "ProjectTimelineUpcomingMessage": "项目即将到来。分享您对发起人创意的看法。{0}",
        "SetContentSectionHeader": "这个产品包括",
        "StablePledgeSectionHeader": "Stable Pledge",
        "StablePledgeSectionText": "这个项目是 Stable Pledge 计划的一部分。如果项目结束后任何价格预估变化超过10%，发起人保证全额退款支持者。支持者在变更公告后14天内申请退款将获得100%退款。Gamefound将退还其佣金给发起人，发起人单独负责退款。<a href=\"{0}\" target=\"_blank\" rel=\"noopener noreferrer\">了解更多</a>。",
        "StoreAddToCartOptionsModalTitle": "将产品添加到您的订单",
        "StoreAddToCartSuccessModalTitle": "产品已添加到您的订单",
        "StoreCardButton": "查看商店",
        "StorePageNavbarLink": "产品",
        "StretchGoalsNextHeader": "即将解锁",
        "StretchGoalsUnlockedHeader": "已解锁",
        "StretchGoalsUnlockedSubHeader": "({0}/{1} 已解锁)",
        "StretchPayAvailableInfo": "您现在可以使用 StretchPay付款",
        "UnfollowProjectButton": "取消关注",
        "UnspentCreditsMessage": "您有 {0} 点未使用的积分。",
        "YourPledgeLabel": "您的支持"
    },
    "ProjectUpdates": {
        "DetailsGoBackActionLink": "返回更新列表",
        "EmptyStateEditorParagraph": "可以在项目设置中添加和管理更新。",
        "EmptyStateEditorParagraphButton": "添加更新",
        "EmptyStateEditorTitle": "你还没有任何更新",
        "EmptyStateParagraph": "请稍后再来。",
        "EmptyStateSearchParagraph": "尝试使用不同的搜索方式。",
        "EmptyStateSearchTitle": "没有匹配的更新。",
        "EmptyStateTitle": "没有可显示的更新。",
        "FiltersAllUpdatesLabel": "所有更新",
        "FiltersUserSpecificUpdatesLabel": "我的更新",
        "LastModified": "最后修改时间：{0}",
        "LikeAction": "点赞",
        "NextUpdateLink": "下一个更新",
        "OriginallyPublished": "最初发布：{0}",
        "PageHeader": "更新",
        "PollStatusActiveLabel": "进行中的投票",
        "PollStatusFinishedLabel": "已结束的投票",
        "PreviousUpdateLink": "上一个更新",
        "ProjectUpdatesDisabledCreatorMessage": "用户无法查看您的项目更新页面，因为该功能当前已禁用。请联系我们的邮箱 business@gamefound.com 以启用更新功能。",
        "ProjectUpdatesDisabledUserMessage": "创作者尚未启用更新部分。",
        "SearchFieldActionLink": "高级搜索",
        "SearchFieldDateFrom": "搜索自",
        "SearchFieldDateTo": "搜索至",
        "SearchFieldLabel": "搜索更新",
        "SearchFieldPlaceholder": "开始输入以搜索更新",
        "UpdateSequenceNumberLabel": "更新 #{0}",
        "UpdatesPageNavbarLink": "更新",
        "UpdateStatusDraftBadge": "草稿",
        "UpdateStatusDraftParagraph": "此更新对用户不可见。",
        "UpdateStatusScheduledBadge": "已计划"
    },
    "ResetPassword": {
        "LinkSentFollowInstructionParagraph": "<strong>请检查您的电子邮件，并按照我们消息中的说明进行操作。</strong>",
        "LinkSentHeader": "重置密码链接已发送",
        "LinkSentParagraph": "如果您的电子邮件匹配一个有效的Gamefound账户，我们会发送一条消息和一个重置密码页面的链接给您。",
        "NewPasswordFieldLabel": "新密码",
        "PasswordChangedHeader": "您的密码已更改。",
        "PasswordChangedParagraph": "您可以使用新密码在{0}登录。",
        "RedirectToLogInLink": "这里",
        "RepeatPasswordFieldLabel": "重复密码",
        "ResetPasswordEmailFieldLabel": "电子邮件",
        "ResetPasswordHeader": "重置密码",
        "ResetPasswordInvalidLinkInfo": "无法完成密码重置请求。链接无效或已过期。",
        "ResetPasswordInvalidNewPasswordErrorInfo": "新密码无效。",
        "ResetPasswordParagraph": "请输入您的电子邮件地址。我们将向您发送一个重置密码页面的链接。",
        "ResetPasswordSubmitButton": "重置密码",
        "ResetPasswordUnknownErrorInfo": "由于系统错误，无法激活账户。请再试一次。",
        "ResetPasswordValidLinkInfo": "请提供并确认您的新密码。"
    },
    "Rewards": {
        "RewardsNavbarLink": "奖励"
    },
    "Search": {
        "SearchFiltersGroupAgeLabel": "年龄",
        "SearchFiltersGroupCommunityLabel": "社区",
        "SearchFiltersGroupContributionLabel": "贡献",
        "SearchFiltersGroupCreatorLabel": "发起者",
        "SearchFiltersGroupPlayableLabel": "可玩项目",
        "SearchFiltersGroupPlaytimeLabel": "游戏时长",
        "SearchFiltersGroupSearchPhraseLabel": "搜索词",
        "SearchFiltersGroupStatusLabel": "状态",
        "SearchFiltersGroupTagLabel": "标签",
        "SearchFiltersHeader": "筛选",
        "SearchFiltersSortLabel": "排序：",
        "SearchProjectPlayerAgeSearchTypeSixteenLabel": "16+ 仅限",
        "SearchProjectPlayerCountSearchTypeFourAndMoreLabel": "4+ 玩家",
        "SearchProjectPlayerCountSearchTypeOneLabel": "1 玩家",
        "SearchProjectPlayerCountSearchTypeThreeLabel": "3 玩家",
        "SearchProjectPlayerCountSearchTypeTwoLabel": "2 玩家",
        "SearchProjectPlayTimeSearchTypeHalfHourLabel": "最多 30 分钟",
        "SearchProjectPlayTimeSearchTypeMoreThanTwoHoursLabel": "120+ 分钟",
        "SearchProjectPlayTimeSearchTypeOneHourLabel": "30-60 分钟",
        "SearchProjectPlayTimeSearchTypeTwoHoursLabel": "60-120 分钟",
        "SearchProjectProjectContributionTypeArchivedProjectsLabel": "已存档项目",
        "SearchProjectProjectContributionTypeBackerLabel": "支持的项目",
        "SearchProjectProjectContributionTypeFollowerLabel": "关注的项目",
        "SearchProjectProjectContributionTypeUnusedCreditsLabel": "未使用的积分",
        "SearchProjectProjectPhaseSearchTypeCrowdfundingLabel": "众筹中",
        "SearchProjectProjectPhaseSearchTypeLatePledgeLabel": "后期支持",
        "SearchProjectProjectPhaseSearchTypePreorderLabel": "预购",
        "SearchProjectProjectPhaseSearchTypeRecentlyFundedLabel": "已筹资",
        "SearchProjectProjectPhaseSearchTypeStoreLabel": "商店",
        "SearchProjectProjectPhaseSearchTypeUpcomingLabel": "即将上线",
        "SearchProjectsFiltersAgeLabel": "玩家年龄",
        "SearchProjectsFiltersBenefitLabel": "福利",
        "SearchProjectsFiltersBenefitStablePledgeLabel": "Stable pledge",
        "SearchProjectsFiltersBenefitStretchPayLabel": "Stretch Pay",
        "SearchProjectsFiltersCategoryLabel": "分类",
        "SearchProjectsFiltersCommunityLabel": "社区",
        "SearchProjectsFiltersContributionLabel": "贡献项目",
        "SearchProjectsFiltersCreatorLabel": "发起者",
        "SearchProjectsFiltersCreatorPlaceholder": "开始输入以查看发起者列表...",
        "SearchProjectsFiltersPlayableLabel": "可玩的",
        "SearchProjectsFiltersPlaytimeLabel": "游戏时长",
        "SearchProjectsFiltersSearchApplyButton": "应用",
        "SearchProjectsFiltersSearchClearButton": "清除所有",
        "SearchProjectsFiltersSearchPhraseLabel": "搜索词",
        "SearchProjectsFiltersSearchPhrasePlaceholder": "输入内容以搜索...",
        "SearchProjectsFiltersStatusLabel": "项目状态",
        "SearchProjectsFiltersTagLabel": "标签",
        "SearchProjectsFiltersTagPlaceholder": "选择标签...",
        "SearchProjectSortApplyButton": "应用",
        "SearchProjectSortCancelButton": "取消",
        "SearchProjectSortGroupLabel": "排序结果",
        "SearchProjectSortTitle": "排序",
        "SearchProjectsResultsEmptyStateParagraph": "你可以尝试不同的筛选条件来找到你想要的内容。",
        "SearchProjectsResultsEmptyStateParagraphButton": "更改过滤条件",
        "SearchProjectsResultsEmptyStateTitle": "暂无项目展示",
        "SearchProjectsResultsTitle": "项目",
        "SearchProjectUserCommunityTypeBackedByCommunityLabel": "由你的社群支持",
        "SearchProjectUserCommunityTypeFollowedByCommunityLabel": "由你的社区关注"
    },
    "Spotlight": {
        "CrowdfundingCampaign24HoursLeftNotificationText": "{0}",
        "CrowdfundingCampaign24HoursLeftNotificationTitle": "还有24小时",
        "CrowdfundingCampaignFundedNotificationText": "{0}",
        "CrowdfundingCampaignFundedNotificationTitle": "项目已筹资成功",
        "CrowdfundingCampaignStartedNotificationText": "{0}",
        "CrowdfundingCampaignStartedNotificationTitle": "项目开始",
        "CrowdfundingCampaignStartScheduledNotificationText": "{0} 已确定启动日期。",
        "CrowdfundingCampaignStartScheduledNotificationTitle": "启动日期",
        "CrowdfundingDraftPublishedNotificationText": "{0}",
        "CrowdfundingDraftPublishedNotificationTitle": "新项目",
        "ExternalLatePledgePublishedNotificationText": "{0}",
        "ExternalLatePledgePublishedNotificationTitle": "新 Late Pledge",
        "ExternalPledgeManagerPublishedNotificationText": "{0}",
        "ExternalPledgeManagerPublishedNotificationTitle": "新 Pledge Manager",
        "GamefoundBlogPostPublishedNotificationText": "{0}",
        "GamefoundBlogPostPublishedNotificationTitle": "新博客文章"
    },
    "SubscriptionManagement": {
        "AdfoundNotificationHeader": "Adfound",
        "CommentRepliesFieldDescription": "关于对您的评论的新回复的通知。",
        "CommentRepliesFieldLabel": "评论回复",
        "CommunityLifeFieldDescription": "关于您关注的个人资料、最新评论、新的关注者等的通知。",
        "CommunityLifeFieldLabel": "社区活动",
        "CouldNotSendFollowConfirmationMessageError": "无法发送关注确认消息。请再试一次。",
        "CreatorDigestFieldDescription": "关于您项目活动的定期通知。",
        "CreatorDigestFieldLabel": "创作者摘要",
        "CreatorNewProjectLaunchFieldDescription": "关于该创作者发起的新项目的通知。",
        "CreatorNewProjectLaunchFieldLabel": "新项目发布",
        "CreatorNotificationsSectionHeader": "创作者",
        "FeastFieldDescription": "更新即将到来的激动人心的活动。",
        "FeastFieldLabel": "Gamefound Feast",
        "GeneralProjectNotificationsFieldDescription": "关于该项目生命周期变更的通知，例如活动开始或结束。",
        "GeneralProjectNotificationsFieldLabel": "一般通知",
        "InvalidFollowConfirmationLinkHeader": "无效的关注确认链接",
        "InvalidFollowConfirmationLinkParagraph": "此确认链接已失效。它可能无效或已被使用。",
        "InvalidTopicBadRequestMessageText": "无效的通知主题。",
        "MissingCreatorIdBadRequestMessageText": "缺少创作者ID。",
        "MissingPreferenceBadRequestMessageText": "缺少偏好设置。",
        "MissingProjectIdBadRequestMessageText": "缺少项目ID。",
        "NewsletterFieldDescription": "Gamefound 上精心挑选的项目更新。我们不会向您发送垃圾邮件。",
        "NewsletterFieldLabel": "通讯",
        "NotificationOptionDefaultLabel": "默认",
        "NotificationPreferenceNoNotificationsDisplayName": "不接收通知",
        "NotificationPreferenceOnlyEmailDisplayName": "电子邮件",
        "NotificationPreferenceOnlyPushDisplayName": "推送通知",
        "PageHeader": "通讯偏好",
        "PageIntroParagraph": "选择通讯订阅和创作者或项目通知的选项。",
        "PageTitle": "通讯偏好",
        "PerformanceMarketingDailyReportFieldDescription": "关于您的Adfound活动的每日报告。",
        "PerformanceMarketingDailyReportFieldLabel": "每日性能报告",
        "PerformanceMarketingRecommendationFieldDescription": "有关Adfound营销表现的建议电子邮件。",
        "PerformanceMarketingRecommendationFieldLabel": "营销活动建议",
        "ProjectMilestonesFieldLabel": "一般通知",
        "ProjectMilestonesInputFieldDescription": "关于该项目生命周期变更的通知，例如活动开始或结束。您可以在下方为单个项目覆盖此设置。",
        "ProjectNotificationHeader": "项目通讯",
        "ProjectNotificationsSubsectionHeader": "项目",
        "ProjectUpdatesFieldLabel": "更新",
        "ProjectUpdatesInputFieldDescription": "关于创作者发布的更新的通知。您可以在下方为单个项目覆盖此设置。",
        "PushNotificationsDeviceTokenInvalidErrorMessage": "您的设备令牌有问题。",
        "SettingsSavedMessageText": "订阅设置已保存。",
        "SystemMessagesFieldDescription": "自动邮件，如确认、支持状态更新等。这些对履行您的支持和使用 Gamefound 至关重要。",
        "SystemMessagesFieldLabel": "系统消息",
        "SystemNotificationHeader": "平台通知",
        "UpdatesProjectNotificationsFieldDescription": "关于创作者发布的更新的通知。",
        "UpdatesProjectNotificationsFieldLabel": "更新",
        "UserDigestFrequencyDailyDisplayName": "每日",
        "UserDigestFrequencyEvery2DaysDisplayName": "每两天",
        "UserDigestFrequencyNeverDisplayName": "从不",
        "UserDigestFrequencyWeeklyDisplayName": "每周",
        "WebPushActivateLabel": "启用",
        "WebPushBlockedByBrowserParagraph": "浏览器设置当前阻止推送通知。请参阅我们的帮助中心以了解如何启用它们。",
        "WebPushEnableParagraph": "通过激活推送通知，随时了解 Gamefound 上的最新活动和更新。",
        "WebPushHideLabel": "隐藏此消息"
    },
    "TermsOfService": {
        "BackersTermsOfServiceLinkTitle": "Gamefound 支持者服务条款",
        "CommunityGuidelinesLinkTitle": "Gamefound 社区指南",
        "ContentPolicyLinkTitle": "Gamefound 内容政策",
        "CreatorsDataProcessingAgreementLinkTitle": "Gamefound 数据处理协议",
        "CreatorsDigitalTermsOfServiceLinkTitle": "Gamefound 创作者的数字内容服务条款",
        "CreatorsTermsOfServiceLinkTitle": "Gamefound 创作者服务条款",
        "CreatorsTermsOfServiceSectionTitle": "创作者",
        "CreatorTermsOfServiceForAdfoundLinkTitle": "Gamefound Adfound 服务条款",
        "CrowdfundingAndPMsSectionTitle": "众筹 & Pledge Managers",
        "GeneralTermsOfServiceLinkTitle": "Gamefound 服务条款",
        "IntellectualPropertyPolicyLinkTitle": "Gamefound 知识产权政策",
        "PageDescription": "Gamefound 为支持者和创作者提供各种服务。请参考以下服务区域列表以找到相应的监管文件。",
        "PageHeader": "服务条款",
        "PrivacyPolicyLinkTitle": "Gamefound 隐私政策",
        "ReservedFundsPolicyLinkTitle": "Gamefound 预留资金政策",
        "SiteUsageTermsSectionTitle": "网站使用",
        "StoresTermsOfServiceLinkTitle": "Gamefound 店铺服务条款",
        "StoresTermsOfServiceSectionTitle": "店铺",
        "TrademarkPolicyLinkTitle": "Gamefound 商标政策"
    },
    "Users": {
        "MissingEmailFromExternalProvider": "您用来登录 Gamefound 的账户没有电子邮件。没有电子邮件您无法登录。"
    },
    "YourPledge": {
        "AddItemsButton": "添加商品",
        "AddMoreButton": "添加更多商品",
        "BillingAddressHeader": "账单地址",
        "CancelOrderButton": "取消订单",
        "CancelOrderModalHeader": "取消您的订单",
        "CancelOrderModalParagraph": "您要取消该订单吗？",
        "CancelOrderSuccessToastMessage": "您的订单已被取消。",
        "CancelPaymentMethodChangeButton": "取消",
        "CancelPledgeButton": "取消支持",
        "CancelPledgeCFModalParagraph": "这将取消您的支持。您不会被收费。您要取消支持吗？",
        "CancelPledgeModalHeader": "取消您的支持",
        "CancelPledgeModalParagraph": "您要取消支持吗？",
        "CancelPledgeSuccessToastLabel": "成功",
        "CancelPledgeSuccessToastMessage": "您的支持已被取消。",
        "CardPaymentMethodName": "卡支付",
        "CartTableDetailsHeader": "详情",
        "CartTableItemDetailsHeader": "商品详情",
        "CartTableItemsAddedOnTitle": "商品添加于 {0}",
        "CartTableOrderItemHideSetItemsLabel": "隐藏 {0} ({1})",
        "CartTableOrderItemShowSetItemsLabel": "显示 {0} ({1})",
        "CartTableOrderItemTaxValueLabel": "{0} (税)",
        "CartTableOriginalOrderTitle": "原始订单",
        "CartTablePredefinedItemsTitle": "来自创作者的预定义商品",
        "CartTablePriceHeader": "价格",
        "CartTableQuantityHeader": "数量",
        "CartTableQuantityShortHeader": "数量",
        "CartTableSetContentLabel": "该产品包含：",
        "CartTableSubtotalRowLabel": "小计",
        "CartTableTotalPriceHeader": "总价格",
        "CartTableTotalWeightHeader": "总重量",
        "CartTableUnpaidItemsTitle": "未支付商品",
        "CartTableYourItemsTitle": "您的商品",
        "ChangePaymentMethodButton": "使用其他支付方式",
        "CheckoutButton": "结账",
        "CheckoutDisabledEmptyPledgeToast": "支持内容为空，无法继续。",
        "CheckoutDisabledInvalidCartToast": "您的支持需要进行一些额外操作。请在结账前检查您的支持。",
        "EditingPledgeLabel": "编辑支持",
        "EditingPledgeSuccessToast": "您现在正在编辑您的认筹。",
        "EditingPledgeSuccessToastDescription": "所有操作和更改将应用于此pledge：",
        "EditPledgeActionButtonLabel": "编辑",
        "EditPledgeButton": "编辑支持",
        "EditPledgeImportedItemsEditableInfoToast": "如果您希望升级支持或修改其内容，可以从支持中移除商品并添加您喜欢的商品。",
        "EditPledgeImportedItemsLockedInfoToast": "这些商品是预定义的，无法从支持中移除！",
        "EditPledgeImportedItemsPartiallyLockedInfoToast": "您可以从支持中移除创作者添加的一些商品 - 只能移除带有删除按钮（红色 X 圈）的商品。其他商品为必需品。",
        "EditPledgeLabel": "编辑支持",
        "EditPledgeWarningDescription": "如果继续，任何未保存的更改将会丢失。是否要继续并编辑此订单？",
        "EditPledgeWarningTitle": "你正在编辑另一个订单。",
        "EmptyOrderButton": "向订单添加商品",
        "EmptyOrderMessage": "您的订单为空。您可以在产品选项卡中购买商品。",
        "EmptyPledgeButton": "向支持中添加商品",
        "EmptyPledgeClosedProject": "您的支持为空。由于项目已关闭，您无法向支持中添加商品。",
        "EmptyPledgeFailedProject": "您的支持为空。由于该项目未达到目标，您无法向支持中添加商品。",
        "EmptyPledgeNoCredits": "您的支持为空。由于您没有可用的积分，您无法向支持中添加商品。",
        "EmptyPledgeProjectLaunch": "您的支持为空。项目启动后，您将能够向支持中添加商品。",
        "EmptyPledgeProjectTab": "您的支持为空。您可以在项目选项卡中向支持中添加商品。",
        "EmptyPledgeRemovedAllItems": "您已移除所有商品。",
        "EmptyPledgeTitle": "这里无内容",
        "HideStretchPayScheduleHeader": "隐藏 Stretch Pay 日程",
        "HumanizeDatePluralizedMinute": "分钟|分钟",
        "IncorrectQuantityErrorMessage": "所选数量不正确。",
        "InstallmentCollectionText": "您的支持的第一期付款将在活动成功结束后24小时内收取。",
        "InstallmentCountText": "您的支持将分成<span class=\"_fw-b\">{0}等额分期付款。</span>",
        "InstallmentPlanAmountLabel": "支付金额",
        "InstallmentPlanApproximateConversionLabel": "约",
        "InstallmentPlanApproximateConversionTooltip": "最终价格可能会根据银行汇率和兑换手续费而有所不同。",
        "InstallmentPlanNotFoundError": "未找到分期付款计划。",
        "InstallmentPlanPaymentDateLabel": "付款日期",
        "InstallmentPlanStatusLabel": "状态",
        "InstallmentPlanTotalPaidLabel": "已支付总额",
        "InstallmentPlanWithInsufficientPaymentDetailsButton": "更新付款信息",
        "InstallmentPlanWithInsufficientPaymentDetailsDescription": "您的认捐需要注意。请更新您的付款信息以确保分期计划顺利进行。",
        "InstallmentProgressAllPaid": "所有分期付款已支付",
        "InstallmentProgressCanceledTitle": "此分期付款计划已结束",
        "InstallmentProgressNextTitle": "下期付款",
        "InstallmentProgressOverdueDescription": "我们在尝试收取这期付款时遇到问题。请确保您的支付方式有效并有足够的资金，然后重试。",
        "InstallmentProgressOverdueTitle": "逾期付款",
        "InstallmentXOfYLabel": "第 {0} 期，共 {1} 期",
        "InsufficientPaymentProviderDetailsPayRemainingButtonTooltipLabel": "更新您的付款详细信息以完成此次付款。",
        "InsufficientPaymentProviderDetailsRetryButtonTooltipLabel": "更新您的付款信息以重试此付款。",
        "InvalidOrderItemOptions": "选项不正确。",
        "InvalidProductQuantityMessage": "数量无效。请移除此商品。",
        "InvalidProductSetValidationMessage": "此套装中的一个或多个商品有问题。",
        "InvalidSetItemActionRequired": "此套装中的一个或多个商品有问题。{0} 以解决。",
        "InvalidSetItemActionRequiredLink": "点击这里",
        "InvalidSetItemsMessage": "套装中的一个或多个商品需要操作。",
        "InvoicesLabel": "发票：",
        "LocationChangedSuccessToast": "运输国家已保存。",
        "LocationChangedWithShippingModelAndTaxesSuccessToast": "运输国家已保存。正确的税费和运费已添加到您的支持。",
        "LocationChangedWithShippingModelSuccessToast": "运输国家已保存。运费已添加到您的支持。",
        "LocationChangedWithTaxesSuccessToast": "运输国家已保存。正确的税费已添加到您的支持。",
        "ManageShippingButton": "管理运输",
        "ManageShippingWarningMessage": "您正在编辑另一个订单。如果继续，任何未保存的更改将会丢失。您是否要继续并管理此订单的运输？",
        "ManageShippingWarningTitle": "编辑不同的订单？",
        "NoInvoicesText": "此订单无发票。",
        "NoNewOrdersInfoToast": "该项目当前不接受更多支持。",
        "NotesLabel": "备注：",
        "OneProductCopyAllowedForUserMessage": "您只能订购一个该产品的副本。",
        "OneProductCopyLeftInStockMessage": "库存中只有一个商品。",
        "OrderIDHeader": "订单 ID：{0}",
        "OrderItemNotFoundErrorMessage": "未找到订单商品。",
        "OrderItemOptionsCannotBeChangedErrorMessage": "无法更改此订单商品的选项。",
        "OrderItemQuantityCannotBeChangedErrorMessage": "无法更改此订单商品的数量。",
        "OrderPaymentHistoryModalHeader": "订单 {0} 的支付历史",
        "OrderPaymentStatusLabel": "支付状态：",
        "OrderStageLabel": "阶段：",
        "OrderStageNextHintTitle": "下一步：",
        "OrderSummaryCreditDiscountLabel": "信用折扣：",
        "OrderSummaryHeader": "订单摘要",
        "OrderSummaryNetShippingCostLabel": "运费（净）：",
        "OrderSummaryNetSubtotalLabel": "小计（净）：",
        "OrderSummaryNetTotalDiscountsLabel": "总折扣（净）：",
        "OrderSummaryOverchargedLabel": "多收：",
        "OrderSummaryRefundedLabel": "已退款：",
        "OrderSummaryRemainingInstallmentsLabel": "剩余分期付款：",
        "OrderSummaryShippingCostLabel": "运费：",
        "OrderSummarySubtotalLabel": "小计：",
        "OrderSummaryTaxLabel": "税费：",
        "OrderSummaryTaxWithNameLabel": "税费（{0}）：",
        "OrderSummaryToPayLabel": "应付金额：",
        "OrderSummaryTotalDiscountsLabel": "总折扣：",
        "OrderSummaryTotalPaidLabel": "已支付总额：",
        "OrderSummaryTotalPledgedLabel": "总支持金额：",
        "OrderSummaryTotalVatDeductionLabel": "总 VAT 扣除：",
        "OtherOrdersLabel": "其他订单",
        "OtherPledgesLabel": "其他pledges",
        "PaymentHistoryActionButton": "支付历史",
        "PaymentHistoryModalEmptyStateText": "暂无支付记录。",
        "PaymentMethodInfoInstantPaymentText": "此支付方式用于结算您的付款。如果您想取消支持，请在活动结束前{0}以获得全额退款。",
        "PaymentMethodInfoInstantPaymentTextLink": "联系创作者",
        "PaymentMethodInfoSinglePaymentText": "此支付方式将在活动结束时用于结算您的付款。",
        "PaymentMethodInfoWithInstallmentsText": "此支付方式将用于结清您的分期付款。",
        "PaymentMethodSectionHeader": "支付方式",
        "PledgeDateSubheader": "日期：{0}",
        "PledgeIDHeader": "支持ID：{0}",
        "PledgeModifiedSuccessToast": "您的支持已修改。",
        "PledgePaymentHistoryModalHeader": "支持 {0} 的支付历史",
        "ProductCopiesAllowedForUserMessage": "您只能订购 {0} 份此产品。",
        "ProductCopiesLeftInStockMessage": "此产品库存仅剩 {0} 份。",
        "ProductCopiesPerUserLimitExceededMessage": "您不能再购买此产品的更多份数。",
        "ProductOutOfStockMessage": "此产品已无库存，不再供应。",
        "ProductQuantityExceededMessage": "您不能将这么多商品添加到您的支持中。",
        "ReCaptchaChangeDeferredPaymentVerificationFailedErrorMessage": "我们注意到一些异常活动。您无法保存更改。",
        "ReCaptchaInvalidTokenErrorMessage": "无效的reCaptcha令牌。",
        "ReCaptchaMissingTokenErrorMessage": "缺少reCaptcha令牌。",
        "RemainingInstallmentsAmountToPayLabel": "剩余金额",
        "RemainingInstallmentsBoxTitle": "Stretch Pay 进度",
        "RemainingInstallmentsModalHeader": "支付剩余金额",
        "RemainingInstallmentsModalText": "您即将全额支付所有分期款。",
        "RemainingInstallmentsPaymentConfirmationText": "您确认要支付剩余的 {0} 吗",
        "RemainingInstallmentsPayRemainingButton": "支付剩余 {0}",
        "RemainingInstallmentsProgressBarTitle": "已支付 {0} / {1} 期",
        "RemainingInstallmentsTotalPaidLabel": "已支付总金额",
        "ResumePaymentButton": "恢复付款",
        "RetryInstallmentButton": "重试支付",
        "RetryInstallmentSuccessToast": "分期付款已成功支付。",
        "RevertChangesButton": "撤销更改",
        "RevertChangesButtonLong": "恢复原始支持",
        "RevertChangesSuccessToast": "您已成功撤销对支持的更改。",
        "RevertOriginalActionButton": "恢复到原始",
        "SavePaymentMethodChangeButton": "保存",
        "SetShippingButton": "设置配送",
        "ShippingAddressHeader": "配送地址",
        "ShippingInfoLabel": "配送：",
        "ShippingInfoNotRequiredNotificationText": "此阶段未收集配送详情和费用。项目发起人稍后将要求您支付配送费用。",
        "ShippingInfoPartiallyCollectedNotificationText": "已收取部分配送费。您将在支持管理阶段被要求提供详细的配送地址。",
        "ShippingInfoRequiredNotificationText": "要接收您的奖励，您需要添加配送信息并选择配送方式。",
        "ShippingInfoText": "{0}（预计配送开始时间：{1}）",
        "ShippingSectionHeader": "配送",
        "ShowMoreButton": "查看更多",
        "StageHistoryActionButton": "阶段历史",
        "StageHistoryModalHeader": "订单 {0} 的历史阶段",
        "StretchPaySectionHeader": "Stretch Pay（分期付款）",
        "TooManyCopiesRemoveExcessMessage": "添加到支持中的商品数量过多。请删除多余的商品。",
        "UpdatePaymentMethodButton": "更新支付方式",
        "ViewStretchPayScheduleHeader": "查看 Stretch Pay 时间表",
        "YourCartPageTitle": "您的购物车",
        "YourOrderPageTitle": "您当前的订单",
        "YourOrdersNavbarLink": "您的订单",
        "YourPledgeAbortPaymentButton": "中止付款",
        "YourPledgeAbortPaymentConfirmationButton": "中止付款",
        "YourPledgeAbortPaymentDescription": "您的付款花费的时间比预期的要长（通常不超过 {0} 分钟）。您可以等待或中止付款。",
        "YourPledgeAbortPaymentModalDescription": "如果您确认，我们将停止处理您的付款。但是，在少数情况下，付款仍然可能会被收取。如果发生这种情况，您需要联系发起人以请求退款。",
        "YourPledgeAbortPaymentModalIssueWithPaymentDescription": "处理您的付款时出现问题。我们建议中止交易并重试。",
        "YourPledgeAbortPaymentModalTitle": "您确定要中止付款吗？",
        "YourPledgeAbortPaymentSuccessToast": "付款已成功中止。",
        "YourPledgeCartTableOriginalOrderSectionHeader": "原始订单",
        "YourPledgeCartTableUnsubmittedOrderSectionHeader": "未提交的 {0}",
        "YourPledgeEditOrderItemModalTitle": "编辑订单商品",
        "YourPledgeExtraChargeDescription": "您的订单增加了额外费用，导致未结余额。请查看详情并决定是支付欠款还是{0}。有关更多信息，请阅读发起人的说明：",
        "YourPledgeExtraChargeHideCreatorMessageLabel": "隐藏发起人的消息",
        "YourPledgeExtraChargeRequestRefundLabel": "讨论可能的退款",
        "YourPledgeExtraChargeShowCreatorMessageLabel": "显示发起人的消息",
        "YourPledgeInvalidValidationCallToActionMessage": "解决问题。",
        "YourPledgeInvalidValidationGenericMessage": "该商品目前在您的订单中引起问题。",
        "YourPledgeNavbarLink": "您的支持",
        "YourPledgePageTitle": "您当前的支持",
        "YourPledgePaymentHistoryLabel": "查看支付历史",
        "YourPledgePluralizedDayLabel": "天|天",
        "YourPledgePluralizedProductLabel": "产品|产品",
        "YourPledgeProcessingPaymentDescription": "您的付款正在处理中。对于选定的付款方式，这可能需要最多 {0} 天。{1}",
        "YourPledgeRecommendationTitle": "其他用户添加",
        "YourPledgeRemoveOrderItemConfirmationDescription": "您确定要移除此商品吗？",
        "YourPledgeRemoveOrderItemConfirmationTitle": "移除订单商品"
    }
};
    if (typeof window !== 'undefined' && !window.__RESOURCES__) {
        window.__RESOURCES__ = resources;
    }
    export default resources;
    export const rawResources = resources;
